module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "01b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("4625");
var aCallable = __webpack_require__("59ed");
var NATIVE_BIND = __webpack_require__("40d5");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "04f8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__("c6b6");
var toIndexedObject = __webpack_require__("fc6a");
var $getOwnPropertyNames = __webpack_require__("241c").f;
var arraySlice = __webpack_require__("4dae");

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) === 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var call = __webpack_require__("c65b");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var hasOwn = __webpack_require__("1a2d");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "079e":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VMenu");

/***/ }),

/***/ "07fa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toLength = __webpack_require__("50c4");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "0b42":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__("e8b5");
var isConstructor = __webpack_require__("68ee");
var isObject = __webpack_require__("861d");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ "0b43":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_SYMBOL = __webpack_require__("04f8");

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ "0cb2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),

/***/ "0d51":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "107c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ "129f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};


/***/ }),

/***/ "13d2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var DESCRIPTORS = __webpack_require__("83ab");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("5e77").CONFIGURABLE;
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw new $TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ "14e5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var iterate = __webpack_require__("2266");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("5eed");

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "1588":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var DOMTokenListPrototype = __webpack_require__("785a");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ "1626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $documentAll = __webpack_require__("8ea1");

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "19aa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isPrototypeOf = __webpack_require__("3a9b");

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};


/***/ }),

/***/ "1a2d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "1b42":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VForm");

/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1cdc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__("342f");

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "1d6a":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VSpeedDial");

/***/ }),

/***/ "1d76":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1d80":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isNullOrUndefined = __webpack_require__("7234");

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "2266":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var isArrayIteratorMethod = __webpack_require__("e95a");
var lengthOfArrayLike = __webpack_require__("07fa");
var isPrototypeOf = __webpack_require__("3a9b");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");
var iteratorClose = __webpack_require__("2a62");

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__("5926");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var defineBuiltIn = __webpack_require__("cb2d");
var defineGlobalProperty = __webpack_require__("6374");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");
var correctIsRegExpLogic = __webpack_require__("ab13");

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var defineBuiltInAccessor = __webpack_require__("edd0");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "2757":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VCombobox");

/***/ }),

/***/ "2a62":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var getMethod = __webpack_require__("dc4a");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "2ba4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__("40d5");

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "2ca0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("4625");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");
var IS_PURE = __webpack_require__("c430");

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});


/***/ }),

/***/ "2cf4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var apply = __webpack_require__("2ba4");
var bind = __webpack_require__("0366");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var fails = __webpack_require__("d039");
var html = __webpack_require__("1be4");
var arraySlice = __webpack_require__("f36a");
var createElement = __webpack_require__("cc12");
var validateArgumentsLength = __webpack_require__("d6d6");
var IS_IOS = __webpack_require__("1cdc");
var IS_NODE = __webpack_require__("605d");

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ "3511":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ "3529":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var iterate = __webpack_require__("2266");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("5eed");

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "354e":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VIcon");

/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__("f5df");
var getMethod = __webpack_require__("dc4a");
var isNullOrUndefined = __webpack_require__("7234");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "3699":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VDialog");

/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var toIndexedObject = __webpack_require__("fc6a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ "3a9b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "3b7c":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VTabs");

/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__("1626");

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ "3c6d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrmContactInformation_vue_vue_type_style_index_0_id_d621dd56_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1588");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrmContactInformation_vue_vue_type_style_index_0_id_d621dd56_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrmContactInformation_vue_vue_type_style_index_0_id_d621dd56_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {};


/***/ }),

/***/ "40d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var defineProperty = __webpack_require__("9bf2").f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44de":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};


/***/ }),

/***/ "4625":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classofRaw = __webpack_require__("c6b6");
var uncurryThis = __webpack_require__("e330");

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ "4738":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var NativePromiseConstructor = __webpack_require__("d256");
var isCallable = __webpack_require__("1626");
var isForced = __webpack_require__("94ca");
var inspectSource = __webpack_require__("8925");
var wellKnownSymbol = __webpack_require__("b622");
var IS_BROWSER = __webpack_require__("6069");
var IS_DENO = __webpack_require__("6c59");
var IS_PURE = __webpack_require__("c430");
var V8_VERSION = __webpack_require__("2d00");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");
var aConstructor = __webpack_require__("5087");
var isNullOrUndefined = __webpack_require__("7234");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ "485a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("c65b");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "4901":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VAlert");

/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4dae":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  var n = 0;
  for (; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "5087":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isConstructor = __webpack_require__("68ee");
var tryToString = __webpack_require__("0d51");

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__("5926");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var fails = __webpack_require__("d039");
var anObject = __webpack_require__("825a");
var isCallable = __webpack_require__("1626");
var isNullOrUndefined = __webpack_require__("7234");
var toIntegerOrInfinity = __webpack_require__("5926");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var getMethod = __webpack_require__("dc4a");
var getSubstitution = __webpack_require__("0cb2");
var regExpExec = __webpack_require__("14c3");
var wellKnownSymbol = __webpack_require__("b622");

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.33.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "577e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__("f5df");

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ "57b9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("c65b");
var getBuiltIn = __webpack_require__("d066");
var wellKnownSymbol = __webpack_require__("b622");
var defineBuiltIn = __webpack_require__("cb2d");

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ "5926":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var trunc = __webpack_require__("b42e");

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ "59ed":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__("1626");
var tryToString = __webpack_require__("0d51");

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isRegExp = __webpack_require__("44e7");

var $TypeError = TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5a47":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var NATIVE_SYMBOL = __webpack_require__("04f8");
var fails = __webpack_require__("d039");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var toObject = __webpack_require__("7b0b");

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5e77":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var hasOwn = __webpack_require__("1a2d");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "5e7e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var IS_NODE = __webpack_require__("605d");
var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var defineBuiltIn = __webpack_require__("cb2d");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var setSpecies = __webpack_require__("2626");
var aCallable = __webpack_require__("59ed");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var anInstance = __webpack_require__("19aa");
var speciesConstructor = __webpack_require__("4840");
var task = __webpack_require__("2cf4").set;
var microtask = __webpack_require__("b575");
var hostReportErrors = __webpack_require__("44de");
var perform = __webpack_require__("e667");
var Queue = __webpack_require__("01b4");
var InternalStateModule = __webpack_require__("69f3");
var NativePromiseConstructor = __webpack_require__("d256");
var PromiseConstructorDetection = __webpack_require__("4738");
var newPromiseCapabilityModule = __webpack_require__("f069");

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ "5eed":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NativePromiseConstructor = __webpack_require__("d256");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("4738").CONSTRUCTOR;

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ "5f3c":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VGrid");

/***/ }),

/***/ "605d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var classof = __webpack_require__("c6b6");

module.exports = classof(global.process) === 'process';


/***/ }),

/***/ "6069":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_DENO = __webpack_require__("6c59");
var IS_NODE = __webpack_require__("605d");

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';


/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var uncurryThis = __webpack_require__("e330");
var call = __webpack_require__("c65b");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "6146":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrmContactContentPanel_vue_vue_type_style_index_0_id_783c48c4_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1d76");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrmContactContentPanel_vue_vue_type_style_index_0_id_783c48c4_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrmContactContentPanel_vue_vue_type_style_index_0_id_783c48c4_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6374":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var toIntegerOrInfinity = __webpack_require__("5926");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var arraySpeciesConstructor = __webpack_require__("0b42");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "682b":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VRadioGroup");

/***/ }),

/***/ "6881":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VTextField");

/***/ }),

/***/ "68ee":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("f5df");
var getBuiltIn = __webpack_require__("d066");
var inspectSource = __webpack_require__("8925");

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__("cdce");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var hasOwn = __webpack_require__("1a2d");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6b1e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6b38":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VChip");

/***/ }),

/***/ "6c59":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ }),

/***/ "7149":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var NativePromiseConstructor = __webpack_require__("d256");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("4738").CONSTRUCTOR;
var promiseResolve = __webpack_require__("cdf9");

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ "7234":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ "7282":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "7839":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "785a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("cc12");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var requireObjectCoercible = __webpack_require__("1d80");

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c5c":
/***/ (function(module, exports, __webpack_require__) {

/**
 * marked v5.1.2 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */

(function (global, factory) {
   true ? factory(exports) :
  undefined;
})(this, (function (exports) { 'use strict';

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  var id = 0;
  function _classPrivateFieldLooseKey(name) {
    return "__private_" + id++ + "_" + name;
  }
  function _classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
      throw new TypeError("attempted to use private field on non-instance");
    }
    return receiver;
  }

  function getDefaults() {
    return {
      async: false,
      baseUrl: null,
      breaks: false,
      extensions: null,
      gfm: true,
      headerIds: true,
      headerPrefix: '',
      highlight: null,
      hooks: null,
      langPrefix: 'language-',
      mangle: true,
      pedantic: false,
      renderer: null,
      sanitize: false,
      sanitizer: null,
      silent: false,
      smartypants: false,
      tokenizer: null,
      walkTokens: null,
      xhtml: false
    };
  }
  exports.defaults = getDefaults();
  function changeDefaults(newDefaults) {
    exports.defaults = newDefaults;
  }

  /**
   * Helpers
   */
  var escapeTest = /[&<>"']/;
  var escapeReplace = new RegExp(escapeTest.source, 'g');
  var escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
  var escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
  var escapeReplacements = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };
  var getEscapeReplacement = function getEscapeReplacement(ch) {
    return escapeReplacements[ch];
  };
  function escape(html, encode) {
    if (encode) {
      if (escapeTest.test(html)) {
        return html.replace(escapeReplace, getEscapeReplacement);
      }
    } else {
      if (escapeTestNoEncode.test(html)) {
        return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
      }
    }
    return html;
  }
  var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;

  /**
   * @param {string} html
   */
  function unescape(html) {
    // explicitly match decimal, hex, and named HTML entities
    return html.replace(unescapeTest, function (_, n) {
      n = n.toLowerCase();
      if (n === 'colon') return ':';
      if (n.charAt(0) === '#') {
        return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
      }
      return '';
    });
  }
  var caret = /(^|[^\[])\^/g;

  /**
   * @param {string | RegExp} regex
   * @param {string} opt
   */
  function edit(regex, opt) {
    regex = typeof regex === 'string' ? regex : regex.source;
    opt = opt || '';
    var obj = {
      replace: function replace(name, val) {
        val = val.source || val;
        val = val.replace(caret, '$1');
        regex = regex.replace(name, val);
        return obj;
      },
      getRegex: function getRegex() {
        return new RegExp(regex, opt);
      }
    };
    return obj;
  }
  var nonWordAndColonTest = /[^\w:]/g;
  var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

  /**
   * @param {boolean} sanitize
   * @param {string} base
   * @param {string} href
   */
  function cleanUrl(sanitize, base, href) {
    if (sanitize) {
      var prot;
      try {
        prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, '').toLowerCase();
      } catch (e) {
        return null;
      }
      if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
        return null;
      }
    }
    if (base && !originIndependentUrl.test(href)) {
      href = resolveUrl(base, href);
    }
    try {
      href = encodeURI(href).replace(/%25/g, '%');
    } catch (e) {
      return null;
    }
    return href;
  }
  var baseUrls = {};
  var justDomain = /^[^:]+:\/*[^/]*$/;
  var protocol = /^([^:]+:)[\s\S]*$/;
  var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;

  /**
   * @param {string} base
   * @param {string} href
   */
  function resolveUrl(base, href) {
    if (!baseUrls[' ' + base]) {
      // we can ignore everything in base after the last slash of its path component,
      // but we might need to add _that_
      // https://tools.ietf.org/html/rfc3986#section-3
      if (justDomain.test(base)) {
        baseUrls[' ' + base] = base + '/';
      } else {
        baseUrls[' ' + base] = rtrim(base, '/', true);
      }
    }
    base = baseUrls[' ' + base];
    var relativeBase = base.indexOf(':') === -1;
    if (href.substring(0, 2) === '//') {
      if (relativeBase) {
        return href;
      }
      return base.replace(protocol, '$1') + href;
    } else if (href.charAt(0) === '/') {
      if (relativeBase) {
        return href;
      }
      return base.replace(domain, '$1') + href;
    } else {
      return base + href;
    }
  }
  var noopTest = {
    exec: function noopTest() {}
  };
  function splitCells(tableRow, count) {
    // ensure that every cell-delimiting pipe has a space
    // before it to distinguish it from an escaped pipe
    var row = tableRow.replace(/\|/g, function (match, offset, str) {
        var escaped = false,
          curr = offset;
        while (--curr >= 0 && str[curr] === '\\') escaped = !escaped;
        if (escaped) {
          // odd number of slashes means | is escaped
          // so we leave it alone
          return '|';
        } else {
          // add space before unescaped |
          return ' |';
        }
      }),
      cells = row.split(/ \|/);
    var i = 0;

    // First/last cell in a row cannot be empty if it has no leading/trailing pipe
    if (!cells[0].trim()) {
      cells.shift();
    }
    if (cells.length > 0 && !cells[cells.length - 1].trim()) {
      cells.pop();
    }
    if (cells.length > count) {
      cells.splice(count);
    } else {
      while (cells.length < count) cells.push('');
    }
    for (; i < cells.length; i++) {
      // leading or trailing whitespace is ignored per the gfm spec
      cells[i] = cells[i].trim().replace(/\\\|/g, '|');
    }
    return cells;
  }

  /**
   * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
   * /c*$/ is vulnerable to REDOS.
   *
   * @param {string} str
   * @param {string} c
   * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
   */
  function rtrim(str, c, invert) {
    var l = str.length;
    if (l === 0) {
      return '';
    }

    // Length of suffix matching the invert condition.
    var suffLen = 0;

    // Step left until we fail to match the invert condition.
    while (suffLen < l) {
      var currChar = str.charAt(l - suffLen - 1);
      if (currChar === c && !invert) {
        suffLen++;
      } else if (currChar !== c && invert) {
        suffLen++;
      } else {
        break;
      }
    }
    return str.slice(0, l - suffLen);
  }
  function findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) {
      return -1;
    }
    var l = str.length;
    var level = 0,
      i = 0;
    for (; i < l; i++) {
      if (str[i] === '\\') {
        i++;
      } else if (str[i] === b[0]) {
        level++;
      } else if (str[i] === b[1]) {
        level--;
        if (level < 0) {
          return i;
        }
      }
    }
    return -1;
  }
  function checkDeprecations(opt, callback) {
    if (!opt || opt.silent) {
      return;
    }
    if (callback) {
      console.warn('marked(): callback is deprecated since version 5.0.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/using_pro#async');
    }
    if (opt.sanitize || opt.sanitizer) {
      console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
    }
    if (opt.highlight || opt.langPrefix !== 'language-') {
      console.warn('marked(): highlight and langPrefix parameters are deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-highlight.');
    }
    if (opt.mangle) {
      console.warn('marked(): mangle parameter is enabled by default, but is deprecated since version 5.0.0, and will be removed in the future. To clear this warning, install https://www.npmjs.com/package/marked-mangle, or disable by setting `{mangle: false}`.');
    }
    if (opt.baseUrl) {
      console.warn('marked(): baseUrl parameter is deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-base-url.');
    }
    if (opt.smartypants) {
      console.warn('marked(): smartypants parameter is deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-smartypants.');
    }
    if (opt.xhtml) {
      console.warn('marked(): xhtml parameter is deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-xhtml.');
    }
    if (opt.headerIds || opt.headerPrefix) {
      console.warn('marked(): headerIds and headerPrefix parameters enabled by default, but are deprecated since version 5.0.0, and will be removed in the future. To clear this warning, install  https://www.npmjs.com/package/marked-gfm-heading-id, or disable by setting `{headerIds: false}`.');
    }
  }

  function outputLink(cap, link, raw, lexer) {
    var href = link.href;
    var title = link.title ? escape(link.title) : null;
    var text = cap[1].replace(/\\([\[\]])/g, '$1');
    if (cap[0].charAt(0) !== '!') {
      lexer.state.inLink = true;
      var token = {
        type: 'link',
        raw: raw,
        href: href,
        title: title,
        text: text,
        tokens: lexer.inlineTokens(text)
      };
      lexer.state.inLink = false;
      return token;
    }
    return {
      type: 'image',
      raw: raw,
      href: href,
      title: title,
      text: escape(text)
    };
  }
  function indentCodeCompensation(raw, text) {
    var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
    if (matchIndentToCode === null) {
      return text;
    }
    var indentToCode = matchIndentToCode[1];
    return text.split('\n').map(function (node) {
      var matchIndentInNode = node.match(/^\s+/);
      if (matchIndentInNode === null) {
        return node;
      }
      var indentInNode = matchIndentInNode[0];
      if (indentInNode.length >= indentToCode.length) {
        return node.slice(indentToCode.length);
      }
      return node;
    }).join('\n');
  }

  /**
   * Tokenizer
   */
  var Tokenizer = /*#__PURE__*/function () {
    function Tokenizer(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Tokenizer.prototype;
    _proto.space = function space(src) {
      var cap = this.rules.block.newline.exec(src);
      if (cap && cap[0].length > 0) {
        return {
          type: 'space',
          raw: cap[0]
        };
      }
    };
    _proto.code = function code(src) {
      var cap = this.rules.block.code.exec(src);
      if (cap) {
        var text = cap[0].replace(/^ {1,4}/gm, '');
        return {
          type: 'code',
          raw: cap[0],
          codeBlockStyle: 'indented',
          text: !this.options.pedantic ? rtrim(text, '\n') : text
        };
      }
    };
    _proto.fences = function fences(src) {
      var cap = this.rules.block.fences.exec(src);
      if (cap) {
        var raw = cap[0];
        var text = indentCodeCompensation(raw, cap[3] || '');
        return {
          type: 'code',
          raw: raw,
          lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, '$1') : cap[2],
          text: text
        };
      }
    };
    _proto.heading = function heading(src) {
      var cap = this.rules.block.heading.exec(src);
      if (cap) {
        var text = cap[2].trim();

        // remove trailing #s
        if (/#$/.test(text)) {
          var trimmed = rtrim(text, '#');
          if (this.options.pedantic) {
            text = trimmed.trim();
          } else if (!trimmed || / $/.test(trimmed)) {
            // CommonMark requires space before trailing #s
            text = trimmed.trim();
          }
        }
        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[1].length,
          text: text,
          tokens: this.lexer.inline(text)
        };
      }
    };
    _proto.hr = function hr(src) {
      var cap = this.rules.block.hr.exec(src);
      if (cap) {
        return {
          type: 'hr',
          raw: cap[0]
        };
      }
    };
    _proto.blockquote = function blockquote(src) {
      var cap = this.rules.block.blockquote.exec(src);
      if (cap) {
        var text = cap[0].replace(/^ *>[ \t]?/gm, '');
        var top = this.lexer.state.top;
        this.lexer.state.top = true;
        var tokens = this.lexer.blockTokens(text);
        this.lexer.state.top = top;
        return {
          type: 'blockquote',
          raw: cap[0],
          tokens: tokens,
          text: text
        };
      }
    };
    _proto.list = function list(src) {
      var cap = this.rules.block.list.exec(src);
      if (cap) {
        var raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
        var bull = cap[1].trim();
        var isordered = bull.length > 1;
        var list = {
          type: 'list',
          raw: '',
          ordered: isordered,
          start: isordered ? +bull.slice(0, -1) : '',
          loose: false,
          items: []
        };
        bull = isordered ? "\\d{1,9}\\" + bull.slice(-1) : "\\" + bull;
        if (this.options.pedantic) {
          bull = isordered ? bull : '[*+-]';
        }

        // Get next list item
        var itemRegex = new RegExp("^( {0,3}" + bull + ")((?:[\t ][^\\n]*)?(?:\\n|$))");

        // Check if current bullet point can start a new List Item
        while (src) {
          endEarly = false;
          if (!(cap = itemRegex.exec(src))) {
            break;
          }
          if (this.rules.block.hr.test(src)) {
            // End list if bullet was actually HR (possibly move into itemRegex?)
            break;
          }
          raw = cap[0];
          src = src.substring(raw.length);
          line = cap[2].split('\n', 1)[0].replace(/^\t+/, function (t) {
            return ' '.repeat(3 * t.length);
          });
          nextLine = src.split('\n', 1)[0];
          if (this.options.pedantic) {
            indent = 2;
            itemContents = line.trimLeft();
          } else {
            indent = cap[2].search(/[^ ]/); // Find first non-space char
            indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
            itemContents = line.slice(indent);
            indent += cap[1].length;
          }
          blankLine = false;
          if (!line && /^ *$/.test(nextLine)) {
            // Items begin with at most one blank line
            raw += nextLine + '\n';
            src = src.substring(nextLine.length + 1);
            endEarly = true;
          }
          if (!endEarly) {
            var nextBulletRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))");
            var hrRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)");
            var fencesBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:```|~~~)");
            var headingBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}#");

            // Check if following lines should be included in List Item
            while (src) {
              rawLine = src.split('\n', 1)[0];
              nextLine = rawLine;

              // Re-align to follow commonmark nesting rules
              if (this.options.pedantic) {
                nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
              }

              // End list item if found code fences
              if (fencesBeginRegex.test(nextLine)) {
                break;
              }

              // End list item if found start of new heading
              if (headingBeginRegex.test(nextLine)) {
                break;
              }

              // End list item if found start of new bullet
              if (nextBulletRegex.test(nextLine)) {
                break;
              }

              // Horizontal rule found
              if (hrRegex.test(src)) {
                break;
              }
              if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) {
                // Dedent if possible
                itemContents += '\n' + nextLine.slice(indent);
              } else {
                // not enough indentation
                if (blankLine) {
                  break;
                }

                // paragraph continuation unless last line was a different block level element
                if (line.search(/[^ ]/) >= 4) {
                  // indented code block
                  break;
                }
                if (fencesBeginRegex.test(line)) {
                  break;
                }
                if (headingBeginRegex.test(line)) {
                  break;
                }
                if (hrRegex.test(line)) {
                  break;
                }
                itemContents += '\n' + nextLine;
              }
              if (!blankLine && !nextLine.trim()) {
                // Check if current line is blank
                blankLine = true;
              }
              raw += rawLine + '\n';
              src = src.substring(rawLine.length + 1);
              line = nextLine.slice(indent);
            }
          }
          if (!list.loose) {
            // If the previous item ended with a blank line, the list is loose
            if (endsWithBlankLine) {
              list.loose = true;
            } else if (/\n *\n *$/.test(raw)) {
              endsWithBlankLine = true;
            }
          }

          // Check for task list items
          if (this.options.gfm) {
            istask = /^\[[ xX]\] /.exec(itemContents);
            if (istask) {
              ischecked = istask[0] !== '[ ] ';
              itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
            }
          }
          list.items.push({
            type: 'list_item',
            raw: raw,
            task: !!istask,
            checked: ischecked,
            loose: false,
            text: itemContents
          });
          list.raw += raw;
        }

        // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
        list.items[list.items.length - 1].raw = raw.trimRight();
        list.items[list.items.length - 1].text = itemContents.trimRight();
        list.raw = list.raw.trimRight();
        var l = list.items.length;

        // Item child tokens handled here at end because we needed to have the final item to trim it first
        for (i = 0; i < l; i++) {
          this.lexer.state.top = false;
          list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
          if (!list.loose) {
            // Check if list should be loose
            var spacers = list.items[i].tokens.filter(function (t) {
              return t.type === 'space';
            });
            var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function (t) {
              return /\n.*\n/.test(t.raw);
            });
            list.loose = hasMultipleLineBreaks;
          }
        }

        // Set all items to loose if list is loose
        if (list.loose) {
          for (i = 0; i < l; i++) {
            list.items[i].loose = true;
          }
        }
        return list;
      }
    };
    _proto.html = function html(src) {
      var cap = this.rules.block.html.exec(src);
      if (cap) {
        var token = {
          type: 'html',
          block: true,
          raw: cap[0],
          pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
          text: cap[0]
        };
        if (this.options.sanitize) {
          var text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
          token.type = 'paragraph';
          token.text = text;
          token.tokens = this.lexer.inline(text);
        }
        return token;
      }
    };
    _proto.def = function def(src) {
      var cap = this.rules.block.def.exec(src);
      if (cap) {
        var tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
        var href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline._escapes, '$1') : '';
        var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, '$1') : cap[3];
        return {
          type: 'def',
          tag: tag,
          raw: cap[0],
          href: href,
          title: title
        };
      }
    };
    _proto.table = function table(src) {
      var cap = this.rules.block.table.exec(src);
      if (cap) {
        var item = {
          type: 'table',
          header: splitCells(cap[1]).map(function (c) {
            return {
              text: c
            };
          }),
          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
          rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : []
        };
        if (item.header.length === item.align.length) {
          item.raw = cap[0];
          var l = item.align.length;
          var i, j, k, row;
          for (i = 0; i < l; i++) {
            if (/^ *-+: *$/.test(item.align[i])) {
              item.align[i] = 'right';
            } else if (/^ *:-+: *$/.test(item.align[i])) {
              item.align[i] = 'center';
            } else if (/^ *:-+ *$/.test(item.align[i])) {
              item.align[i] = 'left';
            } else {
              item.align[i] = null;
            }
          }
          l = item.rows.length;
          for (i = 0; i < l; i++) {
            item.rows[i] = splitCells(item.rows[i], item.header.length).map(function (c) {
              return {
                text: c
              };
            });
          }

          // parse child tokens inside headers and cells

          // header child tokens
          l = item.header.length;
          for (j = 0; j < l; j++) {
            item.header[j].tokens = this.lexer.inline(item.header[j].text);
          }

          // cell child tokens
          l = item.rows.length;
          for (j = 0; j < l; j++) {
            row = item.rows[j];
            for (k = 0; k < row.length; k++) {
              row[k].tokens = this.lexer.inline(row[k].text);
            }
          }
          return item;
        }
      }
    };
    _proto.lheading = function lheading(src) {
      var cap = this.rules.block.lheading.exec(src);
      if (cap) {
        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[2].charAt(0) === '=' ? 1 : 2,
          text: cap[1],
          tokens: this.lexer.inline(cap[1])
        };
      }
    };
    _proto.paragraph = function paragraph(src) {
      var cap = this.rules.block.paragraph.exec(src);
      if (cap) {
        var text = cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1];
        return {
          type: 'paragraph',
          raw: cap[0],
          text: text,
          tokens: this.lexer.inline(text)
        };
      }
    };
    _proto.text = function text(src) {
      var cap = this.rules.block.text.exec(src);
      if (cap) {
        return {
          type: 'text',
          raw: cap[0],
          text: cap[0],
          tokens: this.lexer.inline(cap[0])
        };
      }
    };
    _proto.escape = function escape$1(src) {
      var cap = this.rules.inline.escape.exec(src);
      if (cap) {
        return {
          type: 'escape',
          raw: cap[0],
          text: escape(cap[1])
        };
      }
    };
    _proto.tag = function tag(src) {
      var cap = this.rules.inline.tag.exec(src);
      if (cap) {
        if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
          this.lexer.state.inLink = true;
        } else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
          this.lexer.state.inLink = false;
        }
        if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.lexer.state.inRawBlock = true;
        } else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.lexer.state.inRawBlock = false;
        }
        return {
          type: this.options.sanitize ? 'text' : 'html',
          raw: cap[0],
          inLink: this.lexer.state.inLink,
          inRawBlock: this.lexer.state.inRawBlock,
          block: false,
          text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
        };
      }
    };
    _proto.link = function link(src) {
      var cap = this.rules.inline.link.exec(src);
      if (cap) {
        var trimmedUrl = cap[2].trim();
        if (!this.options.pedantic && /^</.test(trimmedUrl)) {
          // commonmark requires matching angle brackets
          if (!/>$/.test(trimmedUrl)) {
            return;
          }

          // ending angle bracket cannot be escaped
          var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
          if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
            return;
          }
        } else {
          // find closing parenthesis
          var lastParenIndex = findClosingBracket(cap[2], '()');
          if (lastParenIndex > -1) {
            var start = cap[0].indexOf('!') === 0 ? 5 : 4;
            var linkLen = start + cap[1].length + lastParenIndex;
            cap[2] = cap[2].substring(0, lastParenIndex);
            cap[0] = cap[0].substring(0, linkLen).trim();
            cap[3] = '';
          }
        }
        var href = cap[2];
        var title = '';
        if (this.options.pedantic) {
          // split pedantic href and title
          var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
          if (link) {
            href = link[1];
            title = link[3];
          }
        } else {
          title = cap[3] ? cap[3].slice(1, -1) : '';
        }
        href = href.trim();
        if (/^</.test(href)) {
          if (this.options.pedantic && !/>$/.test(trimmedUrl)) {
            // pedantic allows starting angle bracket without ending angle bracket
            href = href.slice(1);
          } else {
            href = href.slice(1, -1);
          }
        }
        return outputLink(cap, {
          href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
          title: title ? title.replace(this.rules.inline._escapes, '$1') : title
        }, cap[0], this.lexer);
      }
    };
    _proto.reflink = function reflink(src, links) {
      var cap;
      if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
        var link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
        link = links[link.toLowerCase()];
        if (!link) {
          var text = cap[0].charAt(0);
          return {
            type: 'text',
            raw: text,
            text: text
          };
        }
        return outputLink(cap, link, cap[0], this.lexer);
      }
    };
    _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
      if (prevChar === void 0) {
        prevChar = '';
      }
      var match = this.rules.inline.emStrong.lDelim.exec(src);
      if (!match) return;

      // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
      if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDF50-\uDF59\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEC0-\uDED3\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDCD0-\uDCEB\uDCF0-\uDCF9\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])/)) return;
      var nextChar = match[1] || match[2] || '';
      if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
        var lLength = match[0].length - 1;
        var rDelim,
          rLength,
          delimTotal = lLength,
          midDelimTotal = 0;
        var endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
        endReg.lastIndex = 0;

        // Clip maskedSrc to same section of string as src (move to lexer?)
        maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
        while ((match = endReg.exec(maskedSrc)) != null) {
          rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
          if (!rDelim) continue; // skip single * in __abc*abc__

          rLength = rDelim.length;
          if (match[3] || match[4]) {
            // found another Left Delim
            delimTotal += rLength;
            continue;
          } else if (match[5] || match[6]) {
            // either Left or Right Delim
            if (lLength % 3 && !((lLength + rLength) % 3)) {
              midDelimTotal += rLength;
              continue; // CommonMark Emphasis Rules 9-10
            }
          }

          delimTotal -= rLength;
          if (delimTotal > 0) continue; // Haven't found enough closing delimiters

          // Remove extra characters. *a*** -> *a*
          rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
          var raw = src.slice(0, lLength + match.index + rLength + 1);

          // Create `em` if smallest delimiter has odd char count. *a***
          if (Math.min(lLength, rLength) % 2) {
            var _text = raw.slice(1, -1);
            return {
              type: 'em',
              raw: raw,
              text: _text,
              tokens: this.lexer.inlineTokens(_text)
            };
          }

          // Create 'strong' if smallest delimiter has even char count. **a***
          var text = raw.slice(2, -2);
          return {
            type: 'strong',
            raw: raw,
            text: text,
            tokens: this.lexer.inlineTokens(text)
          };
        }
      }
    };
    _proto.codespan = function codespan(src) {
      var cap = this.rules.inline.code.exec(src);
      if (cap) {
        var text = cap[2].replace(/\n/g, ' ');
        var hasNonSpaceChars = /[^ ]/.test(text);
        var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
        if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
          text = text.substring(1, text.length - 1);
        }
        text = escape(text, true);
        return {
          type: 'codespan',
          raw: cap[0],
          text: text
        };
      }
    };
    _proto.br = function br(src) {
      var cap = this.rules.inline.br.exec(src);
      if (cap) {
        return {
          type: 'br',
          raw: cap[0]
        };
      }
    };
    _proto.del = function del(src) {
      var cap = this.rules.inline.del.exec(src);
      if (cap) {
        return {
          type: 'del',
          raw: cap[0],
          text: cap[2],
          tokens: this.lexer.inlineTokens(cap[2])
        };
      }
    };
    _proto.autolink = function autolink(src, mangle) {
      var cap = this.rules.inline.autolink.exec(src);
      if (cap) {
        var text, href;
        if (cap[2] === '@') {
          text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
          href = 'mailto:' + text;
        } else {
          text = escape(cap[1]);
          href = text;
        }
        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };
    _proto.url = function url(src, mangle) {
      var cap;
      if (cap = this.rules.inline.url.exec(src)) {
        var text, href;
        if (cap[2] === '@') {
          text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
          href = 'mailto:' + text;
        } else {
          // do extended autolink path validation
          var prevCapZero;
          do {
            prevCapZero = cap[0];
            cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
          } while (prevCapZero !== cap[0]);
          text = escape(cap[0]);
          if (cap[1] === 'www.') {
            href = 'http://' + cap[0];
          } else {
            href = cap[0];
          }
        }
        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };
    _proto.inlineText = function inlineText(src, smartypants) {
      var cap = this.rules.inline.text.exec(src);
      if (cap) {
        var text;
        if (this.lexer.state.inRawBlock) {
          text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
        } else {
          text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
        }
        return {
          type: 'text',
          raw: cap[0],
          text: text
        };
      }
    };
    return Tokenizer;
  }();

  /**
   * Block-Level Grammar
   */
  var block = {
    newline: /^(?: *(?:\n|$))+/,
    code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
    fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
    hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
    heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
    list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
    html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
    + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (6)
    + '|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) open tag
    + '|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) closing tag
    + ')',
    def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
    table: noopTest,
    lheading: /^((?:(?!^bull ).|\n(?!\n|bull ))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    // regex template, placeholders will be replaced according to different paragraph
    // interruption rules of commonmark and the original markdown spec:
    _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
    text: /^[^\n]+/
  };
  block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
  block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
  block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();
  block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
  block.listItemStart = edit(/^( *)(bull) */).replace('bull', block.bullet).getRegex();
  block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();
  block._tag = 'address|article|aside|base|basefont|blockquote|body|caption' + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption' + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe' + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option' + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr' + '|track|ul';
  block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
  block.html = edit(block.html, 'i').replace('comment', block._comment).replace('tag', block._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
  block.lheading = edit(block.lheading).replace(/bull/g, block.bullet) // lists can interrupt
  .getRegex();
  block.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
  block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();

  /**
   * Normal Block Grammar
   */

  block.normal = _extends({}, block);

  /**
   * GFM Block Grammar
   */

  block.gfm = _extends({}, block.normal, {
    table: '^ *([^\\n ].*\\|.*)\\n' // Header
    + ' {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?' // Align
    + '(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)' // Cells
  });

  block.gfm.table = edit(block.gfm.table).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // tables can be interrupted by type (6) html blocks
  .getRegex();
  block.gfm.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('table', block.gfm.table) // interrupt paragraphs with table
  .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
  /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */

  block.pedantic = _extends({}, block.normal, {
    html: edit('^ *(?:comment *(?:\\n|\\s*$)' + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))').replace('comment', block._comment).replace(/tag/g, '(?!(?:' + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub' + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)' + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b').getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: noopTest,
    // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: edit(block.normal._paragraph).replace('hr', block.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
  });

  /**
   * Inline-Level Grammar
   */
  var inline = {
    escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
    url: noopTest,
    tag: '^comment' + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>',
    // CDATA section
    link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
    reflink: /^!?\[(label)\]\[(ref)\]/,
    nolink: /^!?\[(ref)\](?:\[\])?/,
    reflinkSearch: 'reflink|nolink(?!\\()',
    emStrong: {
      lDelim: /^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/,
      //         (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
      //         | Skip orphan inside strong      | Consume to delim | (1) #***              | (2) a***#, a***                    | (3) #***a, ***a                  | (4) ***#                 | (5) #***#                         | (6) a***a
      rDelimAst: /^[^_*]*?__[^_*]*?\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\*)[punct](\*+)(?=[\s]|$)|[^punct\s](\*+)(?!\*)(?=[punct\s]|$)|(?!\*)[punct\s](\*+)(?=[^punct\s])|[\s](\*+)(?!\*)(?=[punct])|(?!\*)[punct](\*+)(?!\*)(?=[punct])|[^punct\s](\*+)(?=[^punct\s])/,
      rDelimUnd: /^[^_*]*?\*\*[^_*]*?_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\s]|$)|[^punct\s](_+)(?!_)(?=[punct\s]|$)|(?!_)[punct\s](_+)(?=[^punct\s])|[\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])/ // ^- Not allowed for _
    },

    code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
    br: /^( {2,}|\\)\n(?!\s*$)/,
    del: noopTest,
    text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
    punctuation: /^((?![*_])[\spunctuation])/
  };

  // list of unicode punctuation marks, plus any missing characters from CommonMark spec
  inline._punctuation = '\\p{P}$+<=>`^|~';
  inline.punctuation = edit(inline.punctuation, 'u').replace(/punctuation/g, inline._punctuation).getRegex();

  // sequences em should skip over [title](link), `code`, <html>
  inline.blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
  inline.anyPunctuation = /\\[punct]/g;
  inline._escapes = /\\([punct])/g;
  inline._comment = edit(block._comment).replace('(?:-->|$)', '-->').getRegex();
  inline.emStrong.lDelim = edit(inline.emStrong.lDelim, 'u').replace(/punct/g, inline._punctuation).getRegex();
  inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, 'gu').replace(/punct/g, inline._punctuation).getRegex();
  inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, 'gu').replace(/punct/g, inline._punctuation).getRegex();
  inline.anyPunctuation = edit(inline.anyPunctuation, 'gu').replace(/punct/g, inline._punctuation).getRegex();
  inline._escapes = edit(inline._escapes, 'gu').replace(/punct/g, inline._punctuation).getRegex();
  inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
  inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
  inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();
  inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
  inline.tag = edit(inline.tag).replace('comment', inline._comment).replace('attribute', inline._attribute).getRegex();
  inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
  inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
  inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
  inline.link = edit(inline.link).replace('label', inline._label).replace('href', inline._href).replace('title', inline._title).getRegex();
  inline.reflink = edit(inline.reflink).replace('label', inline._label).replace('ref', block._label).getRegex();
  inline.nolink = edit(inline.nolink).replace('ref', block._label).getRegex();
  inline.reflinkSearch = edit(inline.reflinkSearch, 'g').replace('reflink', inline.reflink).replace('nolink', inline.nolink).getRegex();

  /**
   * Normal Inline Grammar
   */

  inline.normal = _extends({}, inline);

  /**
   * Pedantic Inline Grammar
   */

  inline.pedantic = _extends({}, inline.normal, {
    strong: {
      start: /^__|\*\*/,
      middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
      endAst: /\*\*(?!\*)/g,
      endUnd: /__(?!_)/g
    },
    em: {
      start: /^_|\*/,
      middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
      endAst: /\*(?!\*)/g,
      endUnd: /_(?!_)/g
    },
    link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline._label).getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline._label).getRegex()
  });

  /**
   * GFM Inline Grammar
   */

  inline.gfm = _extends({}, inline.normal, {
    escape: edit(inline.escape).replace('])', '~|])').getRegex(),
    _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
    url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
  });
  inline.gfm.url = edit(inline.gfm.url, 'i').replace('email', inline.gfm._extended_email).getRegex();
  /**
   * GFM + Line Breaks Inline Grammar
   */

  inline.breaks = _extends({}, inline.gfm, {
    br: edit(inline.br).replace('{2,}', '*').getRegex(),
    text: edit(inline.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
  });

  /**
   * smartypants text replacement
   * @param {string} text
   */
  function smartypants(text) {
    return text
    // em-dashes
    .replace(/---/g, "\u2014")
    // en-dashes
    .replace(/--/g, "\u2013")
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018")
    // closing singles & apostrophes
    .replace(/'/g, "\u2019")
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C")
    // closing doubles
    .replace(/"/g, "\u201D")
    // ellipses
    .replace(/\.{3}/g, "\u2026");
  }

  /**
   * mangle email addresses
   * @param {string} text
   */
  function mangle(text) {
    var out = '',
      i,
      ch;
    var l = text.length;
    for (i = 0; i < l; i++) {
      ch = text.charCodeAt(i);
      if (Math.random() > 0.5) {
        ch = 'x' + ch.toString(16);
      }
      out += '&#' + ch + ';';
    }
    return out;
  }

  /**
   * Block Lexer
   */
  var Lexer = /*#__PURE__*/function () {
    function Lexer(options) {
      this.tokens = [];
      this.tokens.links = Object.create(null);
      this.options = options || exports.defaults;
      this.options.tokenizer = this.options.tokenizer || new Tokenizer();
      this.tokenizer = this.options.tokenizer;
      this.tokenizer.options = this.options;
      this.tokenizer.lexer = this;
      this.inlineQueue = [];
      this.state = {
        inLink: false,
        inRawBlock: false,
        top: true
      };
      var rules = {
        block: block.normal,
        inline: inline.normal
      };
      if (this.options.pedantic) {
        rules.block = block.pedantic;
        rules.inline = inline.pedantic;
      } else if (this.options.gfm) {
        rules.block = block.gfm;
        if (this.options.breaks) {
          rules.inline = inline.breaks;
        } else {
          rules.inline = inline.gfm;
        }
      }
      this.tokenizer.rules = rules;
    }

    /**
     * Expose Rules
     */
    /**
     * Static Lex Method
     */
    Lexer.lex = function lex(src, options) {
      var lexer = new Lexer(options);
      return lexer.lex(src);
    }

    /**
     * Static Lex Inline Method
     */;
    Lexer.lexInline = function lexInline(src, options) {
      var lexer = new Lexer(options);
      return lexer.inlineTokens(src);
    }

    /**
     * Preprocessing
     */;
    var _proto = Lexer.prototype;
    _proto.lex = function lex(src) {
      src = src.replace(/\r\n|\r/g, '\n');
      this.blockTokens(src, this.tokens);
      var next;
      while (next = this.inlineQueue.shift()) {
        this.inlineTokens(next.src, next.tokens);
      }
      return this.tokens;
    }

    /**
     * Lexing
     */;
    _proto.blockTokens = function blockTokens(src, tokens) {
      var _this = this;
      if (tokens === void 0) {
        tokens = [];
      }
      if (this.options.pedantic) {
        src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
      } else {
        src = src.replace(/^( *)(\t+)/gm, function (_, leading, tabs) {
          return leading + '    '.repeat(tabs.length);
        });
      }
      var token, lastToken, cutSrc, lastParagraphClipped;
      var _loop = function _loop() {
        if (_this.options.extensions && _this.options.extensions.block && _this.options.extensions.block.some(function (extTokenizer) {
          if (token = extTokenizer.call({
            lexer: _this
          }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
          return "continue";
        }

        // newline
        if (token = _this.tokenizer.space(src)) {
          src = src.substring(token.raw.length);
          if (token.raw.length === 1 && tokens.length > 0) {
            // if there's a single \n as a spacer, it's terminating the last line,
            // so move it there so that we don't get unecessary paragraph tags
            tokens[tokens.length - 1].raw += '\n';
          } else {
            tokens.push(token);
          }
          return "continue";
        }

        // code
        if (token = _this.tokenizer.code(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          // An indented code block cannot interrupt a paragraph.
          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            _this.inlineQueue[_this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          return "continue";
        }

        // fences
        if (token = _this.tokenizer.fences(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // heading
        if (token = _this.tokenizer.heading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // hr
        if (token = _this.tokenizer.hr(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // blockquote
        if (token = _this.tokenizer.blockquote(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // list
        if (token = _this.tokenizer.list(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // html
        if (token = _this.tokenizer.html(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // def
        if (token = _this.tokenizer.def(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.raw;
            _this.inlineQueue[_this.inlineQueue.length - 1].src = lastToken.text;
          } else if (!_this.tokens.links[token.tag]) {
            _this.tokens.links[token.tag] = {
              href: token.href,
              title: token.title
            };
          }
          return "continue";
        }

        // table (gfm)
        if (token = _this.tokenizer.table(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // lheading
        if (token = _this.tokenizer.lheading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // top-level paragraph
        // prevent paragraph consuming extensions by clipping 'src' to extension start
        cutSrc = src;
        if (_this.options.extensions && _this.options.extensions.startBlock) {
          var startIndex = Infinity;
          var tempSrc = src.slice(1);
          var tempStart;
          _this.options.extensions.startBlock.forEach(function (getStartIndex) {
            tempStart = getStartIndex.call({
              lexer: this
            }, tempSrc);
            if (typeof tempStart === 'number' && tempStart >= 0) {
              startIndex = Math.min(startIndex, tempStart);
            }
          });
          if (startIndex < Infinity && startIndex >= 0) {
            cutSrc = src.substring(0, startIndex + 1);
          }
        }
        if (_this.state.top && (token = _this.tokenizer.paragraph(cutSrc))) {
          lastToken = tokens[tokens.length - 1];
          if (lastParagraphClipped && lastToken.type === 'paragraph') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            _this.inlineQueue.pop();
            _this.inlineQueue[_this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          lastParagraphClipped = cutSrc.length !== src.length;
          src = src.substring(token.raw.length);
          return "continue";
        }

        // text
        if (token = _this.tokenizer.text(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            _this.inlineQueue.pop();
            _this.inlineQueue[_this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          return "continue";
        }
        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
          if (_this.options.silent) {
            console.error(errMsg);
            return "break";
          } else {
            throw new Error(errMsg);
          }
        }
      };
      while (src) {
        var _ret = _loop();
        if (_ret === "continue") continue;
        if (_ret === "break") break;
      }
      this.state.top = true;
      return tokens;
    };
    _proto.inline = function inline(src, tokens) {
      if (tokens === void 0) {
        tokens = [];
      }
      this.inlineQueue.push({
        src: src,
        tokens: tokens
      });
      return tokens;
    }

    /**
     * Lexing/Compiling
     */;
    _proto.inlineTokens = function inlineTokens(src, tokens) {
      var _this2 = this;
      if (tokens === void 0) {
        tokens = [];
      }
      var token, lastToken, cutSrc;

      // String with links masked to avoid interference with em and strong
      var maskedSrc = src;
      var match;
      var keepPrevChar, prevChar;

      // Mask out reflinks
      if (this.tokens.links) {
        var links = Object.keys(this.tokens.links);
        if (links.length > 0) {
          while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
            if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
              maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
          }
        }
      }
      // Mask out other blocks
      while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
      }

      // Mask out escaped characters
      while ((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
      }
      var _loop2 = function _loop2() {
        if (!keepPrevChar) {
          prevChar = '';
        }
        keepPrevChar = false;

        // extensions
        if (_this2.options.extensions && _this2.options.extensions.inline && _this2.options.extensions.inline.some(function (extTokenizer) {
          if (token = extTokenizer.call({
            lexer: _this2
          }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
          return "continue";
        }

        // escape
        if (token = _this2.tokenizer.escape(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // tag
        if (token = _this2.tokenizer.tag(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          return "continue";
        }

        // link
        if (token = _this2.tokenizer.link(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // reflink, nolink
        if (token = _this2.tokenizer.reflink(src, _this2.tokens.links)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          return "continue";
        }

        // em & strong
        if (token = _this2.tokenizer.emStrong(src, maskedSrc, prevChar)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // code
        if (token = _this2.tokenizer.codespan(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // br
        if (token = _this2.tokenizer.br(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // del (gfm)
        if (token = _this2.tokenizer.del(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // autolink
        if (token = _this2.tokenizer.autolink(src, mangle)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // url (gfm)
        if (!_this2.state.inLink && (token = _this2.tokenizer.url(src, mangle))) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // text
        // prevent inlineText consuming extensions by clipping 'src' to extension start
        cutSrc = src;
        if (_this2.options.extensions && _this2.options.extensions.startInline) {
          var startIndex = Infinity;
          var tempSrc = src.slice(1);
          var tempStart;
          _this2.options.extensions.startInline.forEach(function (getStartIndex) {
            tempStart = getStartIndex.call({
              lexer: this
            }, tempSrc);
            if (typeof tempStart === 'number' && tempStart >= 0) {
              startIndex = Math.min(startIndex, tempStart);
            }
          });
          if (startIndex < Infinity && startIndex >= 0) {
            cutSrc = src.substring(0, startIndex + 1);
          }
        }
        if (token = _this2.tokenizer.inlineText(cutSrc, smartypants)) {
          src = src.substring(token.raw.length);
          if (token.raw.slice(-1) !== '_') {
            // Track prevChar before string of ____ started
            prevChar = token.raw.slice(-1);
          }
          keepPrevChar = true;
          lastToken = tokens[tokens.length - 1];
          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          return "continue";
        }
        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
          if (_this2.options.silent) {
            console.error(errMsg);
            return "break";
          } else {
            throw new Error(errMsg);
          }
        }
      };
      while (src) {
        var _ret2 = _loop2();
        if (_ret2 === "continue") continue;
        if (_ret2 === "break") break;
      }
      return tokens;
    };
    _createClass(Lexer, null, [{
      key: "rules",
      get: function get() {
        return {
          block: block,
          inline: inline
        };
      }
    }]);
    return Lexer;
  }();

  /**
   * Renderer
   */
  var Renderer = /*#__PURE__*/function () {
    function Renderer(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Renderer.prototype;
    _proto.code = function code(_code, infostring, escaped) {
      var lang = (infostring || '').match(/\S*/)[0];
      if (this.options.highlight) {
        var out = this.options.highlight(_code, lang);
        if (out != null && out !== _code) {
          escaped = true;
          _code = out;
        }
      }
      _code = _code.replace(/\n$/, '') + '\n';
      if (!lang) {
        return '<pre><code>' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
      }
      return '<pre><code class="' + this.options.langPrefix + escape(lang) + '">' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
    }

    /**
     * @param {string} quote
     */;
    _proto.blockquote = function blockquote(quote) {
      return "<blockquote>\n" + quote + "</blockquote>\n";
    };
    _proto.html = function html(_html, block) {
      return _html;
    }

    /**
     * @param {string} text
     * @param {string} level
     * @param {string} raw
     * @param {any} slugger
     */;
    _proto.heading = function heading(text, level, raw, slugger) {
      if (this.options.headerIds) {
        var id = this.options.headerPrefix + slugger.slug(raw);
        return "<h" + level + " id=\"" + id + "\">" + text + "</h" + level + ">\n";
      }

      // ignore IDs
      return "<h" + level + ">" + text + "</h" + level + ">\n";
    };
    _proto.hr = function hr() {
      return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
    };
    _proto.list = function list(body, ordered, start) {
      var type = ordered ? 'ol' : 'ul',
        startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
      return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
    }

    /**
     * @param {string} text
     */;
    _proto.listitem = function listitem(text) {
      return "<li>" + text + "</li>\n";
    };
    _proto.checkbox = function checkbox(checked) {
      return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
    }

    /**
     * @param {string} text
     */;
    _proto.paragraph = function paragraph(text) {
      return "<p>" + text + "</p>\n";
    }

    /**
     * @param {string} header
     * @param {string} body
     */;
    _proto.table = function table(header, body) {
      if (body) body = "<tbody>" + body + "</tbody>";
      return '<table>\n' + '<thead>\n' + header + '</thead>\n' + body + '</table>\n';
    }

    /**
     * @param {string} content
     */;
    _proto.tablerow = function tablerow(content) {
      return "<tr>\n" + content + "</tr>\n";
    };
    _proto.tablecell = function tablecell(content, flags) {
      var type = flags.header ? 'th' : 'td';
      var tag = flags.align ? "<" + type + " align=\"" + flags.align + "\">" : "<" + type + ">";
      return tag + content + ("</" + type + ">\n");
    }

    /**
     * span level renderer
     * @param {string} text
     */;
    _proto.strong = function strong(text) {
      return "<strong>" + text + "</strong>";
    }

    /**
     * @param {string} text
     */;
    _proto.em = function em(text) {
      return "<em>" + text + "</em>";
    }

    /**
     * @param {string} text
     */;
    _proto.codespan = function codespan(text) {
      return "<code>" + text + "</code>";
    };
    _proto.br = function br() {
      return this.options.xhtml ? '<br/>' : '<br>';
    }

    /**
     * @param {string} text
     */;
    _proto.del = function del(text) {
      return "<del>" + text + "</del>";
    }

    /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */;
    _proto.link = function link(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
      if (href === null) {
        return text;
      }
      var out = '<a href="' + href + '"';
      if (title) {
        out += ' title="' + title + '"';
      }
      out += '>' + text + '</a>';
      return out;
    }

    /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */;
    _proto.image = function image(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
      if (href === null) {
        return text;
      }
      var out = "<img src=\"" + href + "\" alt=\"" + text + "\"";
      if (title) {
        out += " title=\"" + title + "\"";
      }
      out += this.options.xhtml ? '/>' : '>';
      return out;
    };
    _proto.text = function text(_text) {
      return _text;
    };
    return Renderer;
  }();

  /**
   * TextRenderer
   * returns only the textual part of the token
   */
  var TextRenderer = /*#__PURE__*/function () {
    function TextRenderer() {}
    var _proto = TextRenderer.prototype;
    // no need for block level renderers
    _proto.strong = function strong(text) {
      return text;
    };
    _proto.em = function em(text) {
      return text;
    };
    _proto.codespan = function codespan(text) {
      return text;
    };
    _proto.del = function del(text) {
      return text;
    };
    _proto.html = function html(text) {
      return text;
    };
    _proto.text = function text(_text) {
      return _text;
    };
    _proto.link = function link(href, title, text) {
      return '' + text;
    };
    _proto.image = function image(href, title, text) {
      return '' + text;
    };
    _proto.br = function br() {
      return '';
    };
    return TextRenderer;
  }();

  /**
   * Slugger generates header id
   */
  var Slugger = /*#__PURE__*/function () {
    function Slugger() {
      this.seen = {};
    }

    /**
     * @param {string} value
     */
    var _proto = Slugger.prototype;
    _proto.serialize = function serialize(value) {
      return value.toLowerCase().trim()
      // remove html tags
      .replace(/<[!\/a-z].*?>/ig, '')
      // remove unwanted chars
      .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');
    }

    /**
     * Finds the next safe (unique) slug to use
     * @param {string} originalSlug
     * @param {boolean} isDryRun
     */;
    _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
      var slug = originalSlug;
      var occurenceAccumulator = 0;
      if (this.seen.hasOwnProperty(slug)) {
        occurenceAccumulator = this.seen[originalSlug];
        do {
          occurenceAccumulator++;
          slug = originalSlug + '-' + occurenceAccumulator;
        } while (this.seen.hasOwnProperty(slug));
      }
      if (!isDryRun) {
        this.seen[originalSlug] = occurenceAccumulator;
        this.seen[slug] = 0;
      }
      return slug;
    }

    /**
     * Convert string to unique id
     * @param {object} [options]
     * @param {boolean} [options.dryrun] Generates the next unique slug without
     * updating the internal accumulator.
     */;
    _proto.slug = function slug(value, options) {
      if (options === void 0) {
        options = {};
      }
      var slug = this.serialize(value);
      return this.getNextSafeSlug(slug, options.dryrun);
    };
    return Slugger;
  }();

  /**
   * Parsing & Compiling
   */
  var Parser = /*#__PURE__*/function () {
    function Parser(options) {
      this.options = options || exports.defaults;
      this.options.renderer = this.options.renderer || new Renderer();
      this.renderer = this.options.renderer;
      this.renderer.options = this.options;
      this.textRenderer = new TextRenderer();
      this.slugger = new Slugger();
    }

    /**
     * Static Parse Method
     */
    Parser.parse = function parse(tokens, options) {
      var parser = new Parser(options);
      return parser.parse(tokens);
    }

    /**
     * Static Parse Inline Method
     */;
    Parser.parseInline = function parseInline(tokens, options) {
      var parser = new Parser(options);
      return parser.parseInline(tokens);
    }

    /**
     * Parse Loop
     */;
    var _proto = Parser.prototype;
    _proto.parse = function parse(tokens, top) {
      if (top === void 0) {
        top = true;
      }
      var out = '',
        i,
        j,
        k,
        l2,
        l3,
        row,
        cell,
        header,
        body,
        token,
        ordered,
        start,
        loose,
        itemBody,
        item,
        checked,
        task,
        checkbox,
        ret;
      var l = tokens.length;
      for (i = 0; i < l; i++) {
        token = tokens[i];

        // Run any renderer extensions
        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call({
            parser: this
          }, token);
          if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }
        switch (token.type) {
          case 'space':
            {
              continue;
            }
          case 'hr':
            {
              out += this.renderer.hr();
              continue;
            }
          case 'heading':
            {
              out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
              continue;
            }
          case 'code':
            {
              out += this.renderer.code(token.text, token.lang, token.escaped);
              continue;
            }
          case 'table':
            {
              header = '';

              // header
              cell = '';
              l2 = token.header.length;
              for (j = 0; j < l2; j++) {
                cell += this.renderer.tablecell(this.parseInline(token.header[j].tokens), {
                  header: true,
                  align: token.align[j]
                });
              }
              header += this.renderer.tablerow(cell);
              body = '';
              l2 = token.rows.length;
              for (j = 0; j < l2; j++) {
                row = token.rows[j];
                cell = '';
                l3 = row.length;
                for (k = 0; k < l3; k++) {
                  cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                    header: false,
                    align: token.align[k]
                  });
                }
                body += this.renderer.tablerow(cell);
              }
              out += this.renderer.table(header, body);
              continue;
            }
          case 'blockquote':
            {
              body = this.parse(token.tokens);
              out += this.renderer.blockquote(body);
              continue;
            }
          case 'list':
            {
              ordered = token.ordered;
              start = token.start;
              loose = token.loose;
              l2 = token.items.length;
              body = '';
              for (j = 0; j < l2; j++) {
                item = token.items[j];
                checked = item.checked;
                task = item.task;
                itemBody = '';
                if (item.task) {
                  checkbox = this.renderer.checkbox(checked);
                  if (loose) {
                    if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                      item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                      if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                        item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                      }
                    } else {
                      item.tokens.unshift({
                        type: 'text',
                        text: checkbox
                      });
                    }
                  } else {
                    itemBody += checkbox;
                  }
                }
                itemBody += this.parse(item.tokens, loose);
                body += this.renderer.listitem(itemBody, task, checked);
              }
              out += this.renderer.list(body, ordered, start);
              continue;
            }
          case 'html':
            {
              out += this.renderer.html(token.text, token.block);
              continue;
            }
          case 'paragraph':
            {
              out += this.renderer.paragraph(this.parseInline(token.tokens));
              continue;
            }
          case 'text':
            {
              body = token.tokens ? this.parseInline(token.tokens) : token.text;
              while (i + 1 < l && tokens[i + 1].type === 'text') {
                token = tokens[++i];
                body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
              }
              out += top ? this.renderer.paragraph(body) : body;
              continue;
            }
          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }
      return out;
    }

    /**
     * Parse Inline Tokens
     */;
    _proto.parseInline = function parseInline(tokens, renderer) {
      renderer = renderer || this.renderer;
      var out = '',
        i,
        token,
        ret;
      var l = tokens.length;
      for (i = 0; i < l; i++) {
        token = tokens[i];

        // Run any renderer extensions
        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call({
            parser: this
          }, token);
          if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }
        switch (token.type) {
          case 'escape':
            {
              out += renderer.text(token.text);
              break;
            }
          case 'html':
            {
              out += renderer.html(token.text);
              break;
            }
          case 'link':
            {
              out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
              break;
            }
          case 'image':
            {
              out += renderer.image(token.href, token.title, token.text);
              break;
            }
          case 'strong':
            {
              out += renderer.strong(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'em':
            {
              out += renderer.em(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'codespan':
            {
              out += renderer.codespan(token.text);
              break;
            }
          case 'br':
            {
              out += renderer.br();
              break;
            }
          case 'del':
            {
              out += renderer.del(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'text':
            {
              out += renderer.text(token.text);
              break;
            }
          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }
      return out;
    };
    return Parser;
  }();

  var Hooks = /*#__PURE__*/function () {
    function Hooks(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Hooks.prototype;
    /**
     * Process markdown before marked
     */
    _proto.preprocess = function preprocess(markdown) {
      return markdown;
    }

    /**
     * Process HTML after marked is finished
     */;
    _proto.postprocess = function postprocess(html) {
      return html;
    };
    return Hooks;
  }();
  Hooks.passThroughHooks = new Set(['preprocess', 'postprocess']);

  var _parseMarkdown = /*#__PURE__*/_classPrivateFieldLooseKey("parseMarkdown");
  var _onError = /*#__PURE__*/_classPrivateFieldLooseKey("onError");
  var Marked = /*#__PURE__*/function () {
    function Marked() {
      Object.defineProperty(this, _onError, {
        value: _onError2
      });
      Object.defineProperty(this, _parseMarkdown, {
        value: _parseMarkdown2
      });
      this.defaults = getDefaults();
      this.options = this.setOptions;
      this.parse = _classPrivateFieldLooseBase(this, _parseMarkdown)[_parseMarkdown](Lexer.lex, Parser.parse);
      this.parseInline = _classPrivateFieldLooseBase(this, _parseMarkdown)[_parseMarkdown](Lexer.lexInline, Parser.parseInline);
      this.Parser = Parser;
      this.parser = Parser.parse;
      this.Renderer = Renderer;
      this.TextRenderer = TextRenderer;
      this.Lexer = Lexer;
      this.lexer = Lexer.lex;
      this.Tokenizer = Tokenizer;
      this.Slugger = Slugger;
      this.Hooks = Hooks;
      this.use.apply(this, arguments);
    }
    var _proto = Marked.prototype;
    _proto.walkTokens = function walkTokens(tokens, callback) {
      var _this = this;
      var values = [];
      var _loop = function _loop() {
        var token = _step.value;
        values = values.concat(callback.call(_this, token));
        switch (token.type) {
          case 'table':
            {
              for (var _iterator2 = _createForOfIteratorHelperLoose(token.header), _step2; !(_step2 = _iterator2()).done;) {
                var cell = _step2.value;
                values = values.concat(_this.walkTokens(cell.tokens, callback));
              }
              for (var _iterator3 = _createForOfIteratorHelperLoose(token.rows), _step3; !(_step3 = _iterator3()).done;) {
                var row = _step3.value;
                for (var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;) {
                  var _cell = _step4.value;
                  values = values.concat(_this.walkTokens(_cell.tokens, callback));
                }
              }
              break;
            }
          case 'list':
            {
              values = values.concat(_this.walkTokens(token.items, callback));
              break;
            }
          default:
            {
              if (_this.defaults.extensions && _this.defaults.extensions.childTokens && _this.defaults.extensions.childTokens[token.type]) {
                // Walk any extensions
                _this.defaults.extensions.childTokens[token.type].forEach(function (childTokens) {
                  values = values.concat(_this.walkTokens(token[childTokens], callback));
                });
              } else if (token.tokens) {
                values = values.concat(_this.walkTokens(token.tokens, callback));
              }
            }
        }
      };
      for (var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;) {
        _loop();
      }
      return values;
    };
    _proto.use = function use() {
      var _this2 = this;
      var extensions = this.defaults.extensions || {
        renderers: {},
        childTokens: {}
      };
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      args.forEach(function (pack) {
        // copy options to new object
        var opts = _extends({}, pack);

        // set async to true if it was set to true before
        opts.async = _this2.defaults.async || opts.async || false;

        // ==-- Parse "addon" extensions --== //
        if (pack.extensions) {
          pack.extensions.forEach(function (ext) {
            if (!ext.name) {
              throw new Error('extension name required');
            }
            if (ext.renderer) {
              // Renderer extensions
              var prevRenderer = extensions.renderers[ext.name];
              if (prevRenderer) {
                // Replace extension with func to run new extension but fall back if false
                extensions.renderers[ext.name] = function () {
                  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                  }
                  var ret = ext.renderer.apply(this, args);
                  if (ret === false) {
                    ret = prevRenderer.apply(this, args);
                  }
                  return ret;
                };
              } else {
                extensions.renderers[ext.name] = ext.renderer;
              }
            }
            if (ext.tokenizer) {
              // Tokenizer Extensions
              if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') {
                throw new Error("extension level must be 'block' or 'inline'");
              }
              if (extensions[ext.level]) {
                extensions[ext.level].unshift(ext.tokenizer);
              } else {
                extensions[ext.level] = [ext.tokenizer];
              }
              if (ext.start) {
                // Function to check for start of token
                if (ext.level === 'block') {
                  if (extensions.startBlock) {
                    extensions.startBlock.push(ext.start);
                  } else {
                    extensions.startBlock = [ext.start];
                  }
                } else if (ext.level === 'inline') {
                  if (extensions.startInline) {
                    extensions.startInline.push(ext.start);
                  } else {
                    extensions.startInline = [ext.start];
                  }
                }
              }
            }
            if (ext.childTokens) {
              // Child tokens to be visited by walkTokens
              extensions.childTokens[ext.name] = ext.childTokens;
            }
          });
          opts.extensions = extensions;
        }

        // ==-- Parse "overwrite" extensions --== //
        if (pack.renderer) {
          var renderer = _this2.defaults.renderer || new Renderer(_this2.defaults);
          var _loop2 = function _loop2(prop) {
            var prevRenderer = renderer[prop];
            // Replace renderer with func to run extension, but fall back if false
            renderer[prop] = function () {
              for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
              }
              var ret = pack.renderer[prop].apply(renderer, args);
              if (ret === false) {
                ret = prevRenderer.apply(renderer, args);
              }
              return ret;
            };
          };
          for (var prop in pack.renderer) {
            _loop2(prop);
          }
          opts.renderer = renderer;
        }
        if (pack.tokenizer) {
          var tokenizer = _this2.defaults.tokenizer || new Tokenizer(_this2.defaults);
          var _loop3 = function _loop3(_prop) {
            var prevTokenizer = tokenizer[_prop];
            // Replace tokenizer with func to run extension, but fall back if false
            tokenizer[_prop] = function () {
              for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
              }
              var ret = pack.tokenizer[_prop].apply(tokenizer, args);
              if (ret === false) {
                ret = prevTokenizer.apply(tokenizer, args);
              }
              return ret;
            };
          };
          for (var _prop in pack.tokenizer) {
            _loop3(_prop);
          }
          opts.tokenizer = tokenizer;
        }

        // ==-- Parse Hooks extensions --== //
        if (pack.hooks) {
          var hooks = _this2.defaults.hooks || new Hooks();
          var _loop4 = function _loop4(_prop2) {
            var prevHook = hooks[_prop2];
            if (Hooks.passThroughHooks.has(_prop2)) {
              hooks[_prop2] = function (arg) {
                if (_this2.defaults.async) {
                  return Promise.resolve(pack.hooks[_prop2].call(hooks, arg)).then(function (ret) {
                    return prevHook.call(hooks, ret);
                  });
                }
                var ret = pack.hooks[_prop2].call(hooks, arg);
                return prevHook.call(hooks, ret);
              };
            } else {
              hooks[_prop2] = function () {
                for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  args[_key5] = arguments[_key5];
                }
                var ret = pack.hooks[_prop2].apply(hooks, args);
                if (ret === false) {
                  ret = prevHook.apply(hooks, args);
                }
                return ret;
              };
            }
          };
          for (var _prop2 in pack.hooks) {
            _loop4(_prop2);
          }
          opts.hooks = hooks;
        }

        // ==-- Parse WalkTokens extensions --== //
        if (pack.walkTokens) {
          var walkTokens = _this2.defaults.walkTokens;
          opts.walkTokens = function (token) {
            var values = [];
            values.push(pack.walkTokens.call(this, token));
            if (walkTokens) {
              values = values.concat(walkTokens.call(this, token));
            }
            return values;
          };
        }
        _this2.defaults = _extends({}, _this2.defaults, opts);
      });
      return this;
    };
    _proto.setOptions = function setOptions(opt) {
      this.defaults = _extends({}, this.defaults, opt);
      return this;
    };
    return Marked;
  }();
  function _parseMarkdown2(lexer, parser) {
    var _this3 = this;
    return function (src, opt, callback) {
      if (typeof opt === 'function') {
        callback = opt;
        opt = null;
      }
      var origOpt = _extends({}, opt);
      opt = _extends({}, _this3.defaults, origOpt);
      var throwError = _classPrivateFieldLooseBase(_this3, _onError)[_onError](opt.silent, opt.async, callback);

      // throw error in case of non string input
      if (typeof src === 'undefined' || src === null) {
        return throwError(new Error('marked(): input parameter is undefined or null'));
      }
      if (typeof src !== 'string') {
        return throwError(new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected'));
      }
      checkDeprecations(opt, callback);
      if (opt.hooks) {
        opt.hooks.options = opt;
      }
      if (callback) {
        var highlight = opt.highlight;
        var tokens;
        try {
          if (opt.hooks) {
            src = opt.hooks.preprocess(src);
          }
          tokens = lexer(src, opt);
        } catch (e) {
          return throwError(e);
        }
        var done = function done(err) {
          var out;
          if (!err) {
            try {
              if (opt.walkTokens) {
                _this3.walkTokens(tokens, opt.walkTokens);
              }
              out = parser(tokens, opt);
              if (opt.hooks) {
                out = opt.hooks.postprocess(out);
              }
            } catch (e) {
              err = e;
            }
          }
          opt.highlight = highlight;
          return err ? throwError(err) : callback(null, out);
        };
        if (!highlight || highlight.length < 3) {
          return done();
        }
        delete opt.highlight;
        if (!tokens.length) return done();
        var pending = 0;
        _this3.walkTokens(tokens, function (token) {
          if (token.type === 'code') {
            pending++;
            setTimeout(function () {
              highlight(token.text, token.lang, function (err, code) {
                if (err) {
                  return done(err);
                }
                if (code != null && code !== token.text) {
                  token.text = code;
                  token.escaped = true;
                }
                pending--;
                if (pending === 0) {
                  done();
                }
              });
            }, 0);
          }
        });
        if (pending === 0) {
          done();
        }
        return;
      }
      if (opt.async) {
        return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function (src) {
          return lexer(src, opt);
        }).then(function (tokens) {
          return opt.walkTokens ? Promise.all(_this3.walkTokens(tokens, opt.walkTokens)).then(function () {
            return tokens;
          }) : tokens;
        }).then(function (tokens) {
          return parser(tokens, opt);
        }).then(function (html) {
          return opt.hooks ? opt.hooks.postprocess(html) : html;
        })["catch"](throwError);
      }
      try {
        if (opt.hooks) {
          src = opt.hooks.preprocess(src);
        }
        var _tokens = lexer(src, opt);
        if (opt.walkTokens) {
          _this3.walkTokens(_tokens, opt.walkTokens);
        }
        var html = parser(_tokens, opt);
        if (opt.hooks) {
          html = opt.hooks.postprocess(html);
        }
        return html;
      } catch (e) {
        return throwError(e);
      }
    };
  }
  function _onError2(silent, async, callback) {
    return function (e) {
      e.message += '\nPlease report this to https://github.com/markedjs/marked.';
      if (silent) {
        var msg = '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
        if (async) {
          return Promise.resolve(msg);
        }
        if (callback) {
          callback(null, msg);
          return;
        }
        return msg;
      }
      if (async) {
        return Promise.reject(e);
      }
      if (callback) {
        callback(e);
        return;
      }
      throw e;
    };
  }

  var markedInstance = new Marked(exports.defaults);

  /**
   * Marked
   */
  function marked(src, opt, callback) {
    return markedInstance.parse(src, opt, callback);
  }

  /**
   * Options
   */

  marked.options = marked.setOptions = function (opt) {
    markedInstance.setOptions(opt);
    marked.defaults = markedInstance.defaults;
    changeDefaults(marked.defaults);
    return marked;
  };
  marked.getDefaults = getDefaults;
  marked.defaults = exports.defaults;

  /**
   * Use Extension
   */

  marked.use = function () {
    markedInstance.use.apply(markedInstance, arguments);
    marked.defaults = markedInstance.defaults;
    changeDefaults(marked.defaults);
    return marked;
  };

  /**
   * Run callback for every token
   */

  marked.walkTokens = function (tokens, callback) {
    return markedInstance.walkTokens(tokens, callback);
  };

  /**
   * Parse Inline
   * @param {string} src
   */
  marked.parseInline = markedInstance.parseInline;

  /**
   * Expose
   */
  marked.Parser = Parser;
  marked.parser = Parser.parse;
  marked.Renderer = Renderer;
  marked.TextRenderer = TextRenderer;
  marked.Lexer = Lexer;
  marked.lexer = Lexer.lex;
  marked.Tokenizer = Tokenizer;
  marked.Slugger = Slugger;
  marked.Hooks = Hooks;
  marked.parse = marked;
  var options = marked.options;
  var setOptions = marked.setOptions;
  var use = marked.use;
  var walkTokens = marked.walkTokens;
  var parseInline = marked.parseInline;
  var parse = marked;
  var parser = Parser.parse;
  var lexer = Lexer.lex;

  exports.Hooks = Hooks;
  exports.Lexer = Lexer;
  exports.Marked = Marked;
  exports.Parser = Parser;
  exports.Renderer = Renderer;
  exports.Slugger = Slugger;
  exports.TextRenderer = TextRenderer;
  exports.Tokenizer = Tokenizer;
  exports.getDefaults = getDefaults;
  exports.lexer = lexer;
  exports.marked = marked;
  exports.options = options;
  exports.parse = parse;
  exports.parseInline = parseInline;
  exports.parser = parser;
  exports.setOptions = setOptions;
  exports.use = use;
  exports.walkTokens = walkTokens;

}));


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("825a");
var definePropertiesModule = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ "7db0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $find = __webpack_require__("b727").find;
var addToUnscopables = __webpack_require__("44d2");

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("861d");

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__("a04b");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "841c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("c65b");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var isNullOrUndefined = __webpack_require__("7234");
var requireObjectCoercible = __webpack_require__("1d80");
var sameValue = __webpack_require__("129f");
var toString = __webpack_require__("577e");
var getMethod = __webpack_require__("dc4a");
var regExpExec = __webpack_require__("14c3");

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ "861d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__("1626");
var $documentAll = __webpack_require__("8ea1");

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "863d":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VBtn");

/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var isCallable = __webpack_require__("1626");
var store = __webpack_require__("c6cd");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8ea1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ "90e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var toString = __webpack_require__("577e");
var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var shared = __webpack_require__("5692");
var create = __webpack_require__("7c73");
var getInternalState = __webpack_require__("69f3").get;
var UNSUPPORTED_DOT_ALL = __webpack_require__("fce3");
var UNSUPPORTED_NCG = __webpack_require__("107c");

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "9845":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/transitions");

/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var doesNotExceedSafeInteger = __webpack_require__("3511");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9a1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var getIteratorMethod = __webpack_require__("35a1");

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw new $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var anObject = __webpack_require__("825a");
var toPropertyKey = __webpack_require__("a04b");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ "a04b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var isSymbol = __webpack_require__("d9b5");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var arrayMethodIsStrict = __webpack_require__("a640");

var nativeJoin = uncurryThis([].join);

var ES3_STRINGS = IndexedObject !== Object;
var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: FORCED }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a4b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__("342f");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("d9f5");
__webpack_require__("b4f8");
__webpack_require__("c513");
__webpack_require__("e9c4");
__webpack_require__("5a47");


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "aed9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),

/***/ "af99":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VTextarea");

/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var FUNCTION_NAME_EXISTS = __webpack_require__("5e77").EXISTS;
var uncurryThis = __webpack_require__("e330");
var defineBuiltInAccessor = __webpack_require__("edd0");

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineBuiltInAccessor(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b1bf":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VDataTable");

/***/ }),

/***/ "b42e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ "b4f8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var hasOwn = __webpack_require__("1a2d");
var toString = __webpack_require__("577e");
var shared = __webpack_require__("5692");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("0b43");

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ "b575":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var macrotask = __webpack_require__("2cf4").set;
var Queue = __webpack_require__("01b4");
var IS_IOS = __webpack_require__("1cdc");
var IS_IOS_PEBBLE = __webpack_require__("d4c3");
var IS_WEBOS_WEBKIT = __webpack_require__("a4b4");
var IS_NODE = __webpack_require__("605d");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var microtask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var hasOwn = __webpack_require__("1a2d");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("04f8");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var uncurryThis = __webpack_require__("e330");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "b7cf":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VCard");

/***/ }),

/***/ "bfa4":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VSelect");

/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("c65b");
var isObject = __webpack_require__("861d");
var isSymbol = __webpack_require__("d9b5");
var getMethod = __webpack_require__("dc4a");
var ordinaryToPrimitive = __webpack_require__("485a");
var wellKnownSymbol = __webpack_require__("b622");

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "c0c4":
/***/ (function(module, exports, __webpack_require__) {

/*! @license DOMPurify 2.4.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.7/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  undefined;
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }
  /* Add properties to a lookup table */

  function addToSet(set, array, transformCaseFunc) {
    var _transformCaseFunc;

    transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;

    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;

    while (l--) {
      var element = array[l];

      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);

        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }
  /* Shallow clone an object */

  function clone(object) {
    var newObject = create(null);
    var property;

    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }
  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */

  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);

      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.

  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.

  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };
  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */


  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    } // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.


    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';

    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };
    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */


    DOMPurify.version = '2.4.7';
    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */

    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }

    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.

    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');

      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);

    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};

    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};
    /**
     * Expose whether this browser supports running the full DOMPurify.
     */

    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
    /* Allowed attribute names */

    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */

    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

    var FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

    var FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */

    var ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */

    var ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */

    var ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */

    var ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */

    var SAFE_FOR_TEMPLATES = false;
    /* Decide if document with <html>... should be returned */

    var WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */

    var SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */

    var FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */

    var RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */

    var RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */

    var RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */

    var SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */

    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */

    var KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */

    var IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */

    var USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */

    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
    /* Tags that are safe for data: URIs */

    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
    /* Attributes safe for values like "javascript:" */

    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */

    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */

    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
    /* Parsing of strict XHTML documents */

    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;
    /* Keep a reference to config to pass to hooks */

    var CONFIG = null;
    /* Ideally, do not touch anything below this line */

    /* ______________________________________________ */

    var formElement = document.createElement('form');

    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity


    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }
      /* Shield configuration object from tampering */


      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }
      /* Shield configuration object from prototype pollution */


      cfg = clone(cfg);
      PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
      /* Set configuration parameters */

      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true

      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

      RETURN_DOM = cfg.RETURN_DOM || false; // Default false

      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

      FORCE_BODY = cfg.FORCE_BODY || false; // Default false

      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

      IN_PLACE = cfg.IN_PLACE || false; // Default false

      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }
      /* Parse profile info */


      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];

        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      /* Merge configuration parameters */


      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }
      /* Add #text in case KEEP_CONTENT is set to true */


      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }
      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }
      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      } // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.


      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.

    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */

    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */

    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.

      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        } // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.


        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        } // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.


        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        } // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points


        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        } // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.


        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        } // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace


        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      } // For XHTML and XML documents that support custom namespaces


      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      } // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.


      return false;
    };
    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */


    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });

      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };
    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */


    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };
    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */


    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */

      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }
      /* Use createHTMLDocument in case DOMParser is not available */


      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);

        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {// Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }
      /* Work on whole document or just its body */


      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */


    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };
    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */


    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };
    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */


    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };
    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */


    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };
    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */


    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeElements', currentNode, null);
      /* Check if element is clobbered or can clobber */


      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Check if tagname contains Unicode */


      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Now let's check the element's type and name */


      var tagName = transformCaseFunc(currentNode.nodeName);
      /* Execute a hook if present */

      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });
      /* Detect mXSS attempts abusing namespace confusion */


      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Mitigate a problem with templates inside select */


      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Remove element if anything forbids its presence */


      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements */


        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);

        return true;
      }
      /* Check whether element has a valid namespace */


      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Make sure that older browsers don't get fallback-tag mXSS */


      if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Sanitize element content to be template-safe */


      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');

        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };
    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity


    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }
      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */


      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */

      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (value) {
        return false;
      } else ;

      return true;
    };
    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */


    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName.indexOf('-') > 0;
    };
    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */


    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;
      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;
      /* Go backwards over all attributes; safely remove bad ones */

      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);
        /* Execute a hook if present */

        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */

        if (hookEvent.forceKeepAttr) {
          continue;
        }
        /* Remove attribute */


        _removeAttribute(name, currentNode);
        /* Did the hooks approve of the attribute? */


        if (!hookEvent.keepAttr) {
          continue;
        }
        /* Work around a security issue in jQuery 3.0 */


        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);

          continue;
        }
        /* Sanitize attribute content to be template-safe */


        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }
        /* Is `value` valid for this attribute? */


        var lcTag = transformCaseFunc(currentNode.nodeName);

        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }
        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */


        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }
        /* Handle attributes that require Trusted Types */


        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                {
                  value = trustedTypesPolicy.createHTML(value);
                  break;
                }

              case 'TrustedScriptURL':
                {
                  value = trustedTypesPolicy.createScriptURL(value);
                  break;
                }
            }
          }
        }
        /* Handle invalid data-* attribute set by try-catching it */


        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeAttributes', currentNode, null);
    };
    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */


    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;

      var shadowIterator = _createIterator(fragment);
      /* Execute a hook if present */


      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */


        if (_sanitizeElements(shadowNode)) {
          continue;
        }
        /* Deep shadow DOM detected */


        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(shadowNode);
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };
    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity


    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */

      IS_EMPTY_INPUT = !dirty;

      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }
      /* Stringify, in case dirty is an object */


      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        if (typeof dirty.toString === 'function') {
          dirty = dirty.toString();

          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        } else {
          throw typeErrorCreate('toString is not a function');
        }
      }
      /* Check we can run. Otherwise fall back or ignore */


      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }
      /* Assign config vars */


      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }
      /* Clean up removed elements */


      DOMPurify.removed = [];
      /* Check if dirty is correctly typed for IN_PLACE */

      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);

          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);

        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }
        /* Initialize the document to work on */


        body = _initDocument(dirty);
        /* Check we have a DOM node from the data */

        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }
      /* Remove first element node (ours) if FORCE_BODY is set */


      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }
      /* Get node iterator */


      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
      /* Now start iterating over the created document */


      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }
        /* Sanitize tags and elements */


        if (_sanitizeElements(currentNode)) {
          continue;
        }
        /* Shadow DOM detected, sanitize it */


        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;
      /* If we sanitized `dirty` in-place, return it. */

      if (IN_PLACE) {
        return dirty;
      }
      /* Return sanitized string or DOM */


      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      /* Serialize doctype if allowed */

      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }
      /* Sanitize final string template-safe */


      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */


    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);

      SET_CONFIG = true;
    };
    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */


    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };
    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */


    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };
    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */


    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */


    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };
    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */


    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };
    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */


    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ "c430":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = false;


/***/ }),

/***/ "c513":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var hasOwn = __webpack_require__("1a2d");
var isSymbol = __webpack_require__("d9b5");
var tryToString = __webpack_require__("0d51");
var shared = __webpack_require__("5692");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("0b43");

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw new TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ "c65b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__("40d5");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var defineGlobalProperty = __webpack_require__("6374");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "ca92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrmContactRelationListItem_vue_vue_type_style_index_0_id_75c98974_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6b1e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrmContactRelationListItem_vue_vue_type_style_index_0_id_75c98974_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrmContactRelationListItem_vue_vue_type_style_index_0_id_75c98974_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $includes = __webpack_require__("4d64").includes;
var fails = __webpack_require__("d039");
var addToUnscopables = __webpack_require__("44d2");

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cb2d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__("1626");
var definePropertyModule = __webpack_require__("9bf2");
var makeBuiltIn = __webpack_require__("13d2");
var defineGlobalProperty = __webpack_require__("6374");

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cc98":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("4738").CONSTRUCTOR;
var NativePromiseConstructor = __webpack_require__("d256");
var getBuiltIn = __webpack_require__("d066");
var isCallable = __webpack_require__("1626");
var defineBuiltIn = __webpack_require__("cb2d");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var assign = __webpack_require__("60da");

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "cdce":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ "cdf9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var newPromiseCapability = __webpack_require__("f069");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d256":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");

module.exports = global.Promise;


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__("7282");
var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var defineBuiltIn = __webpack_require__("cb2d");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__("9bf2").f;
var hasOwn = __webpack_require__("1a2d");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d4c3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__("342f");

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ }),

/***/ "d587":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VImg");

/***/ }),

/***/ "d6d6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var uncurryThis = __webpack_require__("4625");
var defineBuiltIn = __webpack_require__("cb2d");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "d9b5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ "d9f5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("04f8");
var fails = __webpack_require__("d039");
var hasOwn = __webpack_require__("1a2d");
var isPrototypeOf = __webpack_require__("3a9b");
var anObject = __webpack_require__("825a");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var $toString = __webpack_require__("577e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var definePropertiesModule = __webpack_require__("37e8");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var defineBuiltIn = __webpack_require__("cb2d");
var defineBuiltInAccessor = __webpack_require__("edd0");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("e065");
var defineSymbolToPrimitive = __webpack_require__("57b9");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var RangeError = global.RangeError;
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var fallbackDefineProperty = function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
};

var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a !== 7;
}) ? fallbackDefineProperty : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw new TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      var descriptor = createPropertyDescriptor(1, value);
      try {
        setSymbolDescriptor(this, tag, descriptor);
      } catch (error) {
        if (!(error instanceof RangeError)) throw error;
        fallbackDefineProperty(this, tag, descriptor);
      }
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "dc4a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("59ed");
var isNullOrUndefined = __webpack_require__("7234");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var toString = __webpack_require__("577e");
var defineBuiltInAccessor = __webpack_require__("edd0");
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e065":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__("428f");
var hasOwn = __webpack_require__("1a2d");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "e267":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var isArray = __webpack_require__("e8b5");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("c6b6");
var toString = __webpack_require__("577e");

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),

/***/ "e330":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__("40d5");

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "e34a":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VToolbar");

/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e667":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "e6cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("5e7e");
__webpack_require__("14e5");
__webpack_require__("cc98");
__webpack_require__("3529");
__webpack_require__("f22b");
__webpack_require__("7149");


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__("1a2d");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),

/***/ "e8e3":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VTooltip");

/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "e9c4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var isSymbol = __webpack_require__("d9b5");
var arraySlice = __webpack_require__("f36a");
var getReplacerFunction = __webpack_require__("e267");
var NATIVE_SYMBOL = __webpack_require__("04f8");

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ "ec68":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VList");

/***/ }),

/***/ "edd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var makeBuiltIn = __webpack_require__("13d2");
var defineProperty = __webpack_require__("9bf2");

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ "f069":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("59ed");

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "f22b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var newPromiseCapabilityModule = __webpack_require__("f069");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("4738").CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});


/***/ }),

/***/ "f36a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis([].slice);


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var isCallable = __webpack_require__("1626");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "CrmContactListView", function() { return /* reexport */ CrmContactListView; });
__webpack_require__.d(__webpack_exports__, "CrmAddressFields", function() { return /* reexport */ CrmAddressFields; });
__webpack_require__.d(__webpack_exports__, "PhysicalAddress", function() { return /* reexport */ PhysicalAddress; });
__webpack_require__.d(__webpack_exports__, "PhoneNumber", function() { return /* reexport */ PhoneNumber; });
__webpack_require__.d(__webpack_exports__, "EmailAddress", function() { return /* reexport */ EmailAddress; });
__webpack_require__.d(__webpack_exports__, "WebAddress", function() { return /* reexport */ WebAddress; });
__webpack_require__.d(__webpack_exports__, "AddContactDialog", function() { return /* reexport */ AddContactDialog; });
__webpack_require__.d(__webpack_exports__, "routes", function() { return /* reexport */ routes; });
__webpack_require__.d(__webpack_exports__, "locale", function() { return /* reexport */ locale; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: external "vuetify/lib/components/VGrid"
var VGrid_ = __webpack_require__("5f3c");

// EXTERNAL MODULE: external "vuetify/lib/components/VTextField"
var VTextField_ = __webpack_require__("6881");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmAddressFields.vue?vue&type=template&id=3b0da778&




var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VTextField_["VTextField"],{ref:"first",attrs:{"value":_vm.value.address,"append-icon":_vm.appendIcon,"name":_vm.prefix + 'Address',"disabled":_vm.disabled,"label":"Gatuadress/boxadress"},on:{"input":function($event){return _vm.$emit('input', Object.assign({}, _vm.value, {address: $event}))},"click:append":function($event){return _vm.$emit('click:append', $event)}}}),_c(VGrid_["VRow"],{attrs:{"dense":""}},[_c(VGrid_["VCol"],{staticClass:"pt-0 pb-0",attrs:{"cols":"5"}},[_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.postalCode,"name":_vm.prefix + 'PostalCode',"disabled":_vm.disabled,"label":"Postnr"},on:{"input":function($event){return _vm.$emit('input', Object.assign({}, _vm.value, {postalCode: $event}))}}})],1),_c(VGrid_["VCol"],{staticClass:"pt-0 pb-0",attrs:{"cols":"7"}},[_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.city,"name":_vm.prefix + 'City',"disabled":_vm.disabled,"label":"Ort"},on:{"input":function($event){return _vm.$emit('input', Object.assign({}, _vm.value, {city: $event}))}}})],1)],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmAddressFields.vue?vue&type=template&id=3b0da778&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmAddressFields.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CrmAddressFieldsvue_type_script_lang_js_ = ({
  name: 'CrmAddressFields',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          address: null,
          postalCode: null,
          city: null
        };
      }
    },
    prefix: {
      type: String,
      default: ''
    },
    appendIcon: String,
    disabled: Boolean
  }
});
// CONCATENATED MODULE: ./src/components/CrmAddressFields.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmAddressFieldsvue_type_script_lang_js_ = (CrmAddressFieldsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/CrmAddressFields.vue





/* normalize component */

var component = normalizeComponent(
  components_CrmAddressFieldsvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmAddressFields = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/PhysicalAddress.vue?vue&type=template&id=072a2e13&




var PhysicalAddressvue_type_template_id_072a2e13_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VTextField_["VTextField"],{directives:[{name:"focus-on-empty",rawName:"v-focus-on-empty"}],attrs:{"value":_vm.value.address,"label":_vm.label || _vm.$vuetify.lang.t('$vuetify.crm.contact.address.address'),"append-icon":_vm.removeIcon},on:{"input":function($event){return _vm.$emit('input', Object.assign({}, _vm.value, {address: $event}))},"click:append":function($event){return _vm.$emit('remove', _vm.value)}}}),_c(VGrid_["VRow"],{attrs:{"dense":""}},[_c(VGrid_["VCol"],{attrs:{"cols":"4"}},[_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.postalCode,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.address.postalCode')},on:{"input":function($event){return _vm.$emit('input', Object.assign({}, _vm.value, {postalCode: $event}))}}})],1),_c(VGrid_["VCol"],{attrs:{"cols":"8"}},[_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.city,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.address.city'),"append-icon":"mdi-earth"},on:{"input":function($event){return _vm.$emit('input', Object.assign({}, _vm.value, {city: $event}))},"click:append":function($event){_vm.showCountry = !_vm.showCountry}}})],1)],1),(_vm.showCountry)?_c(VGrid_["VRow"],{attrs:{"dense":""}},[_c(VGrid_["VCol"],{attrs:{"cols":"4"}},[_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.region,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.address.region')},on:{"input":function($event){return _vm.$emit('input', Object.assign({}, _vm.value, {region: $event}))}}})],1),_c(VGrid_["VCol"],{attrs:{"cols":"8"}},[_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.country,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.address.country')},on:{"input":function($event){return _vm.$emit('input', Object.assign({}, _vm.value, {country: $event}))}}})],1)],1):_vm._e()],1)}
var PhysicalAddressvue_type_template_id_072a2e13_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/PhysicalAddress.vue?vue&type=template&id=072a2e13&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/PhysicalAddress.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PhysicalAddressvue_type_script_lang_js_ = ({
  name: "PhysicalAddress",
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    label: {
      type: String
    },
    removable: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      showCountry: !!(this.value && (this.value.country || this.value.region))
    };
  },
  computed: {
    removeIcon: function removeIcon() {
      return this.removable ? '$delete' : null;
    }
  },
  directives: {
    /**
     * If the model value is empty, focus on the input field.
     * When a user adds a new component instance it's value is empty and the field receives focus.
     */
    focusOnEmpty: {
      inserted: function inserted(el, binding, vnode) {
        var component = vnode.context;

        if (!component.value.address) {
          el.querySelector('input').focus();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/PhysicalAddress.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_PhysicalAddressvue_type_script_lang_js_ = (PhysicalAddressvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/PhysicalAddress.vue





/* normalize component */

var PhysicalAddress_component = normalizeComponent(
  components_PhysicalAddressvue_type_script_lang_js_,
  PhysicalAddressvue_type_template_id_072a2e13_render,
  PhysicalAddressvue_type_template_id_072a2e13_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PhysicalAddress = (PhysicalAddress_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/PhoneNumber.vue?vue&type=template&id=f3e5c098&


var PhoneNumbervue_type_template_id_f3e5c098_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField_["VTextField"],{directives:[{name:"focus-on-empty",rawName:"v-focus-on-empty"}],attrs:{"value":_vm.value.value,"label":_vm.label || _vm.$vuetify.lang.t('$vuetify.crm.contact.phone'),"append-icon":_vm.removeIcon},on:{"input":function($event){return _vm.$emit('input', Object.assign({}, _vm.value, {value: $event}))},"click:append":function($event){return _vm.$emit('remove', _vm.value)}}})}
var PhoneNumbervue_type_template_id_f3e5c098_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/PhoneNumber.vue?vue&type=template&id=f3e5c098&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/PhoneNumber.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PhoneNumbervue_type_script_lang_js_ = ({
  name: "PhoneNumber",
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    label: {
      type: String
    },
    removable: {
      type: Boolean
    }
  },
  computed: {
    removeIcon: function removeIcon() {
      return this.removable ? '$delete' : null;
    }
  },
  directives: {
    /**
     * If the model value is empty, focus on the input field.
     * When a user adds a new component instance it's value is empty and the field receives focus.
     */
    focusOnEmpty: {
      inserted: function inserted(el, binding, vnode) {
        var component = vnode.context;

        if (!component.value.value) {
          el.querySelector('input').focus();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/PhoneNumber.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_PhoneNumbervue_type_script_lang_js_ = (PhoneNumbervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/PhoneNumber.vue





/* normalize component */

var PhoneNumber_component = normalizeComponent(
  components_PhoneNumbervue_type_script_lang_js_,
  PhoneNumbervue_type_template_id_f3e5c098_render,
  PhoneNumbervue_type_template_id_f3e5c098_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PhoneNumber = (PhoneNumber_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/EmailAddress.vue?vue&type=template&id=8b0e6abc&


var EmailAddressvue_type_template_id_8b0e6abc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField_["VTextField"],{directives:[{name:"focus-on-empty",rawName:"v-focus-on-empty"}],attrs:{"value":_vm.value.value,"label":_vm.label || _vm.$vuetify.lang.t('$vuetify.crm.contact.email'),"append-icon":_vm.removeIcon},on:{"input":function($event){return _vm.$emit('input', Object.assign({}, _vm.value, {value: $event}))},"click:append":function($event){return _vm.$emit('remove', _vm.value)}}})}
var EmailAddressvue_type_template_id_8b0e6abc_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/EmailAddress.vue?vue&type=template&id=8b0e6abc&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/EmailAddress.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var EmailAddressvue_type_script_lang_js_ = ({
  name: "EmailAddress",
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    label: {
      type: String
    },
    removable: {
      type: Boolean
    }
  },
  computed: {
    removeIcon: function removeIcon() {
      return this.removable ? '$delete' : null;
    }
  },
  directives: {
    /**
     * If the model value is empty, focus on the input field.
     * When a user adds a new component instance it's value is empty and the field receives focus.
     */
    focusOnEmpty: {
      inserted: function inserted(el, binding, vnode) {
        var component = vnode.context;

        if (!component.value.value) {
          el.querySelector('input').focus();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/EmailAddress.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_EmailAddressvue_type_script_lang_js_ = (EmailAddressvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/EmailAddress.vue





/* normalize component */

var EmailAddress_component = normalizeComponent(
  components_EmailAddressvue_type_script_lang_js_,
  EmailAddressvue_type_template_id_8b0e6abc_render,
  EmailAddressvue_type_template_id_8b0e6abc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var EmailAddress = (EmailAddress_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/WebAddress.vue?vue&type=template&id=54f2ac6e&


var WebAddressvue_type_template_id_54f2ac6e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField_["VTextField"],{directives:[{name:"focus-on-empty",rawName:"v-focus-on-empty"}],attrs:{"value":_vm.value.value,"label":_vm.label || _vm.$vuetify.lang.t('$vuetify.crm.contact.web'),"append-icon":_vm.removeIcon},on:{"input":function($event){return _vm.$emit('input', Object.assign({}, _vm.value, {value: $event}))},"click:append":function($event){return _vm.$emit('remove', _vm.value)}}})}
var WebAddressvue_type_template_id_54f2ac6e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/WebAddress.vue?vue&type=template&id=54f2ac6e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/WebAddress.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-console */
/* harmony default export */ var WebAddressvue_type_script_lang_js_ = ({
  name: "WebAddress",
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    label: {
      type: String
    },
    removable: {
      type: Boolean
    }
  },
  computed: {
    removeIcon: function removeIcon() {
      return this.removable ? '$delete' : null;
    }
  },
  directives: {
    /**
     * If the model value is empty, focus on the input field.
     * When a user adds a new component instance it's value is empty and the field receives focus.
     */
    focusOnEmpty: {
      inserted: function inserted(el, binding, vnode) {
        var component = vnode.context;

        if (!component.value.value) {
          el.querySelector('input').focus();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/WebAddress.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_WebAddressvue_type_script_lang_js_ = (WebAddressvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/WebAddress.vue





/* normalize component */

var WebAddress_component = normalizeComponent(
  components_WebAddressvue_type_script_lang_js_,
  WebAddressvue_type_template_id_54f2ac6e_render,
  WebAddressvue_type_template_id_54f2ac6e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var WebAddress = (WebAddress_component.exports);
// EXTERNAL MODULE: external "vuetify/lib/components/VIcon"
var VIcon_ = __webpack_require__("354e");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactInformation.vue?vue&type=template&id=d621dd56&scoped=true&


var CrmContactInformationvue_type_template_id_d621dd56_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value.postalAddress && _vm.value.postalAddress.value)?_c('div',{on:{"click":function($event){return _vm.triggerCommunication(_vm.value.postalAddress)}}},[_c(VIcon_["VIcon"],{attrs:{"small":"","left":""}},[_vm._v("$address")]),_c('span',{staticClass:"hover"},[_vm._v(_vm._s(_vm.value.postalAddress.value))])],1):(_vm.primaryAddress)?_c('div',{on:{"click":function($event){return _vm.triggerCommunication({ type: 'postal', value: _vm.primaryAddress })}}},[_c(VIcon_["VIcon"],{attrs:{"small":"","left":""}},[_vm._v("$address")]),_c('span',{staticClass:"hover"},[_vm._v(_vm._s(_vm.primaryAddress))])],1):_vm._e(),(_vm.value.visitAddress && _vm.value.visitAddress.value)?_c('div',{on:{"click":function($event){return _vm.triggerCommunication(_vm.value.visitAddress)}}},[_c(VIcon_["VIcon"],{attrs:{"small":"","left":""}},[_vm._v("$address")]),_c('span',{staticClass:"hover"},[_vm._v(_vm._s(_vm.value.visitAddress.value))])],1):_vm._e(),(_vm.value.deliveryAddress && _vm.value.deliveryAddress.value)?_c('div',{on:{"click":function($event){return _vm.triggerCommunication(_vm.value.deliveryAddress)}}},[_c(VIcon_["VIcon"],{attrs:{"small":"","left":""}},[_vm._v("$address")]),_c('span',{staticClass:"hover"},[_vm._v(_vm._s(_vm.value.deliveryAddress.value))])],1):_vm._e(),(_vm.value.invoiceAddress && _vm.value.invoiceAddress.value)?_c('div',{on:{"click":function($event){return _vm.triggerCommunication(_vm.value.invoiceAddress)}}},[_c(VIcon_["VIcon"],{attrs:{"small":"","left":""}},[_vm._v("$address")]),_c('span',{staticClass:"hover"},[_vm._v(_vm._s(_vm.value.invoiceAddress.value))])],1):_vm._e(),(_vm.value.telephone1 && _vm.value.telephone1.value)?_c('div',{on:{"click":function($event){return _vm.triggerCommunication(_vm.value.telephone1)}}},[_c(VIcon_["VIcon"],{attrs:{"small":"","left":""}},[_vm._v("$phone")]),_c('span',{staticClass:"hover"},[_vm._v(_vm._s(_vm.value.telephone1.value))])],1):_vm._e(),(_vm.value.telephone2 && _vm.value.telephone2.value)?_c('div',{on:{"click":function($event){return _vm.triggerCommunication(_vm.value.telephone2)}}},[_c(VIcon_["VIcon"],{attrs:{"small":"","left":""}},[_vm._v("$phone")]),_c('span',{staticClass:"hover"},[_vm._v(_vm._s(_vm.value.telephone2.value))])],1):_vm._e(),(_vm.value.email1 && _vm.value.email1.value)?_c('div',{on:{"click":function($event){return _vm.triggerCommunication(_vm.value.email1)}}},[_c(VIcon_["VIcon"],{attrs:{"small":"","left":""}},[_vm._v("$email")]),_c('span',{staticClass:"hover"},[_vm._v(_vm._s(_vm.value.email1.value))])],1):_vm._e(),(_vm.value.email2 && _vm.value.email2.value)?_c('div',{on:{"click":function($event){return _vm.triggerCommunication(_vm.value.email2)}}},[_c(VIcon_["VIcon"],{attrs:{"small":"","left":""}},[_vm._v("$email")]),_c('span',{staticClass:"hover"},[_vm._v(_vm._s(_vm.value.email2.value))])],1):_vm._e(),(_vm.value.website1 && _vm.value.website1.value)?_c('div',{on:{"click":function($event){return _vm.triggerCommunication(_vm.value.website1)}}},[_c(VIcon_["VIcon"],{attrs:{"small":"","left":""}},[_vm._v("$internet")]),_c('span',{staticClass:"hover"},[_vm._v(_vm._s(_vm.value.website1.value))])],1):_vm._e(),(_vm.value.website2 && _vm.value.website2.value)?_c('div',{on:{"click":function($event){return _vm.triggerCommunication(_vm.value.website2)}}},[_c(VIcon_["VIcon"],{attrs:{"small":"","left":""}},[_vm._v("$internet")]),_c('span',{staticClass:"hover"},[_vm._v(_vm._s(_vm.value.website2.value))])],1):_vm._e()])}
var CrmContactInformationvue_type_template_id_d621dd56_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactInformation.vue?vue&type=template&id=d621dd56&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("2ca0");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactInformation.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CrmContactInformationvue_type_script_lang_js_ = ({
  name: "CrmContactInformation",
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    primaryAddress: function primaryAddress() {
      if (this.value.primaryRelation && this.value.primaryRelation.contact && this.value.primaryRelation.contact.postalAddress) {
        return this.value.primaryRelation.contact.postalAddress.value;
      }

      return null;
    }
  },
  methods: {
    triggerCommunication: function triggerCommunication(comm) {
      var value = comm.value;

      if (comm.label === 'url') {
        var url = value;

        if (!url.startsWith('http')) {
          url = 'http://' + encodeURIComponent(url);
        }

        window.open(url, '_blank');
      } else if (comm.label === 'email') {
        window.location.href = 'mailto:' + encodeURIComponent(value);
      } else if (comm.label === 'phone') {
        window.location.href = 'tel:' + encodeURIComponent(value);
      } else {
        window.open('https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(value), '_blank');
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactInformation.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactInformationvue_type_script_lang_js_ = (CrmContactInformationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/CrmContactInformation.vue?vue&type=style&index=0&id=d621dd56&scoped=true&lang=css&
var CrmContactInformationvue_type_style_index_0_id_d621dd56_scoped_true_lang_css_ = __webpack_require__("3c6d");

// CONCATENATED MODULE: ./src/components/CrmContactInformation.vue






/* normalize component */

var CrmContactInformation_component = normalizeComponent(
  components_CrmContactInformationvue_type_script_lang_js_,
  CrmContactInformationvue_type_template_id_d621dd56_scoped_true_render,
  CrmContactInformationvue_type_template_id_d621dd56_scoped_true_staticRenderFns,
  false,
  null,
  "d621dd56",
  null
  
)

/* harmony default export */ var CrmContactInformation = (CrmContactInformation_component.exports);
// EXTERNAL MODULE: external "vuetify/lib/components/VCard"
var VCard_ = __webpack_require__("b7cf");

// EXTERNAL MODULE: external "vuetify/lib/components/VDialog"
var VDialog_ = __webpack_require__("3699");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AddContactDialog.vue?vue&type=template&id=58b59188&



var AddContactDialogvue_type_template_id_58b59188_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDialog_["VDialog"],{attrs:{"value":_vm.value,"max-width":"640px","persistent":""},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancel.apply(null, arguments)}}},[_c('AddContact',{on:{"save":_vm.success,"cancel":_vm.cancel},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var title = ref.title;
return [_c(VCard_["VCardTitle"],[_vm._v(_vm._s(title))])]}}])})],1)}
var AddContactDialogvue_type_template_id_58b59188_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AddContactDialog.vue?vue&type=template&id=58b59188&

// EXTERNAL MODULE: external "vuetify/lib/components/VForm"
var VForm_ = __webpack_require__("1b42");

// EXTERNAL MODULE: external "vuetify/lib/components/VRadioGroup"
var VRadioGroup_ = __webpack_require__("682b");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AddContact.vue?vue&type=template&id=134cfe44&







var AddContactvue_type_template_id_134cfe44_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("header",null,{"title":_vm.pageTitle}),_c(VForm_["VForm"],{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c(VCard_["VCard"],[_vm._t("title",null,{"title":_vm.pageTitle}),_c(VCard_["VCardText"],[_c(VRadioGroup_["VRadioGroup"],{attrs:{"row":"","label":"Typ"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c(VRadioGroup_["VRadio"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.type.company'),"value":"company"}}),_c(VRadioGroup_["VRadio"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.type.person'),"value":"person"}})],1),(_vm.show === 'person')?_c('AddPersonForm',{attrs:{"gender-options":_vm.genderOptions,"tag-options":_vm.tagOptions},model:{value:(_vm.person),callback:function ($$v) {_vm.person=$$v},expression:"person"}}):_c('AddCompanyForm',{attrs:{"tag-options":_vm.tagOptions},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})],1),_c(VCard_["VCardActions"],[_vm._t("actions",function(){return [_c('crm-save-button',{attrs:{"type":"submit"}}),_c('crm-cancel-button',{on:{"click":_vm.cancel}})]},{"company":_vm.company,"person":_vm.person,"form":_vm.$refs.form,"title":_vm.pageTitle,"save":_vm.save,"cancel":_vm.cancel})],2)],2)],1)],2)}
var AddContactvue_type_template_id_134cfe44_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AddContact.vue?vue&type=template&id=134cfe44&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("e439");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("dbb4");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: external "vuetify/lib/components/VCombobox"
var VCombobox_ = __webpack_require__("2757");

// EXTERNAL MODULE: external "vuetify/lib/components/VTabs"
var VTabs_ = __webpack_require__("3b7c");

// EXTERNAL MODULE: external "vuetify/lib/components/VTextarea"
var VTextarea_ = __webpack_require__("af99");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AddCompanyForm.vue?vue&type=template&id=0db3f0f9&








var AddCompanyFormvue_type_template_id_0db3f0f9_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VTabs_["VTabs"],{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c(VTabs_["VTab"],[_vm._v("Namn & Adress")]),_c(VTabs_["VTab"],[_vm._v("Övrigt")])],1),_c(VTabs_["VTabsItems"],{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c(VTabs_["VTabItem"],[_c(VTextField_["VTextField"],{ref:"companyName",attrs:{"value":_vm.value.companyName,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.companyName'),"autofocus":""},on:{"input":function($event){return _vm.update('companyName', $event)}}}),_c('PhoneNumber',{attrs:{"label":"Telefon","value":_vm.value.telephone1},on:{"input":function($event){return _vm.update('telephone1', $event)}}}),_c('EmailAddress',{attrs:{"value":_vm.value.email1},on:{"input":function($event){return _vm.update('email1', $event)}}}),_c('WebAddress',{attrs:{"value":_vm.value.website1},on:{"input":function($event){return _vm.update('website1', $event)}}}),_c('PhysicalAddress',{attrs:{"value":_vm.value.postalAddress,"show-country":_vm.showCountry},on:{"input":function($event){return _vm.update('postalAddress', $event)}}})],1),_c(VTabs_["VTabItem"],[_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.number,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.number'),"autofocus":""},on:{"input":function($event){return _vm.update('number', $event)}}}),_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.origin,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.origin')},on:{"input":function($event){return _vm.update('origin', $event)}}}),_c(VCombobox_["VCombobox"],{attrs:{"label":"Etiketter","value":_vm.value.tags,"items":_vm.tagOptions,"hide-selected":"","chips":"","deletable-chips":"","small-chips":"","multiple":""},on:{"change":function($event){return _vm.update('tags', $event)}}}),_c(VTextarea_["VTextarea"],{attrs:{"clearable":"","value":_vm.value.description,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.description'),"rows":"5","counter":"4000"},on:{"input":function($event){return _vm.update('description', $event)}}})],1)],1)],1)}
var AddCompanyFormvue_type_template_id_0db3f0f9_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AddCompanyForm.vue?vue&type=template&id=0db3f0f9&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AddCompanyForm.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-console, no-unused-vars */




/* harmony default export */ var AddCompanyFormvue_type_script_lang_js_ = ({
  name: 'AddCompanyForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    tagOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    PhysicalAddress: PhysicalAddress,
    PhoneNumber: PhoneNumber,
    EmailAddress: EmailAddress,
    WebAddress: WebAddress
  },
  data: function data() {
    return {
      tab: 0
    };
  },
  computed: {
    showCountry: function showCountry() {
      var _this$value;

      return !!((_this$value = this.value) !== null && _this$value !== void 0 && _this$value.country);
    }
  },
  methods: {
    focus: function focus() {
      var _this = this;

      requestAnimationFrame(function () {
        return _this.$nextTick(_this.$refs.companyName.focus);
      });
    },
    update: function update(prop, value) {
      this.$emit('input', _objectSpread2(_objectSpread2({}, this.value), {}, _defineProperty({}, prop, value)));
    }
  }
});
// CONCATENATED MODULE: ./src/components/AddCompanyForm.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AddCompanyFormvue_type_script_lang_js_ = (AddCompanyFormvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/AddCompanyForm.vue





/* normalize component */

var AddCompanyForm_component = normalizeComponent(
  components_AddCompanyFormvue_type_script_lang_js_,
  AddCompanyFormvue_type_template_id_0db3f0f9_render,
  AddCompanyFormvue_type_template_id_0db3f0f9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AddCompanyForm = (AddCompanyForm_component.exports);
// EXTERNAL MODULE: external "vuetify/lib/components/VSelect"
var VSelect_ = __webpack_require__("bfa4");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AddPersonForm.vue?vue&type=template&id=7a7e3798&











var AddPersonFormvue_type_template_id_7a7e3798_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VTabs_["VTabs"],{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c(VTabs_["VTab"],[_vm._v("Namn & Adress")]),_c(VTabs_["VTab"],[_vm._v("Övrigt")])],1),_c(VTabs_["VTabsItems"],{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c(VTabs_["VTabItem"],[_c(VGrid_["VRow"],{attrs:{"dense":""}},[_c(VGrid_["VCol"],[_c(VTextField_["VTextField"],{ref:"firstName",attrs:{"value":_vm.value.firstName,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.firstName'),"autofocus":""},on:{"input":function($event){return _vm.update('firstName', $event)}}})],1),(_vm.showMiddleName)?_c(VGrid_["VCol"],[_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.middleName,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.middleName')},on:{"input":function($event){return _vm.update('middleName', $event)}}})],1):_vm._e(),_c(VGrid_["VCol"],[_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.lastName,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.lastName')},on:{"input":function($event){return _vm.update('lastName', $event)}}})],1)],1),_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.title,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.title')},on:{"input":function($event){return _vm.update('title', $event)}}}),_c('PhoneNumber',{attrs:{"label":"Telefon","value":_vm.value.telephone1},on:{"input":function($event){return _vm.update('telephone1', $event)}}}),_c('EmailAddress',{attrs:{"value":_vm.value.email1},on:{"input":function($event){return _vm.update('email1', $event)}}}),_c('PhysicalAddress',{attrs:{"value":_vm.value.postalAddress,"show-country":_vm.showCountry},on:{"input":function($event){return _vm.update('postalAddress', $event)}}})],1),_c(VTabs_["VTabItem"],[_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.number,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.number'),"autofocus":""},on:{"input":function($event){return _vm.update('number', $event)}}}),(_vm.showGender)?_c(VSelect_["VSelect"],{attrs:{"value":_vm.value.sex,"items":_vm.genderOptions,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.sex')},on:{"input":function($event){return _vm.update('sex', $event)}}}):_vm._e(),_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.origin,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.origin')},on:{"input":function($event){return _vm.update('origin', $event)}}}),_c(VCombobox_["VCombobox"],{attrs:{"label":"Etiketter","value":_vm.value.tags,"items":_vm.tagOptions,"hide-selected":"","chips":"","deletable-chips":"","small-chips":"","multiple":""},on:{"change":function($event){return _vm.update('tags', $event)}}}),_c(VTextarea_["VTextarea"],{attrs:{"clearable":"","value":_vm.value.description,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.description'),"rows":"5","counter":"4000"},on:{"input":function($event){return _vm.update('description', $event)}}})],1)],1)],1)}
var AddPersonFormvue_type_template_id_7a7e3798_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AddPersonForm.vue?vue&type=template&id=7a7e3798&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AddPersonForm.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-console, no-unused-vars */



/* harmony default export */ var AddPersonFormvue_type_script_lang_js_ = ({
  name: 'AddPersonForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    showMiddleName: {
      type: Boolean
    },
    tagOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    genderOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    PhysicalAddress: PhysicalAddress,
    PhoneNumber: PhoneNumber,
    EmailAddress: EmailAddress
  },
  data: function data() {
    return {
      tab: 0
    };
  },
  computed: {
    showCountry: function showCountry() {
      var _this$contact;

      return !!((_this$contact = this.contact) !== null && _this$contact !== void 0 && _this$contact.country);
    },
    showGender: function showGender() {
      return this.genderOptions.length > 0;
    }
  },
  methods: {
    focus: function focus() {
      var _this = this;

      requestAnimationFrame(function () {
        return _this.$nextTick(_this.$refs.firstName.focus);
      });
    },
    update: function update(prop, value) {
      this.$emit('input', _objectSpread2(_objectSpread2({}, this.value), {}, _defineProperty({}, prop, value)));
    }
  }
});
// CONCATENATED MODULE: ./src/components/AddPersonForm.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AddPersonFormvue_type_script_lang_js_ = (AddPersonFormvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/AddPersonForm.vue





/* normalize component */

var AddPersonForm_component = normalizeComponent(
  components_AddPersonFormvue_type_script_lang_js_,
  AddPersonFormvue_type_template_id_7a7e3798_render,
  AddPersonFormvue_type_template_id_7a7e3798_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AddPersonForm = (AddPersonForm_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AddContact.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var AddContactvue_type_script_lang_js_ = ({
  name: "AddContact",
  components: {
    AddPersonForm: AddPersonForm,
    AddCompanyForm: AddCompanyForm
  },
  data: function data() {
    return {
      show: 'company',
      company: {
        type: 'company'
      },
      person: {
        type: 'person'
      },
      valid: false,
      tagOptions: []
    };
  },
  computed: {
    pageTitle: function pageTitle() {
      var arr = [];

      if (this.isCompany) {
        arr.push(this.company.companyName);
      }

      if (this.isPerson) {
        var names = [];

        if (this.person.firstName) {
          names.push(this.person.firstName);
        }

        if (this.person.lastName) {
          names.push(this.person.lastName);
        }

        arr.push(names.join(' '));
      }

      var prefix = this.$vuetify.lang.t('$vuetify.crm.contact.create.title');

      if (arr.length) {
        return prefix + ' - ' + arr.join(' och ');
      }

      return prefix;
    },
    isCompany: function isCompany() {
      return !!this.company.companyName;
    },
    isPerson: function isPerson() {
      return !!this.person.firstName || !!this.person.lastName;
    },
    genderOptions: function genderOptions() {
      return this.$store.getters.genderOptions || [{
        text: '',
        value: null
      }, {
        text: 'Man',
        value: 'male'
      }, {
        text: 'Kvinna',
        value: 'female'
      }];
    }
  },
  methods: {
    reset: function reset() {
      this.company = {
        type: 'company'
      };
      this.person = {
        type: 'person'
      };
      this.show = 'company';
    },
    save: function save() {
      var _this = this;

      var promise = undefined;

      if (this.isCompany && this.isPerson) {
        promise = this.createCompanyAndPerson();
      } else if (this.isPerson) {
        promise = this.createPerson();
      } else if (this.isCompany) {
        promise = this.createCompany();
      }

      if (promise !== undefined) {
        return promise.then(function (created) {
          _this.reset();

          _this.$eventBus.$emit('crm-contact-created', {
            contact: created
          });

          _this.$emit('save', created);
        }).catch(function (err) {
          var message = err.response && err.response.data && err.response.data.message;

          _this.$store.dispatch('message', {
            subject: "Ett problem uppstod. Kontrollera uppgifterna och f\xF6rs\xF6k igen (".concat(message, ")"),
            color: 'error'
          }, {
            root: true
          });
        });
      }
    },
    createCompanyAndPerson: function createCompanyAndPerson() {
      var _this2 = this;

      return this.$store.dispatch('contact/createContact', {
        contact: this.company
      }).then(function (company) {
        var contact = _objectSpread2(_objectSpread2({}, _this2.person), {}, {
          relations: [{
            contactId: company.id,
            primary: true
          }]
        });

        return _this2.$store.dispatch('contact/createContact', {
          contact: contact
        });
      });
    },
    createCompany: function createCompany() {
      return this.$store.dispatch('contact/createContact', {
        contact: this.company
      });
    },
    createPerson: function createPerson() {
      return this.$store.dispatch('contact/createContact', {
        contact: this.person
      });
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  },
  created: function created() {
    var _this3 = this;

    this.$store.dispatch('contact/getContactTags').then(function (result) {
      return _this3.tagOptions = result.items;
    });
  }
});
// CONCATENATED MODULE: ./src/components/AddContact.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AddContactvue_type_script_lang_js_ = (AddContactvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/AddContact.vue





/* normalize component */

var AddContact_component = normalizeComponent(
  components_AddContactvue_type_script_lang_js_,
  AddContactvue_type_template_id_134cfe44_render,
  AddContactvue_type_template_id_134cfe44_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AddContact = (AddContact_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AddContactDialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var AddContactDialogvue_type_script_lang_js_ = ({
  name: "AddContactDialog",
  components: {
    AddContact: AddContact
  },
  props: {
    value: {
      type: Boolean
    }
  },
  methods: {
    success: function success(contact) {
      this.$emit('success', contact);
    },
    cancel: function cancel() {
      this.$emit('input', false);
    }
  }
});
// CONCATENATED MODULE: ./src/components/AddContactDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AddContactDialogvue_type_script_lang_js_ = (AddContactDialogvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/AddContactDialog.vue





/* normalize component */

var AddContactDialog_component = normalizeComponent(
  components_AddContactDialogvue_type_script_lang_js_,
  AddContactDialogvue_type_template_id_58b59188_render,
  AddContactDialogvue_type_template_id_58b59188_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AddContactDialog = (AddContactDialog_component.exports);
// EXTERNAL MODULE: external "vuetify/lib/components/VBtn"
var VBtn_ = __webpack_require__("863d");

// EXTERNAL MODULE: external "vuetify/lib/components/transitions"
var transitions_ = __webpack_require__("9845");

// EXTERNAL MODULE: external "vuetify/lib/components/VList"
var VList_ = __webpack_require__("ec68");

// EXTERNAL MODULE: external "vuetify/lib/components/VMenu"
var VMenu_ = __webpack_require__("079e");

// EXTERNAL MODULE: external "vuetify/lib/components/VSwitch"
var VSwitch_ = __webpack_require__("fd34");

// EXTERNAL MODULE: external "vuetify/lib/components/VToolbar"
var VToolbar_ = __webpack_require__("e34a");

// EXTERNAL MODULE: external "vuetify/lib/components/VTooltip"
var VTooltip_ = __webpack_require__("e8e3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/CrmContactListView.vue?vue&type=template&id=76d88291&

















var CrmContactListViewvue_type_template_id_76d88291_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VGrid_["VContainer"],{attrs:{"fluid":""}},[_c(VToolbar_["VToolbar"],{attrs:{"dark":"","dense":"","color":"primary"}},[_c(VToolbar_["VToolbarTitle"],{on:{"click":_vm.toggle}},[_c(VIcon_["VIcon"],{attrs:{"left":""}},[_vm._v("mdi-account-multiple-outline")]),_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.crm.contact.list.title'))+" "),(_vm.items.length)?_c('sup',[_vm._v("("+_vm._s(_vm.items.length)+")")]):_vm._e()],1),_c(VGrid_["VSpacer"]),_c(VToolbar_["VToolbarItems"],[_c(VTooltip_["VTooltip"],{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VBtn_["VBtn"],_vm._g(_vm._b({attrs:{"icon":"","to":{ name: 'crm-contact-create', params: { tenant: _vm.$crm.tenant } }}},'v-btn',attrs,false),on),[_c(VIcon_["VIcon"],[_vm._v("$add")])],1)]}}])},[_c('span',[_vm._v("Registrera en ny kontakt")])]),_c(VTooltip_["VTooltip"],{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VBtn_["VBtn"],_vm._g(_vm._b({attrs:{"icon":""},on:{"click":_vm.toggle}},'v-btn',attrs,false),on),[_c(VIcon_["VIcon"],{domProps:{"textContent":_vm._s(_vm.expanded ? 'mdi-chevron-up' : '$search')}},[_vm._v("$search")])],1)]}}])},[_c('span',[_vm._v("Avancerad sökning")])]),_c(VMenu_["VMenu"],{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VBtn_["VBtn"],_vm._g({attrs:{"icon":"","text":""}},on),[_c(VIcon_["VIcon"],[_vm._v("more_vert")])],1)]}}])},[_c(VList_["VList"],[_c(VList_["VListItem"],{attrs:{"to":{ name: 'crm-contact-create', params: { tenant: _vm.$crm.tenant } }}},[_c(VList_["VListItemIcon"],[_c(VIcon_["VIcon"],[_vm._v("$add")])],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],[_vm._v("Registrera ny kontakt")])],1)],1),_c(VList_["VListItem"],{on:{"click":_vm.openExportDialog}},[_c(VList_["VListItemIcon"],[_c(VIcon_["VIcon"],[_vm._v("mdi-printer")])],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],[_vm._v("Utskrift & export")])],1)],1),(_vm.isAdmin)?_c(VList_["VListItem"],{on:{"click":function($event){return _vm.$router.push({ tenant: _vm.$crm.tenant, name: 'crm-contact-import' })}}},[_c(VList_["VListItemIcon"],[_c(VIcon_["VIcon"],[_vm._v("mdi-import")])],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],[_vm._v("Importera kontakter")])],1)],1):_vm._e()],1)],1)],1)],1),_c(transitions_["VExpandTransition"],[_c('CrmContactSearchForm',{directives:[{name:"show",rawName:"v-show",value:(_vm.expanded),expression:"expanded"}],ref:"form",on:{"search":_vm.searchContacts},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c(VSwitch_["VSwitch"],{staticClass:"ml-3",attrs:{"label":"Behåll öppen"},model:{value:(_vm.stay),callback:function ($$v) {_vm.stay=$$v},expression:"stay"}})]},proxy:true}]),model:{value:(_vm.searchModel),callback:function ($$v) {_vm.searchModel=$$v},expression:"searchModel"}})],1),_c('CrmContactList',{staticClass:"mt-2",attrs:{"items":_vm.items},model:{value:(_vm.searchModel.type),callback:function ($$v) {_vm.$set(_vm.searchModel, "type", $$v)},expression:"searchModel.type"}})],1)}
var CrmContactListViewvue_type_template_id_76d88291_staticRenderFns = []


// CONCATENATED MODULE: ./src/views/CrmContactListView.vue?vue&type=template&id=76d88291&

// EXTERNAL MODULE: external "vuetify/lib/components/VChip"
var VChip_ = __webpack_require__("6b38");

// EXTERNAL MODULE: external "vuetify/lib/components/VDataTable"
var VDataTable_ = __webpack_require__("b1bf");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactList.vue?vue&type=template&id=27bc05db&





var CrmContactListvue_type_template_id_27bc05db_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDataTable_["VDataTable"],{attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":_vm.itemsPerPage,"footer-props":{ itemsPerPageOptions: _vm.$store.getters.itemsPerPageOptions },"search":_vm.localSearch ? _vm.searchValue : null,"sort-by":_vm.sortBy},on:{"update:itemsPerPage":function($event){_vm.itemsPerPage=$event},"update:items-per-page":function($event){_vm.itemsPerPage=$event},"update:sortBy":function($event){_vm.sortBy=$event},"update:sort-by":function($event){_vm.sortBy=$event},"click:row":function($event){return _vm.$router.push({ name: 'crm-contact-show', params: { tenant: _vm.$crm.tenant, id: $event.id }})}},scopedSlots:_vm._u([{key:"item.type",fn:function(ref){
var item = ref.item;
return [_c(VIcon_["VIcon"],{domProps:{"textContent":_vm._s(_vm.typeIcon(item.type))}})]}},{key:"item.primaryRelation",fn:function(ref){
var item = ref.item;
return [_c('span',{domProps:{"textContent":_vm._s(_vm.getPrimaryRelation(item))}})]}},{key:"item.tags",fn:function(ref){
var item = ref.item;
return _vm._l((item.tags),function(tag){return _c(VChip_["VChip"],{key:tag,attrs:{"small":"","color":"yellow lighten-2"}},[_vm._v(_vm._s(tag))])})}},{key:"footer",fn:function(){return [(_vm.searchField)?_c(VTextField_["VTextField"],{staticClass:"mx-3",attrs:{"placeholder":"Filter","prepend-icon":_vm.searchTypeIcon,"single-line":"","clearable":"","hide-details":"","solo":"","flat":"","autofocus":"","autocomplete":"off"},on:{"click:prepend":_vm.toggleSearchType,"input":function($event){return _vm.find($event, _vm.value)}},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}}):_vm._e()]},proxy:true}],null,true)})}
var CrmContactListvue_type_template_id_27bc05db_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactList.vue?vue&type=template&id=27bc05db&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("841c");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactList.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-console, no-unused-vars */
var tableState = {
  sortBy: 'name',
  itemsPerPage: 10
};
/* harmony default export */ var CrmContactListvue_type_script_lang_js_ = ({
  name: "CrmContactList",
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    search: {
      type: Boolean,
      default: true
    },
    value: {
      type: String
    }
  },
  data: function data() {
    return {
      searchValue: '',
      searchTimer: null
    };
  },
  computed: {
    sortBy: {
      get: function get() {
        return tableState.sortBy;
      },
      set: function set(n) {
        tableState.sortBy = n;
      }
    },
    itemsPerPage: {
      get: function get() {
        return tableState.itemsPerPage;
      },
      set: function set(n) {
        tableState.itemsPerPage = n;
      }
    },
    headers: function headers() {
      var array = [{
        text: 'Typ',
        align: 'left',
        value: 'type'
      }, {
        text: 'Namn',
        align: 'left',
        value: 'name'
      }];

      if (this.value !== 'company') {
        array.push({
          text: 'Relation',
          align: 'left',
          value: 'primaryRelation'
        });
      }

      if (this.$vuetify.breakpoint.mdAndUp) {
        array.push({
          text: 'Adress',
          align: 'left',
          value: 'postalAddress.value'
        });
        array.push({
          text: 'Telefon',
          align: 'left',
          value: 'telephone1.value'
        });
        array.push({
          text: 'E-post',
          align: 'left',
          value: 'email1.value'
        });
        array.push({
          text: 'Etiketter',
          align: 'left',
          value: 'tags'
        });
      } else {
        array.push({
          text: 'Ort',
          align: 'left',
          value: 'postalAddress.city'
        });
      }

      return array;
    },
    localSearch: function localSearch() {
      return !this.$listeners.search;
    },
    searchField: function searchField() {
      return this.search || !!this.$listeners.search;
    },
    searchTypeIcon: function searchTypeIcon() {
      if (this.localSearch) {
        return 'search';
      } else if (this.value === 'company') {
        return '$company';
      } else if (this.value === 'person') {
        return '$person';
      } else {
        return 'search';
      }
    }
  },
  methods: {
    typeIcon: function typeIcon(contactType) {
      return contactType === 'person' ? '$person' : '$company';
    },
    toggleSearchType: function toggleSearchType() {
      if (this.localSearch) {
        return;
      }

      if (this.value === 'company') {
        this.$emit('input', 'person');
      } else if (this.value === 'person') {
        this.$emit('input', null);
      } else {
        this.$emit('input', 'company');
      }

      if (this.search) {
        this.find(this.search, this.value);
      }
    },
    getPrimaryRelation: function getPrimaryRelation(item) {
      var _item$primaryRelation;

      return (_item$primaryRelation = item.primaryRelation) === null || _item$primaryRelation === void 0 ? void 0 : _item$primaryRelation.name;
    },
    find: function find(value, type) {
      var _this = this;

      if (this.localSearch) {
        return; // Handled by Vuetify/data-table
      }

      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      this.searchTimer = setTimeout(function () {
        _this._find(value, type);
      }, 600);
    },
    _find: function _find(query, type) {
      this.$emit('search', {
        query: query,
        type: type
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactList.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactListvue_type_script_lang_js_ = (CrmContactListvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/CrmContactList.vue





/* normalize component */

var CrmContactList_component = normalizeComponent(
  components_CrmContactListvue_type_script_lang_js_,
  CrmContactListvue_type_template_id_27bc05db_render,
  CrmContactListvue_type_template_id_27bc05db_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactList = (CrmContactList_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactSearchForm.vue?vue&type=template&id=5274788c&











var CrmContactSearchFormvue_type_template_id_5274788c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VForm_["VForm"],{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.search.apply(null, arguments)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c(VCard_["VCard"],[_c(VCard_["VCardText"],[_c(VRadioGroup_["VRadioGroup"],{attrs:{"row":"","value":_vm.value.type || 'contact'},on:{"change":function($event){return _vm.updateValue('type', $event)}}},[_c(VRadioGroup_["VRadio"],{attrs:{"label":"Alla kontakter","value":"contact"}}),_c(VRadioGroup_["VRadio"],{attrs:{"label":"Endast företag","value":"company"}}),_c(VRadioGroup_["VRadio"],{attrs:{"label":"Endast personer","value":"person"}})],1),_c(VGrid_["VRow"],[_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"5"}},[(_vm.isPerson)?_c(VGrid_["VRow"],[_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"6"}},[_c(VTextField_["VTextField"],{ref:"personName",attrs:{"value":_vm.value.firstName,"label":"Förnamn"},on:{"input":function($event){return _vm.updateValue('firstName', $event)}}})],1),_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"6"}},[_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.lastName,"label":"Efternamn"},on:{"input":function($event){return _vm.updateValue('lastName', $event)}}})],1)],1):_vm._e(),(_vm.isOrganization)?_c(VTextField_["VTextField"],{ref:"companyName",attrs:{"value":_vm.value.companyName,"label":"Företagsnamn"},on:{"input":function($event){return _vm.updateValue('companyName', $event)}}}):_vm._e(),(!_vm.isOrganization && !_vm.isPerson)?_c(VTextField_["VTextField"],{ref:"contactName",attrs:{"value":_vm.value.name,"label":"Namn"},on:{"input":function($event){return _vm.updateValue('name', $event)}}}):_vm._e(),_c('CrmAddressFields',{attrs:{"value":_vm.value.address},on:{"input":function($event){return _vm.updateValue('address', $event)}}})],1),_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"4"}},[_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.telephone,"label":"Telefon"},on:{"input":function($event){return _vm.updateValue('telephone', $event)}}}),_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.email,"label":"E-post"},on:{"input":function($event){return _vm.updateValue('email', $event)}}}),(_vm.isPerson)?_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.title,"label":"Titel"},on:{"input":function($event){return _vm.updateValue('title', $event)}}}):_vm._e()],1),_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"3"}},[_c(VTextField_["VTextField"],{attrs:{"value":_vm.value.tags,"label":"Etiketter"},on:{"input":function($event){return _vm.updateValue('tags', $event)}}})],1)],1)],1),_c(VCard_["VCardActions"],[_c('crm-save-button',{attrs:{"type":"submit"}},[_vm._v("Utför sökning")]),_c(VBtn_["VBtn"],{attrs:{"text":""},on:{"click":_vm.clear}},[_vm._v("Töm fält")]),_vm._t("actions",null,{"valid":_vm.valid})],2)],1)],1)}
var CrmContactSearchFormvue_type_template_id_5274788c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactSearchForm.vue?vue&type=template&id=5274788c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactSearchForm.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CrmContactSearchFormvue_type_script_lang_js_ = ({
  name: 'CrmContactSearchForm',
  components: {
    CrmAddressFields: CrmAddressFields
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      valid: false
    };
  },
  computed: {
    isPerson: function isPerson() {
      return this.value.type === 'person';
    },
    isOrganization: function isOrganization() {
      return this.value.type === 'company';
    }
  },
  methods: {
    updateValue: function updateValue(prop, value) {
      this.$emit('input', _objectSpread2(_objectSpread2({}, this.value), {}, _defineProperty({}, prop, value)));

      if (prop === 'type') {
        this.focus();
      }
    },
    search: function search() {
      if (this.$refs.form.validate()) {
        this.$emit('search', this.getQuery());
      }
    },
    startExport: function startExport(params) {
      if (this.valid) {
        this.$emit('export', _objectSpread2(_objectSpread2({}, params), {}, {
          query: this.getQuery()
        }));
      }
    },
    focus: function focus() {
      var _this = this;

      var vm = this;

      if (this.isPerson) {
        requestAnimationFrame(function () {
          return _this.$nextTick(function () {
            var _vm$$refs$personName;

            return (_vm$$refs$personName = vm.$refs.personName) === null || _vm$$refs$personName === void 0 ? void 0 : _vm$$refs$personName.focus();
          });
        });
      } else if (this.isOrganization) {
        requestAnimationFrame(function () {
          return _this.$nextTick(function () {
            var _vm$$refs$companyName;

            return (_vm$$refs$companyName = vm.$refs.companyName) === null || _vm$$refs$companyName === void 0 ? void 0 : _vm$$refs$companyName.focus();
          });
        });
      } else {
        requestAnimationFrame(function () {
          return _this.$nextTick(function () {
            var _vm$$refs$contactName;

            return (_vm$$refs$contactName = vm.$refs.contactName) === null || _vm$$refs$contactName === void 0 ? void 0 : _vm$$refs$contactName.focus();
          });
        });
      }
    },
    clear: function clear() {
      this.$emit('input', {
        type: 'contact',
        address: {}
      });
    },
    getQuery: function getQuery() {
      var query = _objectSpread2({}, this.value);

      if (query.type === 'person') {
        query.name = undefined;
        query.companyName = undefined;
      } else if (query.type === 'company') {
        query.name = undefined;
        query.firstName = undefined;
        query.middleName = undefined;
        query.lastName = undefined;
      } else {
        query.type = null;
        query.companyName = undefined;
        query.firstName = undefined;
        query.middleName = undefined;
        query.lastName = undefined;
      }

      return query;
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactSearchForm.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactSearchFormvue_type_script_lang_js_ = (CrmContactSearchFormvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/CrmContactSearchForm.vue





/* normalize component */

var CrmContactSearchForm_component = normalizeComponent(
  components_CrmContactSearchFormvue_type_script_lang_js_,
  CrmContactSearchFormvue_type_template_id_5274788c_render,
  CrmContactSearchFormvue_type_template_id_5274788c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactSearchForm = (CrmContactSearchForm_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/CrmContactListView.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var CrmContactListViewvue_type_script_lang_js_ = ({
  name: 'CrmContactListView',
  components: {
    CrmContactSearchForm: CrmContactSearchForm,
    CrmContactList: CrmContactList
  },
  data: function data() {
    return {
      expanded: false,
      stay: false,
      searchModel: {
        type: 'contact',
        address: {}
      },
      items: [],
      exportDialog: false
    };
  },
  computed: {
    isAdmin: function isAdmin() {
      return this.$store.getters['account/isAdmin'];
    }
  },
  methods: {
    toggle: function toggle() {
      this.expanded = !this.expanded;
    },
    searchContacts: function searchContacts(query) {
      var _this = this;

      this.$store.dispatch('contact/searchContact', query || {}).then(function (result) {
        if (result.items.length && !_this.stay) {
          _this.expanded = false;
        }

        _this.$store.commit('contact/setContactSearch', query);

        _this.items = result.items;
      }).catch(function (err) {
        return console.error(err);
      });
    },
    openExportDialog: function openExportDialog() {
      this.exportDialog = true;
    }
  },
  created: function created() {
    this.$store.dispatch('breadcrumbs', [{
      text: 'Kontakter',
      to: {
        name: 'crm-contact-list',
        params: {
          tenant: this.$crm.tenant
        }
      }
    }], {
      root: true
    });
    this.searchModel = _objectSpread2({}, this.$store.getters['contact/contactSearch']);
    this.searchContacts(this.searchModel);
  },
  watch: {
    expanded: function expanded(state) {
      var _this2 = this;

      if (state) {
        this.$nextTick(function () {
          var _this2$$refs$form;

          return (_this2$$refs$form = _this2.$refs.form) === null || _this2$$refs$form === void 0 ? void 0 : _this2$$refs$form.focus();
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./src/views/CrmContactListView.vue?vue&type=script&lang=js&
 /* harmony default export */ var views_CrmContactListViewvue_type_script_lang_js_ = (CrmContactListViewvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/views/CrmContactListView.vue





/* normalize component */

var CrmContactListView_component = normalizeComponent(
  views_CrmContactListViewvue_type_script_lang_js_,
  CrmContactListViewvue_type_template_id_76d88291_render,
  CrmContactListViewvue_type_template_id_76d88291_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactListView = (CrmContactListView_component.exports);
// CONCATENATED MODULE: ./src/store/state.js
var state_state = function state() {
  return {
    contactSearch: null,
    contactList: []
  };
};

/* harmony default export */ var store_state = (state_state);
// CONCATENATED MODULE: ./src/store/mutations.js

var mutations = {
  setContactSearch: function setContactSearch(state, formData) {
    state.contactSearch = _objectSpread2({}, formData); //localStorage.setItem('crm.contact.search', JSON.stringify(formData))
  },
  setContactList: function setContactList(state, list) {
    state.contactList = list;
  }
};
/* harmony default export */ var store_mutations = (mutations);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("e6cf");

// CONCATENATED MODULE: ./src/store/actions.js



/* eslint-disable no-console, no-unused-vars */
var SERVICE_NAME = 'contact';
var IMPORT_SERVICE_NAME = 'export';
var actions = {
  searchContact: function searchContact(_ref, query) {
    var dispatch = _ref.dispatch;
    return new Promise(function (resolve, reject) {
      dispatch('API', SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.post('/search', query);
      }).then(function (response) {
        return resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  queryContact: function queryContact(_ref2, query) {
    var dispatch = _ref2.dispatch;
    return new Promise(function (resolve, reject) {
      dispatch('API', SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.post('/query', {
          query: query
        });
      }).then(function (response) {
        return resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchContactList: function fetchContactList(_ref3, params) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
    var query = params === null || params === void 0 ? void 0 : params.query;
    var path = '/';

    if (query) {
      path = path + '?query=' + query;
    }

    return new Promise(function (resolve, reject) {
      dispatch('API', SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.get(path);
      }).then(function (response) {
        var result = response.data;

        if (params !== null && params !== void 0 && params.cache) {
          commit('setContactList', result);
        }

        resolve(result);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  clearContactList: function clearContactList(_ref4) {
    var commit = _ref4.commit;
    commit('setContactList', []);
  },
  fetchContact: function fetchContact(_ref5, id) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    return new Promise(function (resolve, reject) {
      dispatch('API', SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.get('/' + encodeURIComponent(id));
      }).then(function (response) {
        return resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  getContactSummary: function getContactSummary(_ref6, id) {
    var dispatch = _ref6.dispatch;
    return Promise.resolve('');
  },
  getContactTags: function getContactTags(_ref7) {
    var dispatch = _ref7.dispatch;
    return new Promise(function (resolve, reject) {
      dispatch('API', SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.get('/tags');
      }).then(function (response) {
        return resolve(response.data);
      }).then(function (err) {
        return reject(err);
      });
    });
  },
  createContact: function createContact(_ref8, _ref9) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;
    var contact = _ref9.contact;
    return new Promise(function (resolve, reject) {
      dispatch('API', SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.post('/', contact);
      }).then(function (response) {
        return resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  saveContact: function saveContact(_ref10, _ref11) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    var id = _ref11.id,
        contact = _ref11.contact;
    return new Promise(function (resolve, reject) {
      dispatch('API', SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.put('/' + encodeURIComponent(id), contact);
      }).then(function (response) {
        return resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  deleteContact: function deleteContact(_ref12, id) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    return new Promise(function (resolve, reject) {
      dispatch('API', SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.delete('/' + encodeURIComponent(id));
      }).then(function (response) {
        return resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchContactRelations: function fetchContactRelations(_ref13, id) {
    var dispatch = _ref13.dispatch;
    var path = '/' + encodeURIComponent(id);
    return new Promise(function (resolve, reject) {
      dispatch('API', SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.get(path + '/relations?include=from').then(function (responseFrom) {
          api.get(path + '/relations?include=to').then(function (responseTo) {
            return resolve({
              from: responseFrom.data.items,
              to: responseTo.data.items
            });
          });
        });
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  addRelation: function addRelation(_ref14, _ref15) {
    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;
    var id = _ref15.id,
        relation = _ref15.relation;
    return new Promise(function (resolve, reject) {
      dispatch('API', SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.post('/' + encodeURIComponent(id) + '/relations', relation);
      }).then(function (response) {
        return resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  updateRelation: function updateRelation(_ref16, _ref17) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;
    var id = _ref17.id,
        relation = _ref17.relation;
    return new Promise(function (resolve, reject) {
      dispatch('API', SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.put('/' + encodeURIComponent(id) + '/relations/' + encodeURIComponent(relation.id), relation);
      }).then(function (response) {
        return resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  removeRelation: function removeRelation(_ref18, _ref19) {
    var commit = _ref18.commit,
        dispatch = _ref18.dispatch;
    var id = _ref19.id,
        relation = _ref19.relation;
    return new Promise(function (resolve, reject) {
      dispatch('API', SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.delete('/' + encodeURIComponent(id) + '/relations/' + encodeURIComponent(relation.id));
      }).then(function (response) {
        return resolve(response.data);
      }).then(function (err) {
        return reject(err);
      });
    });
  },
  analyzeContactImport: function analyzeContactImport(_ref20, _ref21) {
    var dispatch = _ref20.dispatch;
    var id = _ref21.id;
    return new Promise(function (resolve, reject) {
      dispatch('API', IMPORT_SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.get('/import/' + encodeURIComponent(id));
      }).then(function (response) {
        return resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  startContactImport: function startContactImport(_ref22, _ref23) {
    var dispatch = _ref22.dispatch;
    var id = _ref23.id,
        data = _ref23.data;
    return new Promise(function (resolve, reject) {
      dispatch('API', IMPORT_SERVICE_NAME, {
        root: true
      }).then(function (api) {
        return api.post('/import/' + encodeURIComponent(id), data);
      }).then(function (response) {
        return resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  }
};
/* harmony default export */ var store_actions = (actions);
// CONCATENATED MODULE: ./src/store/getters.js
var getters = {
  contactSearch: function contactSearch(state) {
    return state.contactSearch; //const saved = localStorage.getItem('crm.contact.search')
    //return saved && JSON.parse(saved)
  },
  contactList: function contactList(state) {
    return state.contactList;
  },
  getTypeIcon: function getTypeIcon(state) {
    return function (type) {
      return '$' + type;
    };
  }
};
/* harmony default export */ var store_getters = (getters);
// CONCATENATED MODULE: ./src/store/index.js




/* harmony default export */ var src_store = ({
  namespaced: true,
  state: store_state,
  mutations: store_mutations,
  actions: store_actions,
  getters: store_getters
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/CrmContactCreateView.vue?vue&type=template&id=0eb78c78&







var CrmContactCreateViewvue_type_template_id_0eb78c78_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VGrid_["VContainer"],{attrs:{"fluid":""}},[_c('AddContact',{on:{"cancel":_vm.cancel,"save":_vm.success},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var title = ref.title;
return [_c(VToolbar_["VToolbar"],{attrs:{"dark":"","dense":"","color":"primary"}},[_c(VToolbar_["VToolbarTitle"],[_c(VIcon_["VIcon"],{attrs:{"left":""},domProps:{"textContent":_vm._s(_vm.$route.meta.icon)}}),_vm._v(" "+_vm._s(title)+" ")],1),_c(VGrid_["VSpacer"]),_c(VToolbar_["VToolbarItems"])],1)]}}])})],1)}
var CrmContactCreateViewvue_type_template_id_0eb78c78_staticRenderFns = []


// CONCATENATED MODULE: ./src/views/CrmContactCreateView.vue?vue&type=template&id=0eb78c78&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/CrmContactCreateView.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CrmContactCreateViewvue_type_script_lang_js_ = ({
  name: "CrmContactCreateView",
  components: {
    AddContact: AddContact
  },
  methods: {
    success: function success(contact) {
      this.$store.dispatch('message', {
        subject: "".concat(contact.name, " har skapats")
      }, {
        root: true
      });
      this.$router.push({
        name: 'crm-contact-show',
        params: {
          tenant: this.$crm.tenant,
          id: contact.id
        }
      });
    },
    cancel: function cancel() {
      this.$router.push({
        name: 'crm-contact-list',
        params: {
          tenant: this.$crm.tenant
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./src/views/CrmContactCreateView.vue?vue&type=script&lang=js&
 /* harmony default export */ var views_CrmContactCreateViewvue_type_script_lang_js_ = (CrmContactCreateViewvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/views/CrmContactCreateView.vue





/* normalize component */

var CrmContactCreateView_component = normalizeComponent(
  views_CrmContactCreateViewvue_type_script_lang_js_,
  CrmContactCreateViewvue_type_template_id_0eb78c78_render,
  CrmContactCreateViewvue_type_template_id_0eb78c78_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactCreateView = (CrmContactCreateView_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/CrmContactView.vue?vue&type=template&id=29323e8a&



var CrmContactViewvue_type_template_id_29323e8a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VGrid_["VContainer"],{attrs:{"fluid":""}},[_c('crm-expandable-section',{scopedSlots:_vm._u([{key:"toolbar",fn:function(ref){
var toggle = ref.toggle;
return [_c('CrmContactToolbar',{attrs:{"favorite":_vm.favorite,"permissions":_vm.permissions},on:{"toggle":toggle,"edit":function($event){_vm.addressDialog = true}},scopedSlots:_vm._u([{key:"menu",fn:function(){return [_c('CrmContactMenu',{attrs:{"value":_vm.contact,"permissions":_vm.permissions,"favorite":_vm.favorite},on:{"favorite":_vm.toggleFavorite,"reload":function($event){return _vm.fetchData(_vm.identifier)},"delete":function($event){_vm.confirmDelete = true},"export":function($event){_vm.exportDialog = true},"email":function($event){return _vm.$router.push({ name: 'contact-email', params: { id: _vm.identifier, tenant: _vm.$crm.tenant } })}}})]},proxy:true}],null,true),model:{value:(_vm.contact),callback:function ($$v) {_vm.contact=$$v},expression:"contact"}})]}},{key:"content",fn:function(){return [_c('CrmContactPanel',{attrs:{"permissions":_vm.permissions,"gender-options":_vm.genderOptions},model:{value:(_vm.contact),callback:function ($$v) {_vm.contact=$$v},expression:"contact"}})]},proxy:true}]),model:{value:(_vm.topExpanded),callback:function ($$v) {_vm.topExpanded=$$v},expression:"topExpanded"}}),_c('crm-expandable-section',{scopedSlots:_vm._u([{key:"toolbar",fn:function(ref){
var toggle = ref.toggle;
return [_c('CrmContactRelationToolbar',{attrs:{"items":_vm.relations.concat( _vm.related),"permissions":_vm.permissions},on:{"toggle":toggle,"add":_vm.addRelation},scopedSlots:_vm._u([{key:"menu",fn:function(){return [_c('CrmContactRelationMenu',{attrs:{"value":_vm.contact,"permissions":_vm.permissions},on:{"add":_vm.addRelation}})]},proxy:true}],null,true),model:{value:(_vm.contact),callback:function ($$v) {_vm.contact=$$v},expression:"contact"}})]}},{key:"content",fn:function(){return [_c('CrmContactRelationPanel',{attrs:{"relations":_vm.relations,"related":_vm.related,"permissions":_vm.permissions},on:{"select":function($event){return _vm.$router.push({ name: 'crm-contact-show', params: { id: $event.contactId, tenant: _vm.$crm.tenant  }})},"edit":function($event){_vm.selectedRelation = $event}},model:{value:(_vm.contact),callback:function ($$v) {_vm.contact=$$v},expression:"contact"}})]},proxy:true}]),model:{value:(_vm.relationsExpanded),callback:function ($$v) {_vm.relationsExpanded=$$v},expression:"relationsExpanded"}}),_c('crm-expandable-section',{scopedSlots:_vm._u([{key:"toolbar",fn:function(ref){
var toggle = ref.toggle;
return [_c('CrmContactContentToolbar',{attrs:{"items":_vm.files,"permissions":_vm.permissions,"thumbnails":_vm.thumbnails},on:{"toggle":toggle,"thumbnails":function($event){return _vm.toggleThumbnails($event)},"upload":_vm.upload},scopedSlots:_vm._u([{key:"menu",fn:function(){return [_c('CrmContactContentMenu',{attrs:{"value":_vm.contact,"permissions":_vm.permissions},on:{"reload":_vm.fetchFiles}})]},proxy:true}],null,true),model:{value:(_vm.contact),callback:function ($$v) {_vm.contact=$$v},expression:"contact"}})]}},{key:"content",fn:function(){return [_c('CrmContactContentPanel',{attrs:{"items":_vm.files,"thumbnails":_vm.thumbnails,"permissions":_vm.permissions},on:{"open":_vm.openContent,"edit":function($event){_vm.selectedContent = $event},"upload":_vm.upload},model:{value:(_vm.contact),callback:function ($$v) {_vm.contact=$$v},expression:"contact"}})]},proxy:true}]),model:{value:(_vm.contentExpanded),callback:function ($$v) {_vm.contentExpanded=$$v},expression:"contentExpanded"}}),_vm._l((_vm.$crm.plugins('contact-show', _vm.contact)),function(plugin,i){return _c(plugin.component,{key:i,tag:"component",attrs:{"value":_vm.contact,"relations":_vm.relations,"related":_vm.related,"files":_vm.files},on:{"reload":function($event){return _vm.fetchData(_vm.identifier)}}})}),_c(VDialog_["VDialog"],{attrs:{"value":_vm.addressDialog,"max-width":"640px","retain-focus":""},on:{"click:outside":function($event){return _vm.closeAddressDialog(false)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeAddressDialog(false)}}},[_c('NameAndAddressForm',{attrs:{"value":_vm.contact,"visible":_vm.addressDialog,"tag-options":_vm.tagOptions,"gender-options":_vm.genderOptions},on:{"save":function($event){return _vm.closeAddressDialog(true, $event)},"close":function($event){return _vm.closeAddressDialog(false)}}})],1),_c('crm-confirm-dialog',{attrs:{"visible":_vm.confirmDelete,"color":"error","title":"Bekräfta borttag","text":"Är du säker på att du vill radera kontakten? All data kopplat till kontakten (filer, m.m) kommer att raderas!"},on:{"confirm":_vm.deleteContact,"cancel":function($event){_vm.confirmDelete = false}}}),_c('CrmContactRelationEdit',{attrs:{"visible":!!_vm.selectedRelation},on:{"input":_vm.saveRelation,"remove":_vm.removeRelation,"close":function($event){_vm.selectedRelation = null}},model:{value:(_vm.selectedRelation),callback:function ($$v) {_vm.selectedRelation=$$v},expression:"selectedRelation"}}),_c('AddPersonDialog',{attrs:{"visible":_vm.addPerson,"items":_vm.searchResult,"parent":_vm.contact},on:{"search":_vm.onSearchPerson,"select":_vm.onSelectPerson,"save":_vm.savePerson,"close":function($event){_vm.addPerson = false}}}),_c('AddCompanyDialog',{attrs:{"visible":_vm.addCompany,"items":_vm.searchResult,"parent":_vm.contact},on:{"search":_vm.onSearchCompany,"select":_vm.onSelectCompany,"save":_vm.saveCompany,"close":function($event){_vm.addCompany = false}}}),_c('EditContentDialog',{attrs:{"visible":!!_vm.selectedContent,"content":_vm.selectedContent,"acl":"anonymous,authenticated"},on:{"update":_vm.saveContent,"delete":function($event){_vm.confirmDeleteContent = $event},"close":function($event){_vm.selectedContent = null}}})],2)}
var CrmContactViewvue_type_template_id_29323e8a_staticRenderFns = []


// CONCATENATED MODULE: ./src/views/CrmContactView.vue?vue&type=template&id=29323e8a&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactToolbar.vue?vue&type=template&id=4ab84ce1&








var CrmContactToolbarvue_type_template_id_4ab84ce1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VToolbar_["VToolbar"],{staticClass:"mt-1",attrs:{"dense":"","dark":"","color":"primary"},on:{"click":function($event){return _vm.$emit('toggle')}}},[_c(VToolbar_["VToolbarTitle"],[_c(VIcon_["VIcon"],{attrs:{"left":""},domProps:{"textContent":_vm._s(("$" + (_vm.value.type)))}}),_vm._v(" "+_vm._s(_vm.value.name)+" "),(_vm.primaryRelationName)?_c('span',[_vm._v("- "+_vm._s(_vm.primaryRelationName))]):_vm._e(),(_vm.favorite)?_c(VIcon_["VIcon"],{staticStyle:{"margin-top":"-10px"},attrs:{"small":"","right":"","color":"favorite"}},[_vm._v("$favorite")]):_vm._e()],1),_c(VGrid_["VSpacer"]),_c(VToolbar_["VToolbarItems"],[(_vm.canEdit)?_c(VTooltip_["VTooltip"],{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VBtn_["VBtn"],_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('edit')}}},'v-btn',attrs,false),on),[_c(VIcon_["VIcon"],[_vm._v("$edit")])],1)]}}],null,false,2899683836)},[_c('span',[_vm._v("Redigera kontaktuppgifter")])]):_vm._e()],1),_vm._t("menu")],2)}
var CrmContactToolbarvue_type_template_id_4ab84ce1_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactToolbar.vue?vue&type=template&id=4ab84ce1&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactToolbar.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CrmContactToolbarvue_type_script_lang_js_ = ({
  name: "CrmContactToolbar",
  props: {
    value: {
      type: Object,
      required: true
    },
    favorite: {
      type: Boolean
    },
    permissions: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    canEdit: function canEdit() {
      return !!this.permissions.update;
    },
    primaryRelationName: function primaryRelationName() {
      var _this$value, _this$value$primaryRe;

      return (_this$value = this.value) === null || _this$value === void 0 ? void 0 : (_this$value$primaryRe = _this$value.primaryRelation) === null || _this$value$primaryRe === void 0 ? void 0 : _this$value$primaryRe.name;
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactToolbar.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactToolbarvue_type_script_lang_js_ = (CrmContactToolbarvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/CrmContactToolbar.vue





/* normalize component */

var CrmContactToolbar_component = normalizeComponent(
  components_CrmContactToolbarvue_type_script_lang_js_,
  CrmContactToolbarvue_type_template_id_4ab84ce1_render,
  CrmContactToolbarvue_type_template_id_4ab84ce1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactToolbar = (CrmContactToolbar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactPanel.vue?vue&type=template&id=32ae5e84&







var CrmContactPanelvue_type_template_id_32ae5e84_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard_["VCard"],[_c(VCard_["VCardText"],[_c(VGrid_["VRow"],{attrs:{"dense":""}},[_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"4"}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.value.name))]),(_vm.value.title)?_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.value.title))]):_vm._e(),(_vm.primaryRelation)?_c('div',{on:{"click":function($event){return _vm.$router.push({ name: 'crm-contact-show', params: { id: _vm.primaryRelation.contact.id, tenant: _vm.$crm.tenant } })}}},[_c(VIcon_["VIcon"],{attrs:{"small":"","left":""},domProps:{"textContent":_vm._s(("$" + (_vm.primaryRelation.contactType)))}}),_c('span',{staticClass:"subtitle-1 hover"},[_vm._v(_vm._s(_vm.primaryRelationName))])],1):_vm._e(),_c('CrmContactInformation',{attrs:{"value":_vm.value}})],1),_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"4"}},[_c('crm-label-value',{attrs:{"value":_vm.value.number,"label":"crm.contact.number"}}),(_vm.gender)?_c('crm-label-value',{attrs:{"value":_vm.gender,"label":"crm.contact.sex"}}):_vm._e(),_c('crm-label-value',{attrs:{"value":_vm.value.origin,"label":"crm.contact.origin"}}),_c('crm-label-value',{attrs:{"value":_vm.value.tags && _vm.value.tags.length > 0,"label":"crm.contact.tags.label"}},_vm._l((_vm.value.tags),function(tag){return _c(VChip_["VChip"],{key:tag,staticClass:"ml-1",attrs:{"small":"","color":"yellow lighten-2"}},[_vm._v(_vm._s(tag))])}),1)],1),_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"4"}},[(_vm.value.description)?_c('div',{staticClass:"mb-1"},[_c('div',{staticClass:"crm-label caption text--secondary"},[_vm._v("Noteringar")]),_c('div',{staticClass:"crm-value",domProps:{"innerHTML":_vm._s(_vm.descriptionMarkdown)}})]):_vm._e()])],1)],1)],1)}
var CrmContactPanelvue_type_template_id_32ae5e84_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactPanel.vue?vue&type=template&id=32ae5e84&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__("c0c4");
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);

// EXTERNAL MODULE: ./node_modules/marked/lib/marked.umd.js
var marked_umd = __webpack_require__("7c5c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactPanel.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var CrmContactPanelvue_type_script_lang_js_ = ({
  name: "CrmContactPanel",
  props: {
    value: {
      type: Object,
      required: true
    },
    permissions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    genderOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    canEdit: function canEdit() {
      return !!this.permissions.update;
    },
    isPerson: function isPerson() {
      var _this$value;

      return ((_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.type) == 'person';
    },
    showGender: function showGender() {
      return this.genderOptions.length > 0;
    },
    primaryRelation: function primaryRelation() {
      var _this$value2;

      return (_this$value2 = this.value) === null || _this$value2 === void 0 ? void 0 : _this$value2.primaryRelation;
    },
    primaryRelationName: function primaryRelationName() {
      var _this$primaryRelation;

      return (_this$primaryRelation = this.primaryRelation) === null || _this$primaryRelation === void 0 ? void 0 : _this$primaryRelation.name;
    },
    descriptionMarkdown: function descriptionMarkdown() {
      var _this$value3;

      if ((_this$value3 = this.value) !== null && _this$value3 !== void 0 && _this$value3.description) {
        return purify_default.a.sanitize(marked_umd["marked"].parse(this.value.description, {
          mangle: false,
          headerIds: false,
          breaks: true,
          gfm: true
        }), {
          USE_PROFILES: {
            html: true
          }
        });
      }

      return null;
    },
    gender: function gender() {
      if (this.isPerson && this.showGender) {
        var _this$value4;

        var gender = (_this$value4 = this.value) === null || _this$value4 === void 0 ? void 0 : _this$value4.sex;
        var opt = this.genderOptions.find(function (opt) {
          return opt.value == gender;
        });
        return opt === null || opt === void 0 ? void 0 : opt.text;
      }

      return null;
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactPanel.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactPanelvue_type_script_lang_js_ = (CrmContactPanelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/CrmContactPanel.vue





/* normalize component */

var CrmContactPanel_component = normalizeComponent(
  components_CrmContactPanelvue_type_script_lang_js_,
  CrmContactPanelvue_type_template_id_32ae5e84_render,
  CrmContactPanelvue_type_template_id_32ae5e84_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactPanel = (CrmContactPanel_component.exports);
// EXTERNAL MODULE: external "vuetify/lib/components/VSpeedDial"
var VSpeedDial_ = __webpack_require__("1d6a");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactRelationToolbar.vue?vue&type=template&id=0d39ba0f&








var CrmContactRelationToolbarvue_type_template_id_0d39ba0f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VToolbar_["VToolbar"],{staticClass:"mt-1",attrs:{"dense":"","dark":"","color":"primary darken-2"},on:{"click":function($event){return _vm.$emit('toggle')}}},[_c(VToolbar_["VToolbarTitle"],[_c(VIcon_["VIcon"],{attrs:{"left":""}},[_vm._v("$group")]),_c('crm-tab-label',{staticClass:"label",attrs:{"value":_vm.items.length}},[_vm._v("Relationer")])],1),_c(VGrid_["VSpacer"]),_c(VToolbar_["VToolbarItems"],{on:{"click":function($event){$event.stopPropagation();}}},[_c(VSpeedDial_["VSpeedDial"],{attrs:{"direction":"top"},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c(VBtn_["VBtn"],{attrs:{"icon":""},model:{value:(_vm.addButton),callback:function ($$v) {_vm.addButton=$$v},expression:"addButton"}},[(_vm.addButton)?_c(VIcon_["VIcon"],[_vm._v("$close")]):_c(VIcon_["VIcon"],[_vm._v("$add")])],1)]},proxy:true}]),model:{value:(_vm.addButton),callback:function ($$v) {_vm.addButton=$$v},expression:"addButton"}},[_c(VBtn_["VBtn"],{attrs:{"fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.$emit('add', 'person')}}},[_c(VIcon_["VIcon"],[_vm._v("$person")])],1),_c(VBtn_["VBtn"],{attrs:{"fab":"","dark":"","small":"","color":"indigo"},on:{"click":function($event){return _vm.$emit('add', 'company')}}},[_c(VIcon_["VIcon"],[_vm._v("$company")])],1)],1)],1),_vm._t("menu")],2)}
var CrmContactRelationToolbarvue_type_template_id_0d39ba0f_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactRelationToolbar.vue?vue&type=template&id=0d39ba0f&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactRelationToolbar.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CrmContactRelationToolbarvue_type_script_lang_js_ = ({
  name: "CrmContactRelationToolbar",
  props: {
    value: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    permissions: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      addButton: false
    };
  },
  computed: {
    canEdit: function canEdit() {
      return !!this.permissions.update;
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactRelationToolbar.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactRelationToolbarvue_type_script_lang_js_ = (CrmContactRelationToolbarvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/CrmContactRelationToolbar.vue





/* normalize component */

var CrmContactRelationToolbar_component = normalizeComponent(
  components_CrmContactRelationToolbarvue_type_script_lang_js_,
  CrmContactRelationToolbarvue_type_template_id_0d39ba0f_render,
  CrmContactRelationToolbarvue_type_template_id_0d39ba0f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactRelationToolbar = (CrmContactRelationToolbar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactRelationPanel.vue?vue&type=template&id=4bfb127a&



var CrmContactRelationPanelvue_type_template_id_4bfb127a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count)?_c(VCard_["VCard"],[_c(VList_["VList"],[_vm._l((_vm.relations),function(item){return _c('CrmContactRelationListItem',{key:item.contactId,attrs:{"item":item,"editable":_vm.canEdit},on:{"select":function($event){return _vm.$emit('select', $event)},"edit":function($event){return _vm.$emit('edit', $event)}}})}),_vm._l((_vm.related),function(item){return _c('CrmContactRelationListItem',{key:item.contactId,attrs:{"item":item,"primary-class":"secondary"},on:{"select":function($event){return _vm.$emit('select', $event)}}})})],2)],1):_vm._e()}
var CrmContactRelationPanelvue_type_template_id_4bfb127a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactRelationPanel.vue?vue&type=template&id=4bfb127a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactRelationListItem.vue?vue&type=template&id=75c98974&scoped=true&









var CrmContactRelationListItemvue_type_template_id_75c98974_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VList_["VListItem"],{on:{"click":function($event){return _vm.$emit('select', _vm.item)}}},[_c(VList_["VListItemAvatar"],{attrs:{"size":"36"}},[_c(VIcon_["VIcon"],{class:[_vm.item.primary ? _vm.primaryClass : _vm.secondaryClass],attrs:{"dark":""},domProps:{"textContent":_vm._s('$' + _vm.item.contactType)}})],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],[_vm._v(_vm._s(_vm.item.name))]),(_vm.item.contact && _vm.item.contact.title)?_c(VList_["VListItemSubtitle"],[_vm._v(" "+_vm._s(_vm.item.contact.title)+" ")]):_vm._e(),(_vm.item.notes)?_c(VList_["VListItemSubtitle"],{staticClass:"caption truncate"},[_vm._v(" "+_vm._s(_vm.item.notes)+" ")]):_vm._e()],1),(_vm.editable)?_c(VList_["VListItemAction"],[_c(VBtn_["VBtn"],{attrs:{"icon":"","ripple":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('edit', _vm.item)}}},[_c(VIcon_["VIcon"],{attrs:{"small":"","color":"grey"}},[_vm._v("$edit")])],1)],1):_vm._e()],1)}
var CrmContactRelationListItemvue_type_template_id_75c98974_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactRelationListItem.vue?vue&type=template&id=75c98974&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactRelationListItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CrmContactRelationListItemvue_type_script_lang_js_ = ({
  name: "CrmContactRelationListItem",
  props: {
    item: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean
    },
    primaryClass: {
      type: String,
      default: 'primary'
    },
    secondaryClass: {
      type: String,
      default: 'accent'
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactRelationListItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactRelationListItemvue_type_script_lang_js_ = (CrmContactRelationListItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/CrmContactRelationListItem.vue?vue&type=style&index=0&id=75c98974&scoped=true&lang=css&
var CrmContactRelationListItemvue_type_style_index_0_id_75c98974_scoped_true_lang_css_ = __webpack_require__("ca92");

// CONCATENATED MODULE: ./src/components/CrmContactRelationListItem.vue






/* normalize component */

var CrmContactRelationListItem_component = normalizeComponent(
  components_CrmContactRelationListItemvue_type_script_lang_js_,
  CrmContactRelationListItemvue_type_template_id_75c98974_scoped_true_render,
  CrmContactRelationListItemvue_type_template_id_75c98974_scoped_true_staticRenderFns,
  false,
  null,
  "75c98974",
  null
  
)

/* harmony default export */ var CrmContactRelationListItem = (CrmContactRelationListItem_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactRelationPanel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CrmContactRelationPanelvue_type_script_lang_js_ = ({
  name: "CrmContactRelationPanel",
  components: {
    CrmContactRelationListItem: CrmContactRelationListItem
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    relations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    related: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    permissions: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    count: function count() {
      return this.relations.length + this.related.length;
    },
    canEdit: function canEdit() {
      return !!this.permissions.update;
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactRelationPanel.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactRelationPanelvue_type_script_lang_js_ = (CrmContactRelationPanelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/CrmContactRelationPanel.vue





/* normalize component */

var CrmContactRelationPanel_component = normalizeComponent(
  components_CrmContactRelationPanelvue_type_script_lang_js_,
  CrmContactRelationPanelvue_type_template_id_4bfb127a_render,
  CrmContactRelationPanelvue_type_template_id_4bfb127a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactRelationPanel = (CrmContactRelationPanel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactContentToolbar.vue?vue&type=template&id=1c926966&








var CrmContactContentToolbarvue_type_template_id_1c926966_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VToolbar_["VToolbar"],{staticClass:"mt-1",attrs:{"dense":"","dark":"","color":"primary darken-4"},on:{"click":function($event){return _vm.$emit('toggle')}}},[_c(VToolbar_["VToolbarTitle"],[_c(VIcon_["VIcon"],{attrs:{"left":""}},[_vm._v("$content")]),_c('crm-tab-label',{staticClass:"label",attrs:{"value":_vm.items.length}},[_vm._v("Filer")])],1),_c(VGrid_["VSpacer"]),_c(VToolbar_["VToolbarItems"],[_c(VTooltip_["VTooltip"],{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VBtn_["VBtn"],_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('thumbnails', !_vm.thumbnails)}}},'v-btn',attrs,false),on),[_c(VIcon_["VIcon"],{domProps:{"textContent":_vm._s(_vm.thumbnails ? 'mdi-format-list-bulleted' : 'mdi-view-grid-outline')}})],1)]}}])},[_c('span',[_vm._v("Växla mellan listvy och miniatyrer")])]),(_vm.canEdit)?_c('crm-upload-button',{attrs:{"multiple":""},on:{"upload":function($event){return _vm.$emit('upload', $event)}}},[_c(VTooltip_["VTooltip"],{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VBtn_["VBtn"],_vm._g(_vm._b({attrs:{"icon":""}},'v-btn',attrs,false),on),[_c(VIcon_["VIcon"],[_vm._v("$upload")])],1)]}}],null,false,1689974959)},[_c('span',[_vm._v("Ladda upp filer")])])],1):_vm._e()],1),_vm._t("menu")],2)}
var CrmContactContentToolbarvue_type_template_id_1c926966_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactContentToolbar.vue?vue&type=template&id=1c926966&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactContentToolbar.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CrmContactContentToolbarvue_type_script_lang_js_ = ({
  name: "CrmContactContentToolbar",
  props: {
    value: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    permissions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    thumbnails: {
      type: Boolean
    }
  },
  computed: {
    canEdit: function canEdit() {
      return !!this.permissions.update;
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactContentToolbar.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactContentToolbarvue_type_script_lang_js_ = (CrmContactContentToolbarvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/CrmContactContentToolbar.vue





/* normalize component */

var CrmContactContentToolbar_component = normalizeComponent(
  components_CrmContactContentToolbarvue_type_script_lang_js_,
  CrmContactContentToolbarvue_type_template_id_1c926966_render,
  CrmContactContentToolbarvue_type_template_id_1c926966_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactContentToolbar = (CrmContactContentToolbar_component.exports);
// EXTERNAL MODULE: external "vuetify/lib/components/VAlert"
var VAlert_ = __webpack_require__("4901");

// EXTERNAL MODULE: external "vuetify/lib/components/VImg"
var VImg_ = __webpack_require__("d587");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactContentPanel.vue?vue&type=template&id=783c48c4&scoped=true&







var CrmContactContentPanelvue_type_template_id_783c48c4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard_["VCard"],[_c(VCard_["VCardText"],[(_vm.thumbnails)?_c('div',[_c('crm-upload-content',{staticClass:"my-1",attrs:{"files":_vm.items,"selected":_vm.selected,"upload":_vm.canEdit},on:{"click":_vm.selectFile,"upload":_vm.upload},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var file = ref.file;
var hover = ref.hover;
return [_c(VImg_["VImg"],{attrs:{"src":_vm.getThumbnailUrl(file.id),"alt":file.title,"title":file.title}}),_c('div',{staticClass:"caption px-1 text-center crm-filename"},[_vm._v(_vm._s(file.title))]),_c(VBtn_["VBtn"],{directives:[{name:"show",rawName:"v-show",value:((_vm.canSign && hover) || _vm.isSigned(file)),expression:"(canSign && hover) || isSigned(file)"}],staticClass:"mb-2",staticStyle:{"margin-right":"-8px"},attrs:{"fab":"","dark":"","x-small":"","color":_vm.isSigned(file) ? 'success' : 'info',"absolute":"","bottom":"","right":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('sign', file)}}},[_c(VIcon_["VIcon"],[_vm._v("mdi-feather")])],1),_c(VBtn_["VBtn"],{directives:[{name:"show",rawName:"v-show",value:(hover),expression:"hover"}],staticStyle:{"margin-left":"auto","margin-right":"auto","left":"0","right":"0","margin-top":"auto","margin-bottom":"auto","top":"0","bottom":"0"},attrs:{"fab":"","dark":"","width":"64","height":"48","color":"blue darken-1","absolute":""},on:{"click":function($event){$event.stopPropagation();return _vm.openFile(file)}}},[_c(VIcon_["VIcon"],{attrs:{"large":""}},[_vm._v("mdi-eye")])],1),(_vm.canEdit)?_c(VBtn_["VBtn"],{directives:[{name:"show",rawName:"v-show",value:(hover),expression:"hover"}],staticClass:"mt-2",staticStyle:{"margin-left":"-8px"},attrs:{"fab":"","dark":"","x-small":"","color":"warning","absolute":"","top":"","left":""},on:{"click":function($event){$event.stopPropagation();return _vm.editFile(file)}}},[_c(VIcon_["VIcon"],[_vm._v("$edit")])],1):_vm._e()]}}],null,false,18328102)})],1):_c('div',[(_vm.items.length)?_c('div',[_c('crm-content-list',{attrs:{"items":_vm.items,"items-per-page":_vm.$store.getters.itemsPerPage,"footer-props":{ itemsPerPageOptions: _vm.$store.getters.itemsPerPageOptions },"editable":_vm.canEdit,"link":"","mobile-breakpoint":"0"},on:{"upload":_vm.upload,"select":_vm.openFile,"fetch":function($event){return _vm.$emit('fetch')},"edit":function($event){return _vm.$emit('edit', $event)}}})],1):(_vm.canEdit)?_c('crm-upload-button',{attrs:{"multiple":""},on:{"upload":_vm.upload}},[_c(VAlert_["VAlert"],{staticClass:"ma-3",attrs:{"type":"info","border":"left","elevation":"1","colored-border":"","dismissible":""},scopedSlots:_vm._u([{key:"close",fn:function(ref){
var toggle = ref.toggle;
return [_c(VIcon_["VIcon"],{attrs:{"color":"info","aria-label":"Stäng"},on:{"click":function($event){$event.stopPropagation();return toggle()}}},[_vm._v("$close")])]}}])},[_vm._v(" Inga filer är associerade med denna kontakt. Tryck här för att ladda upp filer. ")])],1):_c(VAlert_["VAlert"],{staticClass:"ma-3",attrs:{"type":"info","border":"left","elevation":"1","colored-border":"","dismissible":""}},[_vm._v(" Inga filer är associerade med denna kontakt. ")])],1)])],1)}
var CrmContactContentPanelvue_type_template_id_783c48c4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactContentPanel.vue?vue&type=template&id=783c48c4&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactContentPanel.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CrmContactContentPanelvue_type_script_lang_js_ = ({
  name: "CrmContactContentPanel",
  props: {
    value: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    permissions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    thumbnails: {
      type: Boolean
    },
    signing: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      selected: null
    };
  },
  computed: {
    canEdit: function canEdit() {
      return !!this.permissions.update;
    },
    canSign: function canSign() {
      return this.signing && this.canEdit;
    }
  },
  methods: {
    getThumbnailUrl: function getThumbnailUrl(id) {
      return "".concat(this.$store.getters.apiUrl, "/").concat(this.$crm.tenant, "/v1/content/assets/").concat(id, "?variant=thumbnail");
    },
    isSigned: function isSigned(item) {
      return item.tags && item.tags.indexOf('signed') !== -1;
    },
    upload: function upload($event) {
      this.$emit('upload', $event);
    },
    selectFile: function selectFile(item) {
      this.openFile(item);
    },
    openFile: function openFile(file) {
      this.$emit('open', file);
    },
    editFile: function editFile(file) {
      if (this.canEdit) {
        this.$emit('edit', file);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactContentPanel.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactContentPanelvue_type_script_lang_js_ = (CrmContactContentPanelvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/CrmContactContentPanel.vue?vue&type=style&index=0&id=783c48c4&scoped=true&lang=css&
var CrmContactContentPanelvue_type_style_index_0_id_783c48c4_scoped_true_lang_css_ = __webpack_require__("6146");

// CONCATENATED MODULE: ./src/components/CrmContactContentPanel.vue






/* normalize component */

var CrmContactContentPanel_component = normalizeComponent(
  components_CrmContactContentPanelvue_type_script_lang_js_,
  CrmContactContentPanelvue_type_template_id_783c48c4_scoped_true_render,
  CrmContactContentPanelvue_type_template_id_783c48c4_scoped_true_staticRenderFns,
  false,
  null,
  "783c48c4",
  null
  
)

/* harmony default export */ var CrmContactContentPanel = (CrmContactContentPanel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/NameAndAddressForm.vue?vue&type=template&id=bded43be&

















var NameAndAddressFormvue_type_template_id_bded43be_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VForm_["VForm"],{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c(VCard_["VCard"],[_vm._t("title",function(){return [_c(VCard_["VCardTitle"],[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.crm.contact.show.contactInfo'))+" ")])]},{"value":_vm.contact}),_c(VCard_["VCardText"],[_vm._t("prepend",null,{"value":_vm.contact,"update":_vm.update}),_c(VTabs_["VTabs"],{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c(VTabs_["VTab"],[_vm._v("Namn & Adress")]),_c(VTabs_["VTab"],[_vm._v("Övrigt")])],1),_c(VTabs_["VTabsItems"],{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c(VTabs_["VTabItem"],[(_vm.isPerson)?_c('div',[_c(VGrid_["VRow"],{attrs:{"dense":""}},[_c(VGrid_["VCol"],[_c(VTextField_["VTextField"],{ref:"firstName",attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.firstName'),"autofocus":""},model:{value:(_vm.contact.firstName),callback:function ($$v) {_vm.$set(_vm.contact, "firstName", $$v)},expression:"contact.firstName"}})],1),(_vm.showMiddleName)?_c(VGrid_["VCol"],[_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.middleName')},model:{value:(_vm.contact.middleName),callback:function ($$v) {_vm.$set(_vm.contact, "middleName", $$v)},expression:"contact.middleName"}})],1):_vm._e(),_c(VGrid_["VCol"],[_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.lastName')},model:{value:(_vm.contact.lastName),callback:function ($$v) {_vm.$set(_vm.contact, "lastName", $$v)},expression:"contact.lastName"}})],1)],1),_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.title')},model:{value:(_vm.contact.title),callback:function ($$v) {_vm.$set(_vm.contact, "title", $$v)},expression:"contact.title"}})],1):_c('div',[_c(VTextField_["VTextField"],{ref:"companyName",attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.companyName'),"autofocus":""},model:{value:(_vm.contact.companyName),callback:function ($$v) {_vm.$set(_vm.contact, "companyName", $$v)},expression:"contact.companyName"}})],1),_c('PhoneNumber',{attrs:{"label":"Telefon"},model:{value:(_vm.contact.telephone1),callback:function ($$v) {_vm.$set(_vm.contact, "telephone1", $$v)},expression:"contact.telephone1"}}),_c('EmailAddress',{model:{value:(_vm.contact.email1),callback:function ($$v) {_vm.$set(_vm.contact, "email1", $$v)},expression:"contact.email1"}}),(_vm.isOrganization || (_vm.value && _vm.value.website1))?_c('WebAddress',{model:{value:(_vm.contact.website1),callback:function ($$v) {_vm.$set(_vm.contact, "website1", $$v)},expression:"contact.website1"}}):_vm._e(),_c('PhysicalAddress',{attrs:{"show-country":_vm.showCountry},model:{value:(_vm.contact.postalAddress),callback:function ($$v) {_vm.$set(_vm.contact, "postalAddress", $$v)},expression:"contact.postalAddress"}})],1),_c(VTabs_["VTabItem"],[_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.number'),"autofocus":""},model:{value:(_vm.contact.number),callback:function ($$v) {_vm.$set(_vm.contact, "number", $$v)},expression:"contact.number"}}),(_vm.showGender)?_c(VSelect_["VSelect"],{attrs:{"items":_vm.genderOptions,"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.sex')},model:{value:(_vm.contact.sex),callback:function ($$v) {_vm.$set(_vm.contact, "sex", $$v)},expression:"contact.sex"}}):_vm._e(),_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.origin')},model:{value:(_vm.contact.origin),callback:function ($$v) {_vm.$set(_vm.contact, "origin", $$v)},expression:"contact.origin"}}),_c(VCombobox_["VCombobox"],{attrs:{"label":"Etiketter","items":_vm.tagOptions,"hide-selected":"","chips":"","deletable-chips":"","small-chips":"","multiple":""},model:{value:(_vm.contact.tags),callback:function ($$v) {_vm.$set(_vm.contact, "tags", $$v)},expression:"contact.tags"}}),_c(VTextarea_["VTextarea"],{attrs:{"clearable":"","label":_vm.$vuetify.lang.t('$vuetify.crm.contact.description'),"rows":"5","counter":"4000"},model:{value:(_vm.contact.description),callback:function ($$v) {_vm.$set(_vm.contact, "description", $$v)},expression:"contact.description"}})],1)],1)],2),_c(VCard_["VCardActions"],[_vm._t("actions",function(){return [_c(VGrid_["VSpacer"]),_c('crm-save-button',{attrs:{"type":"submit"}}),_c('crm-close-button',{on:{"click":_vm.close}})]},{"value":_vm.contact,"focus":_vm.focus})],2)],2)],1)}
var NameAndAddressFormvue_type_template_id_bded43be_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/NameAndAddressForm.vue?vue&type=template&id=bded43be&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/NameAndAddressForm.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-console, no-unused-vars */




/* harmony default export */ var NameAndAddressFormvue_type_script_lang_js_ = ({
  name: 'NameAndAddressForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      default: true
    },
    showMiddleName: {
      type: Boolean
    },
    tagOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    genderOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    PhysicalAddress: PhysicalAddress,
    PhoneNumber: PhoneNumber,
    EmailAddress: EmailAddress,
    WebAddress: WebAddress
  },
  data: function data() {
    return {
      tab: 0,
      valid: false,
      contact: {}
    };
  },
  computed: {
    isPerson: function isPerson() {
      return this.contact.type === 'person';
    },
    isOrganization: function isOrganization() {
      return this.contact.type === 'company';
    },
    showGender: function showGender() {
      return this.isPerson && this.genderOptions.length > 0;
    },
    showCountry: function showCountry() {
      var _this$contact;

      return !!((_this$contact = this.contact) !== null && _this$contact !== void 0 && _this$contact.country);
    }
  },
  methods: {
    showing: function showing() {
      this.contact = _objectSpread2({}, this.value);
    },
    focus: function focus() {
      var _this = this;

      if (this.isOrganization) {
        requestAnimationFrame(function () {
          return _this.$nextTick(_this.$refs.companyName.focus);
        });
      } else {
        requestAnimationFrame(function () {
          return _this.$nextTick(_this.$refs.firstName.focus);
        });
      }
    },
    update: function update(prop, value) {
      this.$set(this.contact, prop, value);
      this.$emit('change', this.contact);
      this.focus();
    },
    save: function save() {
      if (this.$refs.form.validate()) {
        this.$emit('save', this.contact);
        this.tab = 0;
      }
    },
    close: function close() {
      this.$emit('close');
      this.tab = 0;
    }
  },
  mounted: function mounted() {
    this.showing();
  },
  watch: {
    visible: function visible(state) {
      if (state) {
        this.showing();
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/NameAndAddressForm.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_NameAndAddressFormvue_type_script_lang_js_ = (NameAndAddressFormvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/NameAndAddressForm.vue





/* normalize component */

var NameAndAddressForm_component = normalizeComponent(
  components_NameAndAddressFormvue_type_script_lang_js_,
  NameAndAddressFormvue_type_template_id_bded43be_render,
  NameAndAddressFormvue_type_template_id_bded43be_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NameAndAddressForm = (NameAndAddressForm_component.exports);
// EXTERNAL MODULE: external "vuetify/lib/components/VDivider"
var VDivider_ = __webpack_require__("ffda");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactMenu.vue?vue&type=template&id=34b4f9ea&










var CrmContactMenuvue_type_template_id_34b4f9ea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMenu_["VMenu"],{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VBtn_["VBtn"],_vm._g({attrs:{"icon":"","text":""}},on),[_c(VIcon_["VIcon"],[_vm._v("more_vert")])],1)]}}])},[_c(VList_["VList"],[_c(VList_["VListItem"],{on:{"click":function($event){return _vm.$emit('export')}}},[_c(VList_["VListItemIcon"],[_c(VIcon_["VIcon"],[_vm._v("mdi-printer")])],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],[_vm._v("Utskrift & export")])],1)],1),_c(VList_["VListItem"],{on:{"click":function($event){return _vm.$emit('email')}}},[_c(VList_["VListItemIcon"],[_c(VIcon_["VIcon"],[_vm._v("mdi-at")])],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],[_vm._v("Skicka e-post")])],1)],1),_c(VList_["VListItem"],{on:{"click":function($event){return _vm.$emit('favorite', !_vm.favorite)}}},[_c(VList_["VListItemIcon"],[_c(VIcon_["VIcon"],[_vm._v("$favorite")])],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],{domProps:{"textContent":_vm._s(_vm.favorite ? 'Inte längre favorit' : 'Gör till favorit')}})],1)],1),_c(VList_["VListItem"],{on:{"click":function($event){return _vm.$emit('reload')}}},[_c(VList_["VListItemIcon"],[_c(VIcon_["VIcon"],[_vm._v("$reload")])],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],[_vm._v("Uppdatera")])],1)],1),_c(VList_["VListItem"],{on:{"click":function($event){return _vm.$emit('delete')}}},[_c(VList_["VListItemIcon"],[_c(VIcon_["VIcon"],{attrs:{"color":"error"}},[_vm._v("mdi-delete-outline")])],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],{staticClass:"error--text"},[_vm._v("Ta bort denna kontakt")])],1)],1),(_vm.$crm.plugins('contact-show-menu').length)?_c(VDivider_["VDivider"]):_vm._e(),_vm._l((_vm.$crm.plugins('contact-show-menu', _vm.value)),function(plugin,i){return _c(plugin.component,{key:i,tag:"component",attrs:{"value":_vm.value}})})],2)],1)}
var CrmContactMenuvue_type_template_id_34b4f9ea_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactMenu.vue?vue&type=template&id=34b4f9ea&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactMenu.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CrmContactMenuvue_type_script_lang_js_ = ({
  name: "CrmContactMenu",
  props: {
    value: {
      type: Object,
      required: true
    },
    permissions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    favorite: {
      type: Boolean
    }
  },
  computed: {
    canEdit: function canEdit() {
      return !!this.permissions.update;
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactMenu.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactMenuvue_type_script_lang_js_ = (CrmContactMenuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/CrmContactMenu.vue





/* normalize component */

var CrmContactMenu_component = normalizeComponent(
  components_CrmContactMenuvue_type_script_lang_js_,
  CrmContactMenuvue_type_template_id_34b4f9ea_render,
  CrmContactMenuvue_type_template_id_34b4f9ea_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactMenu = (CrmContactMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactContentMenu.vue?vue&type=template&id=084c4cb0&









var CrmContactContentMenuvue_type_template_id_084c4cb0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMenu_["VMenu"],{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VBtn_["VBtn"],_vm._g({attrs:{"icon":"","text":""}},on),[_c(VIcon_["VIcon"],[_vm._v("more_vert")])],1)]}}])},[_c(VList_["VList"],[_c(VList_["VListItem"],{on:{"click":function($event){return _vm.$emit('reload')}}},[_c(VList_["VListItemIcon"],[_c(VIcon_["VIcon"],[_vm._v("$reload")])],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],[_vm._v("Uppdatera")])],1)],1)],1)],1)}
var CrmContactContentMenuvue_type_template_id_084c4cb0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactContentMenu.vue?vue&type=template&id=084c4cb0&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactContentMenu.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CrmContactContentMenuvue_type_script_lang_js_ = ({
  name: "CrmContactContentMenu",
  props: {
    value: {
      type: Object,
      required: true
    },
    permissions: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    canEdit: function canEdit() {
      return !!this.permissions.update;
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactContentMenu.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactContentMenuvue_type_script_lang_js_ = (CrmContactContentMenuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/CrmContactContentMenu.vue





/* normalize component */

var CrmContactContentMenu_component = normalizeComponent(
  components_CrmContactContentMenuvue_type_script_lang_js_,
  CrmContactContentMenuvue_type_template_id_084c4cb0_render,
  CrmContactContentMenuvue_type_template_id_084c4cb0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactContentMenu = (CrmContactContentMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactRelationMenu.vue?vue&type=template&id=292608b0&









var CrmContactRelationMenuvue_type_template_id_292608b0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMenu_["VMenu"],{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VBtn_["VBtn"],_vm._g({attrs:{"icon":"","text":""}},on),[_c(VIcon_["VIcon"],[_vm._v("more_vert")])],1)]}}])},[_c(VList_["VList"],[(_vm.canEdit)?_c(VList_["VListItem"],{on:{"click":function($event){return _vm.$emit('add', 'company')}}},[_c(VList_["VListItemIcon"],[_c(VIcon_["VIcon"],[_vm._v("$company")])],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],[_vm._v("Registrera ett relaterat företag")])],1)],1):_vm._e(),(_vm.canEdit)?_c(VList_["VListItem"],{on:{"click":function($event){return _vm.$emit('add', 'person')}}},[_c(VList_["VListItemIcon"],[_c(VIcon_["VIcon"],[_vm._v("$person")])],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],[_vm._v("Registrera en relaterad person")])],1)],1):_vm._e()],1)],1)}
var CrmContactRelationMenuvue_type_template_id_292608b0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactRelationMenu.vue?vue&type=template&id=292608b0&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactRelationMenu.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CrmContactRelationMenuvue_type_script_lang_js_ = ({
  name: "CrmContactRelationMenu",
  props: {
    value: {
      type: Object,
      required: true
    },
    permissions: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    canEdit: function canEdit() {
      return !!this.permissions.update;
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactRelationMenu.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactRelationMenuvue_type_script_lang_js_ = (CrmContactRelationMenuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/CrmContactRelationMenu.vue





/* normalize component */

var CrmContactRelationMenu_component = normalizeComponent(
  components_CrmContactRelationMenuvue_type_script_lang_js_,
  CrmContactRelationMenuvue_type_template_id_292608b0_render,
  CrmContactRelationMenuvue_type_template_id_292608b0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactRelationMenu = (CrmContactRelationMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactRelationEdit.vue?vue&type=template&id=1dfb1dac&










var CrmContactRelationEditvue_type_template_id_1dfb1dac_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDialog_["VDialog"],{attrs:{"value":_vm.visible,"max-width":"640px","retain-focus":""},on:{"click:outside":_vm.close,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.close.apply(null, arguments)}}},[_c(VForm_["VForm"],{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[(_vm.value)?_c(VCard_["VCard"],[_c(VCard_["VCardTitle"],[_vm._v(_vm._s(_vm.value.name))]),_c(VCard_["VCardText"],[_c(VSwitch_["VSwitch"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.relations.primary')},model:{value:(_vm.primary),callback:function ($$v) {_vm.primary=$$v},expression:"primary"}}),_c(VTextarea_["VTextarea"],{attrs:{"placeholder":_vm.$vuetify.lang.t('$vuetify.crm.contact.relations.notes'),"rows":"3","counter":"4000","clearable":""},model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}})],1),_c(VCard_["VCardActions"],[_c(VGrid_["VSpacer"]),_c('crm-save-button',{attrs:{"type":"submit"}}),_c('crm-delete-button',{on:{"click":_vm.remove}}),_c('crm-close-button',{on:{"click":_vm.close}})],1)],1):_vm._e()],1)],1)}
var CrmContactRelationEditvue_type_template_id_1dfb1dac_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CrmContactRelationEdit.vue?vue&type=template&id=1dfb1dac&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CrmContactRelationEdit.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-console, no-unused-vars */
/* harmony default export */ var CrmContactRelationEditvue_type_script_lang_js_ = ({
  name: "CrmContactRelationEdit",
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    value: {
      type: Object
    }
  },
  data: function data() {
    return {
      valid: false,
      primary: false,
      notes: null
    };
  },
  methods: {
    showing: function showing() {
      this.primary = this.value.primary;
      this.notes = this.value.notes;
    },
    save: function save() {
      if (this.$refs.form.validate()) {
        this.$emit('input', _objectSpread2(_objectSpread2({}, this.value), {}, {
          primary: this.primary,
          notes: this.notes
        }));
      }
    },
    remove: function remove() {
      this.$emit('remove', this.value);
    },
    close: function close() {
      this.$emit('close');
    }
  },
  watch: {
    visible: function visible(state) {
      if (state) {
        this.showing();
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/CrmContactRelationEdit.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrmContactRelationEditvue_type_script_lang_js_ = (CrmContactRelationEditvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/CrmContactRelationEdit.vue





/* normalize component */

var CrmContactRelationEdit_component = normalizeComponent(
  components_CrmContactRelationEditvue_type_script_lang_js_,
  CrmContactRelationEditvue_type_template_id_1dfb1dac_render,
  CrmContactRelationEditvue_type_template_id_1dfb1dac_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactRelationEdit = (CrmContactRelationEdit_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AddPersonDialog.vue?vue&type=template&id=2bc652d2&



















var AddPersonDialogvue_type_template_id_2bc652d2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDialog_["VDialog"],{attrs:{"value":_vm.visible,"max-width":"640px","retain-focus":""},on:{"click:outside":_vm.close,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.close.apply(null, arguments)}}},[_c(VForm_["VForm"],{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c(VCard_["VCard"],[_c(VCard_["VCardTitle"],[_vm._v(_vm._s(_vm.dialogTitle))]),_c(VCard_["VCardText"],[_c(VGrid_["VRow"],{attrs:{"dense":""}},[_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"6"}},[_c(VTextField_["VTextField"],{ref:"firstName",attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.firstName'),"autofocus":"","autocomplete":"off"},on:{"input":function($event){return _vm.find()}},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}})],1),_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"6"}},[_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.lastName'),"autocomplete":"off"},on:{"input":function($event){return _vm.find()}},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}})],1)],1),_c(VAlert_["VAlert"],{attrs:{"outlined":"","dismissible":"","type":"warning","elevation":"1"},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_c('div',[_vm._v("Det finns "+_vm._s(_vm.items.length)+" kontakter med liknande namn i adressregistret. Tryck på namnet om du vill avbryta nyregistreringen och välja den befintliga kontakten istället.")]),_c(VList_["VList"],_vm._l((_vm.items),function(item){return _c(VList_["VListItem"],{key:item.id,on:{"click":function($event){return _vm.select(item)}}},[_c(VList_["VListItemIcon"],[_c(VIcon_["VIcon"],{attrs:{"small":""},domProps:{"textContent":_vm._s('$'+item.type)}})],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],[_vm._v(_vm._s(item.name))]),_c(VList_["VListItemSubtitle"],[_vm._v(_vm._s(item.primaryRelation && item.primaryRelation.name))])],1)],1)}),1)],1),(!_vm.alert)?_c('div',[_c(VGrid_["VRow"],{attrs:{"dense":""}},[_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"5"}},[_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.telephone'),"autocomplete":"off","type":"tel"},model:{value:(_vm.telephone),callback:function ($$v) {_vm.telephone=$$v},expression:"telephone"}})],1),_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"7"}},[_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.email'),"autocomplete":"off","type":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.address.address'),"hint":_vm.parent ? 'Lämna adressfälten blanka om personen har samma adress som ' + _vm.parent.name : null,"autocomplete":"off"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_c(VGrid_["VRow"],{attrs:{"dense":""}},[_c(VGrid_["VCol"],{attrs:{"cols":"3"}},[_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.address.postalCode'),"autocomplete":"off"},model:{value:(_vm.postalCode),callback:function ($$v) {_vm.postalCode=$$v},expression:"postalCode"}})],1),_c(VGrid_["VCol"],{attrs:{"cols":"9"}},[_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.address.city')},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1)],1)],1):_vm._e()],1),_c(VCard_["VCardActions"],[(_vm.items && _vm.items.length)?_c('span',{staticClass:"ml-3 red--text"},[_vm._v("Det finns "+_vm._s(_vm.items.length)+" kontakter med samma namn")]):_vm._e(),_c(VGrid_["VSpacer"]),_c('crm-save-button',{attrs:{"type":"submit"}}),_c('crm-close-button',{on:{"click":_vm.close}})],1)],1)],1)],1)}
var AddPersonDialogvue_type_template_id_2bc652d2_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AddPersonDialog.vue?vue&type=template&id=2bc652d2&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AddPersonDialog.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var AddPersonDialogvue_type_script_lang_js_ = ({
  name: "AddPersonDialog",
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    // Search result (persons)
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parent: {
      type: Object
    }
  },
  data: function data() {
    return {
      valid: false,
      alert: false,
      searchTimer: null,
      firstName: null,
      middleName: null,
      lastName: null,
      address: null,
      postalCode: null,
      city: null,
      region: null,
      country: null,
      telephone: null,
      email: null,
      title: null,
      notes: null,
      primary: true
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      var s = 'Registrera ny person';

      if (this.parent) {
        s = s + ' med relation till ' + this.parent.name;
      }

      return s;
    },
    name: function name() {
      if (this.firstName && this.lastName) {
        return this.firstName + ' ' + this.lastName;
      } else if (this.firstName) {
        return this.firstName;
      }

      return this.lastName;
    },
    payload: function payload() {
      return {
        type: 'person',
        firstName: this.firstName,
        middleName: this.middleName,
        lastName: this.lastName,
        postalAddress: {
          address: this.address,
          postalCode: this.postalCode,
          city: this.city,
          region: this.region,
          country: this.country
        },
        telephone1: {
          label: 'phone',
          value: this.telephone
        },
        email1: {
          label: 'email',
          value: this.email
        },
        title: this.title,
        notes: this.notes,
        primary: this.primary
      };
    }
  },
  methods: {
    showing: function showing() {
      this.reset();
    },
    find: function find() {
      var _this = this;

      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      this.searchTimer = setTimeout(function () {
        _this._find(_this.name);
      }, 1000);
    },
    _find: function _find(value) {
      this.$emit('search', value);
    },
    select: function select(item) {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$emit('select', _objectSpread2(_objectSpread2({}, item), {}, {
        name: this.name,
        notes: this.notes,
        primary: this.primary
      }));
    },
    save: function save() {
      if (this.$refs.form.validate()) {
        this.$emit('save', this.payload);
      }
    },
    close: function close() {
      this.$emit('close');
    },
    reset: function reset() {
      this.alert = false;
      this.title = null;
      this.notes = null;
      this.primary = true;
      this.firstName = null;
      this.middleName = null;
      this.lastName = null;
      this.address = null;
      this.postalCode = null;
      this.city = null;
      this.region = null;
      this.country = null;
      this.telephone = null;
      this.email = null;
    }
  },
  watch: {
    visible: function visible(state) {
      if (state) {
        this.showing();
      }
    },
    items: function items(list) {
      if (list && list.length > 0) {
        this.alert = true;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/AddPersonDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AddPersonDialogvue_type_script_lang_js_ = (AddPersonDialogvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/AddPersonDialog.vue





/* normalize component */

var AddPersonDialog_component = normalizeComponent(
  components_AddPersonDialogvue_type_script_lang_js_,
  AddPersonDialogvue_type_template_id_2bc652d2_render,
  AddPersonDialogvue_type_template_id_2bc652d2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AddPersonDialog = (AddPersonDialog_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AddCompanyDialog.vue?vue&type=template&id=1f8410b4&











var AddCompanyDialogvue_type_template_id_1f8410b4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDialog_["VDialog"],{attrs:{"value":_vm.visible,"max-width":"640px","retain-focus":""},on:{"click:outside":_vm.close,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.close.apply(null, arguments)}}},[_c(VForm_["VForm"],{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c(VCard_["VCard"],[_c(VCard_["VCardTitle"],[_vm._v(_vm._s(_vm.dialogTitle))]),_c(VCard_["VCardText"],[_c(VTextField_["VTextField"],{ref:"companyName",attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.companyName'),"autofocus":"","autocomplete":"off"},on:{"input":function($event){return _vm.find()}},model:{value:(_vm.companyName),callback:function ($$v) {_vm.companyName=$$v},expression:"companyName"}}),_c(VGrid_["VRow"],{attrs:{"dense":""}},[_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"5"}},[_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.telephone'),"autocomplete":"off","type":"tel"},model:{value:(_vm.telephone),callback:function ($$v) {_vm.telephone=$$v},expression:"telephone"}})],1),_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"7"}},[_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.email'),"autocomplete":"off","type":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.address.address'),"autocomplete":"off"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_c(VGrid_["VRow"],{attrs:{"dense":""}},[_c(VGrid_["VCol"],{attrs:{"cols":"3"}},[_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.address.postalCode'),"autocomplete":"off"},model:{value:(_vm.postalCode),callback:function ($$v) {_vm.postalCode=$$v},expression:"postalCode"}})],1),_c(VGrid_["VCol"],{attrs:{"cols":"9"}},[_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.contact.address.city')},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1)],1)],1),_c(VCard_["VCardActions"],[(_vm.items && _vm.items.length)?_c('span',{staticClass:"ml-3 red--text"},[_vm._v("Det finns "+_vm._s(_vm.items.length)+" kontakter med samma namn")]):_vm._e(),_c(VGrid_["VSpacer"]),_c('crm-save-button',{attrs:{"type":"submit"}}),_c('crm-close-button',{on:{"click":_vm.close}})],1)],1)],1)],1)}
var AddCompanyDialogvue_type_template_id_1f8410b4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/AddCompanyDialog.vue?vue&type=template&id=1f8410b4&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AddCompanyDialog.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var AddCompanyDialogvue_type_script_lang_js_ = ({
  name: "AddCompanyDialog",
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    // Search result (companies)
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parent: {
      type: Object
    }
  },
  data: function data() {
    return {
      valid: false,
      alert: false,
      searchTimer: null,
      companyName: null,
      address: null,
      postalCode: null,
      city: null,
      region: null,
      country: null,
      telephone: null,
      email: null,
      notes: null
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      var s = 'Registrera nytt företag';

      if (this.parent) {
        s = s + ' med relation till ' + this.parent.name;
      }

      return s;
    },
    payload: function payload() {
      return {
        type: 'company',
        companyName: this.companyName,
        postalAddress: {
          address: this.address,
          postalCode: this.postalCode,
          city: this.city,
          region: this.region,
          country: this.country
        },
        telephone1: {
          label: 'phone',
          value: this.telephone
        },
        email1: {
          label: 'email',
          value: this.email
        },
        notes: this.notes,
        primary: false
      };
    }
  },
  methods: {
    showing: function showing() {
      this.reset();
    },
    find: function find() {
      var _this = this;

      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      this.searchTimer = setTimeout(function () {
        _this._find(_this.companyName);
      }, 1000);
    },
    _find: function _find(value) {
      this.$emit('search', value);
    },
    select: function select(item) {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$emit('select', _objectSpread2(_objectSpread2({}, item), {}, {
        companyName: this.companyName,
        notes: this.notes,
        primary: false
      }));
    },
    save: function save() {
      if (this.$refs.form.validate()) {
        this.$emit('save', this.payload);
      }
    },
    close: function close() {
      this.$emit('close');
    },
    reset: function reset() {
      this.alert = false;
      this.notes = null;
      this.companyName = null;
      this.address = null;
      this.postalCode = null;
      this.city = null;
      this.region = null;
      this.country = null;
      this.telephone = null;
      this.email = null;
    }
  },
  watch: {
    visible: function visible(state) {
      if (state) {
        this.showing();
      }
    },
    items: function items(list) {
      if (list && list.length > 0) {
        this.alert = true;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/AddCompanyDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AddCompanyDialogvue_type_script_lang_js_ = (AddCompanyDialogvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/AddCompanyDialog.vue





/* normalize component */

var AddCompanyDialog_component = normalizeComponent(
  components_AddCompanyDialogvue_type_script_lang_js_,
  AddCompanyDialogvue_type_template_id_1f8410b4_render,
  AddCompanyDialogvue_type_template_id_1f8410b4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AddCompanyDialog = (AddCompanyDialog_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/EditContentDialog.vue?vue&type=template&id=8ed08d22&
















var EditContentDialogvue_type_template_id_8ed08d22_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDialog_["VDialog"],{attrs:{"fullscreen":_vm.$vuetify.breakpoint.mobile,"eager":"","value":_vm.visible,"width":"100%","max-width":_vm.dialogWidth,"persistent":""},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.close.apply(null, arguments)}}},[_c(VForm_["VForm"],{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c(VCard_["VCard"],[_c(VCard_["VCardTitle"],[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.crm.content.edit.title'))+" ")]),_c(VCard_["VCardText"],[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editObject.id),expression:"editObject.id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.editObject.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editObject, "id", $event.target.value)}}}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editObject.target),expression:"editObject.target"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.editObject.target)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editObject, "target", $event.target.value)}}}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editObject.mimeType),expression:"editObject.mimeType"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.editObject.mimeType)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editObject, "mimeType", $event.target.value)}}}),_c(VGrid_["VRow"],[_c(VGrid_["VCol"],{attrs:{"cols":"12","md":_vm.acl ? 6 : 12}},[_c(VTextField_["VTextField"],{ref:"title",attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.content.title')},model:{value:(_vm.editObject.title),callback:function ($$v) {_vm.$set(_vm.editObject, "title", $$v)},expression:"editObject.title"}}),_c(VTextField_["VTextField"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.content.filename')},model:{value:(_vm.editObject.filename),callback:function ($$v) {_vm.$set(_vm.editObject, "filename", $$v)},expression:"editObject.filename"}}),_c(VCombobox_["VCombobox"],{attrs:{"label":"Etiketter","items":_vm.tagOptions,"hide-selected":"","chips":"","small-chips":"","deletable-chips":"","multiple":""},model:{value:(_vm.selectedTags),callback:function ($$v) {_vm.selectedTags=$$v},expression:"selectedTags"}})],1),(_vm.acl)?_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"5","offset-md":"1"}},[_c(VRadioGroup_["VRadioGroup"],{staticClass:"mt-0",scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('label',{staticClass:"caption",domProps:{"textContent":_vm._s(_vm.$vuetify.lang.t('$vuetify.crm.content.access.label'))}})]},proxy:true}],null,false,423109213),model:{value:(_vm.editObject.access),callback:function ($$v) {_vm.$set(_vm.editObject, "access", $$v)},expression:"editObject.access"}},[(_vm.showAnonymous)?_c(VRadioGroup_["VRadio"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.content.access.anonymous'),"value":"ANONYMOUS"}}):_vm._e(),(_vm.showAuthenticated)?_c(VRadioGroup_["VRadio"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.content.access.authenticated'),"value":"AUTHENTICATED"}}):_vm._e(),(_vm.showPrivate)?_c(VRadioGroup_["VRadio"],{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.crm.content.access.private'),"value":"PRIVATE"}}):_vm._e()],1)],1):_vm._e()],1),(_vm.secure)?_c(VGrid_["VRow"],{attrs:{"dense":""}},[_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"6"}},[_c(VTextField_["VTextField"],{attrs:{"type":"password","label":_vm.$vuetify.lang.t('$vuetify.crm.content.password1')},model:{value:(_vm.editObject.password1),callback:function ($$v) {_vm.$set(_vm.editObject, "password1", $$v)},expression:"editObject.password1"}})],1),_c(VGrid_["VCol"],{attrs:{"cols":"12","md":"6"}},[_c(VTextField_["VTextField"],{attrs:{"type":"password","label":_vm.$vuetify.lang.t('$vuetify.crm.content.password2')},model:{value:(_vm.editObject.password2),callback:function ($$v) {_vm.$set(_vm.editObject, "password2", $$v)},expression:"editObject.password2"}})],1)],1):_vm._e()],1),_c(VCard_["VCardActions"],[_c(VGrid_["VSpacer"]),(false)?undefined:_vm._e(),_c(VBtn_["VBtn"],{attrs:{"type":"submit","color":"success"}},[_c(VIcon_["VIcon"],[_vm._v("$save")]),_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.crm.default.button.save'))+" ")],1),(_vm.editObject.id)?_c(VBtn_["VBtn"],{attrs:{"color":"error","outlined":""},on:{"click":_vm.remove}},[_c(VIcon_["VIcon"],[_vm._v("$delete")]),_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.crm.default.button.remove'))+" ")],1):_vm._e(),_c(VBtn_["VBtn"],{on:{"click":_vm.close}},[_c(VIcon_["VIcon"],[_vm._v("$close")]),_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.crm.default.button.close'))+" ")],1)],1)],1)],1)],1)}
var EditContentDialogvue_type_template_id_8ed08d22_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/EditContentDialog.vue?vue&type=template&id=8ed08d22&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/EditContentDialog.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-console, no-unused-vars */
/* harmony default export */ var EditContentDialogvue_type_script_lang_js_ = ({
  name: 'EditContentDialog',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    content: {
      type: Object
    },
    acl: {
      type: String
    }
  },
  data: function data() {
    return {
      editObject: {},
      valid: true,
      secure: false,
      selectedTags: []
    };
  },
  computed: {
    showAnonymous: function showAnonymous() {
      return this.acl && this.acl.includes('anonymous');
    },
    showAuthenticated: function showAuthenticated() {
      return this.acl && this.acl.includes('authenticated');
    },
    showPrivate: function showPrivate() {
      return this.acl && this.acl.includes('private');
    },
    tagOptions: function tagOptions() {
      return [];
    },
    dialogWidth: function dialogWidth() {
      return this.acl ? '720px' : '640px';
    }
  },
  methods: {
    showing: function showing() {
      var _this = this;

      this.editObject = Object.assign({}, this.content);
      this.selectedTags = this.editObject.tags || [];
      requestAnimationFrame(function () {
        return _this.$nextTick(_this.$refs.title.focus);
      });
    },
    save: function save() {
      if (this.$refs.form.validate()) {
        this.$emit('update', _objectSpread2(_objectSpread2({}, this.editObject), {}, {
          tags: this.selectedTags
        }));
      }
    },
    remove: function remove() {
      this.$emit('delete', this.editObject);
    },
    close: function close() {
      this.$emit('close');
    }
  },
  watch: {
    visible: function visible(state) {
      if (state) {
        this.showing();
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/EditContentDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_EditContentDialogvue_type_script_lang_js_ = (EditContentDialogvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/EditContentDialog.vue





/* normalize component */

var EditContentDialog_component = normalizeComponent(
  components_EditContentDialogvue_type_script_lang_js_,
  EditContentDialogvue_type_template_id_8ed08d22_render,
  EditContentDialogvue_type_template_id_8ed08d22_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var EditContentDialog = (EditContentDialog_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/CrmContactView.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ var CrmContactViewvue_type_script_lang_js_ = ({
  name: "CrmContactView",
  components: {
    EditContentDialog: EditContentDialog,
    AddCompanyDialog: AddCompanyDialog,
    AddPersonDialog: AddPersonDialog,
    CrmContactRelationEdit: CrmContactRelationEdit,
    CrmContactRelationMenu: CrmContactRelationMenu,
    CrmContactContentMenu: CrmContactContentMenu,
    CrmContactMenu: CrmContactMenu,
    NameAndAddressForm: NameAndAddressForm,
    CrmContactContentPanel: CrmContactContentPanel,
    CrmContactContentToolbar: CrmContactContentToolbar,
    CrmContactRelationPanel: CrmContactRelationPanel,
    CrmContactRelationToolbar: CrmContactRelationToolbar,
    CrmContactPanel: CrmContactPanel,
    CrmContactToolbar: CrmContactToolbar
  },
  data: function data() {
    return {
      topExpanded: true,
      relationsExpanded: true,
      detailsExpanded: false,
      contentExpanded: false,
      addressDialog: false,
      confirmDelete: false,
      exportDialog: false,
      identifier: null,
      favorite: false,
      contact: {},
      relations: [],
      related: [],
      selectedRelation: null,
      addCompany: false,
      addPerson: false,
      searchResult: [],
      files: [],
      thumbnails: false,
      selectedContent: null,
      confirmDeleteContent: false,
      tagOptions: [],
      permissions: {
        create: true,
        read: true,
        update: true,
        delete: true
      }
    };
  },
  computed: {
    target: function target() {
      return 'crmContact@' + this.identifier;
    },
    filePath: function filePath() {
      return 'contact/' + this.identifier;
    },
    genderOptions: function genderOptions() {
      return this.$store.getters.genderOptions || [{
        text: '',
        value: null
      }, {
        text: 'Man',
        value: 'male'
      }, {
        text: 'Kvinna',
        value: 'female'
      }];
    }
  },
  methods: {
    mapIcon: function mapIcon(type) {
      return this.$store.getters['contact/getTypeIcon'](type);
    },
    fetchData: function fetchData(id) {
      return this.fetchContact(id);
    },
    fetchContact: function fetchContact(id) {
      var _this = this;

      return this.$store.dispatch('contact/fetchContact', id).then(function (contact) {
        _this.contact = contact;

        _this.$store.dispatch('breadcrumbs', [{
          text: 'Kontakter',
          to: '/contact'
        }, {
          text: contact.name,
          to: '/contact/show/' + contact.id
        }], {
          root: true
        });

        var tenant = _this.$crm.tenant;
        var payload = {
          id: contact.id,
          icon: _this.mapIcon(contact.type),
          domain: 'contact',
          type: contact.type,
          text: contact.name,
          to: {
            name: 'crm-contact-show',
            params: {
              tenant: tenant,
              id: contact.id
            }
          }
        };

        _this.$store.dispatch('history', payload, {
          root: true
        }).then(function () {
          return _this.$store.dispatch('isFavorite', 'crmContact@' + contact.id, {
            root: true
          });
        }).then(function (state) {
          return _this.favorite = state;
        });

        return contact;
      }).then(function (contact) {
        return _this.fetchRelations(contact.id);
      }).then(function () {
        return _this.$store.dispatch('contact/getContactTags');
      }).then(function (result) {
        return _this.tagOptions = result.items;
      }).then(this.fetchFiles).catch(function (err) {
        return console.error(err);
      });
    },
    fetchRelations: function fetchRelations(id) {
      var _this2 = this;

      this.$store.dispatch('contact/fetchContactRelations', id).then(function (_ref) {
        var from = _ref.from,
            to = _ref.to;
        _this2.relations = from;
        _this2.related = to;
        return {
          from: from,
          to: to
        };
      });
    },
    fetchFiles: function fetchFiles() {
      var _this3 = this;

      return this.$store.dispatch('content/fetchContent', this.filePath).then(function (files) {
        return _this3.files = files;
      });
    },
    toggleFavorite: function toggleFavorite() {
      var _this4 = this;

      this.$store.dispatch('toggleFavorite', this.target, {
        root: true
      }).then(function (state) {
        return _this4.favorite = state;
      });
    },
    closeAddressDialog: function closeAddressDialog(save, data) {
      var _this5 = this;

      if (save) {
        var copy = _objectSpread2(_objectSpread2({}, this.contact), data);

        this.$store.dispatch('contact/saveContact', {
          id: this.contact.id,
          contact: copy
        }).then(function (saved) {
          _this5.contact = saved;
          _this5.addressDialog = false;
        }).catch(function (err) {
          return console.error(err);
        });
      } else {
        this.addressDialog = false;
      }
    },
    deleteContact: function deleteContact() {
      var _this6 = this;

      this.$store.dispatch('contact/deleteContact', this.identifier).then(function (contact) {
        return _this6.$eventBus.$emit('crm-contact-deleted', {
          contact: contact
        });
      }).then(function () {
        return _this6.confirmDelete = false;
      }).then(function () {
        return _this6.$store.dispatch('message', {
          subject: 'Kontakten raderad'
        });
      }, {
        root: true
      }).then(function () {
        return _this6.$router.replace({
          name: 'crm-contact-list'
        });
      });
    },
    addRelation: function addRelation(type) {
      if (type === 'person') {
        this.addCompany = false;
        this.addPerson = true;
      } else {
        this.addPerson = false;
        this.addCompany = true;
      }
    },
    saveRelation: function saveRelation(relation) {
      if (relation.id) {
        this.updateRelation(relation);
      } else {
        this.doAddRelation(relation);
      }
    },
    doAddRelation: function doAddRelation(relation) {
      var _this7 = this;

      this.$store.dispatch('contact/addRelation', {
        id: this.contact.id,
        relation: relation
      }).then(function (contact) {
        return _this7.contact = contact;
      }).then(function (contact) {
        return _this7.$store.dispatch('contact/fetchContactRelations', contact.id);
      }).then(function (_ref2) {
        var from = _ref2.from,
            to = _ref2.to;
        _this7.relations = from;
        _this7.related = to;
      }).catch(function (err) {
        return console.error(err);
      });
    },
    updateRelation: function updateRelation(relation) {
      var _this8 = this;

      this.$store.dispatch('contact/updateRelation', {
        id: this.contact.id,
        relation: relation
      }).then(function (contact) {
        return _this8.contact = contact;
      }).then(function (contact) {
        return _this8.$store.dispatch('contact/fetchContactRelations', contact.id);
      }).then(function (_ref3) {
        var from = _ref3.from,
            to = _ref3.to;
        _this8.relations = from;
        _this8.related = to;
        _this8.selectedRelation = null;
      }).catch(function (err) {
        return console.error(err);
      });
    },
    removeRelation: function removeRelation(relation) {
      var _this9 = this;

      this.$store.dispatch('contact/removeRelation', {
        id: this.contact.id,
        relation: relation
      }).then(function (contact) {
        return _this9.contact = contact;
      }).then(function (contact) {
        return _this9.$store.dispatch('contact/fetchContactRelations', contact.id);
      }).then(function (_ref4) {
        var from = _ref4.from,
            to = _ref4.to;
        _this9.relations = from;
        _this9.related = to;
        _this9.selectedRelation = null;
      }).catch(function (err) {
        return console.error(err);
      });
    },
    onSearchCompany: function onSearchCompany(value) {
      var _this10 = this;

      if (value && value.length > 2) {
        this.$store.dispatch('contact/queryContact', this.contactQuery(value, 'company')).then(function (result) {
          return _this10.searchResult = result.items;
        }).catch(function (err) {
          return console.error(err);
        });
      } else {
        this.searchResult = [];
      }
    },
    onSearchPerson: function onSearchPerson(value) {
      var _this11 = this;

      if (value && value.length > 2) {
        this.$store.dispatch('contact/queryContact', this.contactQuery(value, 'person', this.selectedCompany && this.selectedCompany.id)).then(function (result) {
          return _this11.searchResult = result.items;
        }).catch(function (err) {
          return console.error(err);
        });
      } else {
        this.searchResult = [];
      }
    },
    onSelectCompany: function onSelectCompany(params) {
      var _this12 = this;

      var relation = {
        contactId: params.id,
        name: params.name,
        notes: params.notes,
        primary: params.primary
      };
      this.$store.dispatch('contact/addRelation', {
        id: this.contact.id,
        relation: relation
      }).then(function () {
        return _this12.addCompany = false;
      }) //this.$router.push({ name: 'crm-contact-show', params: { tenant: contact.tenant, id: contact.id }})
      .then(function () {
        return _this12.fetchRelations(_this12.contact.id);
      }).catch(function (err) {
        return console.error(err);
      });
    },
    onSelectPerson: function onSelectPerson(params) {
      var _this13 = this;

      var relation = {
        contactId: params.id,
        name: params.name,
        notes: params.notes,
        primary: params.primary
      };
      this.$store.dispatch('contact/addRelation', {
        id: this.contact.id,
        relation: relation
      }).then(function () {
        return _this13.addPerson = false;
      }) //this.$router.push({ name: 'crm-contact-show', params: { tenant: contact.tenant, id: contact.id }})
      .then(function () {
        return _this13.fetchRelations(_this13.contact.id);
      }).catch(function (err) {
        return console.error(err);
      });
    },
    saveCompany: function saveCompany(company) {
      var _this14 = this;

      this.$store.dispatch('contact/createContact', {
        contact: company
      }).then(function (created) {
        _this14.$eventBus.$emit('crm-contact-created', {
          contact: created
        });

        _this14.onSelectCompany({
          id: created.id,
          name: created.name,
          notes: company.notes,
          primary: company.primary
        });
      }).catch(function (err) {
        return console.error(err);
      });
    },
    savePerson: function savePerson(person) {
      var _this15 = this;

      this.$store.dispatch('contact/createContact', {
        contact: person
      }).then(function (created) {
        _this15.$eventBus.$emit('crm-contact-created', {
          contact: created
        });

        _this15.onSelectPerson({
          id: created.id,
          name: created.name,
          notes: person.notes,
          primary: person.primary
        });
      }).catch(function (err) {
        return console.error(err);
      });
    },
    contactQuery: function contactQuery(input, type, primaryId) {
      var query = 'query{\ncontacts(';

      if (type) {
        query += 'type: "';
        query += type;
        query += '"';
      }

      if (input) {
        if (type) {
          query += ', ';
        }

        query += 'name: "';
        query += input;
        query += '"';
      }

      if (primaryId) {
        if (type || input) {
          query += ', ';
        }

        query += 'primary: "';
        query += primaryId;
        query += '"'; // query += ', first: 25, offset: 0'
      }

      query += ')\n{\nid\ntype\nname\nfirstName\nlastName\nemail\ntelephone\naddress\npostalAddress { value address postalCode city region country }\nprimaryRelation { name }\n}\n}';
      return query;
    },
    toggleThumbnails: function toggleThumbnails(state) {
      if (!this.contentExpanded) {
        this.contentExpanded = true;
      }

      this.thumbnails = state;
    },
    upload: function upload(files) {
      var _this16 = this;

      return this.$store.dispatch('content/uploadContent', {
        path: this.filePath,
        files: files
      }).then(function () {
        return _this16.fetchFiles();
      }).catch(function (err) {
        return console.error(err);
      });
    },
    openContent: function openContent(item) {
      this.$store.dispatch('content/openContent', item).catch(function (err) {
        return console.error(err);
      });
    },
    saveContent: function saveContent(item) {
      var _this17 = this;

      this.$store.dispatch('content/saveContent', {
        path: item.id || item.path,
        data: item
      }).then(this.selectedContent = null).then(function () {
        return _this17.fetchFiles(_this17.identifier);
      }).catch(console.error);
    },
    deleteContent: function deleteContent(item) {
      var _this18 = this;

      this.$store.dispatch('content/deleteContent', item.id || item.path).then(function () {
        return _this18.$store.dispatch('message', {
          subject: 'Filen raderad',
          color: 'warning',
          timeout: 2000
        });
      }).then(this.confirmDeleteContent = null).then(this.selectedContent = null).then(function () {
        return _this18.fetchFiles(_this18.identifier);
      }).catch(console.error);
    }
  },
  created: function created() {
    this.identifier = this.$route.params.id || '0';
    this.fetchData(this.identifier);
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.identifier = to.params.id;
    this.fetchData(this.identifier).then(function () {
      return next();
    });
  }
});
// CONCATENATED MODULE: ./src/views/CrmContactView.vue?vue&type=script&lang=js&
 /* harmony default export */ var views_CrmContactViewvue_type_script_lang_js_ = (CrmContactViewvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/views/CrmContactView.vue





/* normalize component */

var CrmContactView_component = normalizeComponent(
  views_CrmContactViewvue_type_script_lang_js_,
  CrmContactViewvue_type_template_id_29323e8a_render,
  CrmContactViewvue_type_template_id_29323e8a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactView = (CrmContactView_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb4abe34-vue-loader-template"}!./node_modules/vuetify-loader/lib/loader.js??ref--4!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/CrmContactImport.vue?vue&type=template&id=06f0534c&

















var CrmContactImportvue_type_template_id_06f0534c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VGrid_["VContainer"],{attrs:{"fluid":""}},[_c(VToolbar_["VToolbar"],{attrs:{"color":"primary","dark":"","dense":""}},[_c(VToolbar_["VToolbarTitle"],[_c(VIcon_["VIcon"],{domProps:{"textContent":_vm._s(_vm.$route.meta.icon)}}),_vm._v(" "+_vm._s(_vm.$route.meta.title)+" ")],1),_c(VGrid_["VSpacer"]),_c(VMenu_["VMenu"],{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VBtn_["VBtn"],_vm._g({attrs:{"icon":"","text":""}},on),[_c(VIcon_["VIcon"],[_vm._v("more_vert")])],1)]}}])},[_c(VList_["VList"],[_c(VList_["VListItem"],[_c(VList_["VListItemIcon"],[_c(VIcon_["VIcon"],[_vm._v("$upload")])],1),_c(VList_["VListItemContent"],[_c(VList_["VListItemTitle"],[_vm._v("...")])],1)],1)],1)],1)],1),_c(VGrid_["VContainer"],{attrs:{"fluid":""}},[_c('crm-upload-content',{attrs:{"files":_vm.files,"upload":_vm.isAdmin,"accept":".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"},on:{"click":_vm.selectContent,"upload":_vm.upload},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var file = ref.file;
var hover = ref.hover;
return [_c(VImg_["VImg"],{attrs:{"src":_vm.getThumbnailUrl(file.id),"alt":file.title,"title":file.title}}),_c('div',{staticClass:"caption px-1 text-center crm-filename"},[_vm._v(_vm._s(file.title))]),_c(VBtn_["VBtn"],{directives:[{name:"show",rawName:"v-show",value:(hover),expression:"hover"}],staticStyle:{"margin-left":"auto","margin-right":"auto","left":"0","right":"0","margin-top":"auto","margin-bottom":"auto","top":"0","bottom":"0"},attrs:{"fab":"","dark":"","width":"56","height":"40","color":"blue darken-1","absolute":""},on:{"click":function($event){$event.stopPropagation();return _vm.openContent(file)}}},[_c(VIcon_["VIcon"],{attrs:{"large":""}},[_vm._v("mdi-eye")])],1),_c(VBtn_["VBtn"],{directives:[{name:"show",rawName:"v-show",value:(hover),expression:"hover"}],staticClass:"mt-2",staticStyle:{"margin-left":"-8px"},attrs:{"fab":"","dark":"","x-small":"","color":"warning","absolute":"","top":"","left":""},on:{"click":function($event){$event.stopPropagation();return _vm.editContent(file)}}},[_c(VIcon_["VIcon"],[_vm._v("$edit")])],1)]}}])})],1),(_vm.selectedFile)?_c(VToolbar_["VToolbar"],{attrs:{"dense":"","elevation":"2"}},[_c(VToolbar_["VToolbarTitle"],[_vm._v(" "+_vm._s(_vm.selectedFile.title)+" "),(_vm.sample)?_c('sup',{staticClass:"caption"},[_vm._v("("+_vm._s(_vm.sample.size)+" poster)")]):_vm._e()]),_c(VGrid_["VSpacer"]),_c(VToolbar_["VToolbarItems"],[_c(VBtn_["VBtn"],{attrs:{"text":"","color":"red"},on:{"click":function($event){_vm.confirmStartImport = true}}},[_vm._v(" Starta import ")])],1)],1):_vm._e(),(_vm.headers.length)?_c(VDataTable_["VDataTable"],{attrs:{"headers":_vm.headers,"items":_vm.rows,"search":_vm.search,"items-per-page":_vm.itemsPerPage,"footer-props":{ itemsPerPageOptions: _vm.$store.getters.itemsPerPageOptions },"sort-by":_vm.sortBy,"item-class":_vm.itemClass},on:{"update:itemsPerPage":function($event){_vm.itemsPerPage=$event},"update:items-per-page":function($event){_vm.itemsPerPage=$event},"update:sortBy":function($event){_vm.sortBy=$event},"update:sort-by":function($event){_vm.sortBy=$event},"click:row":_vm.selectRow},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c(VTextField_["VTextField"],{staticClass:"ml-3",attrs:{"prepend-icon":"search","single-line":"","clearable":"","hide-details":"","solo":"","flat":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})]},proxy:true}],null,false,2941109270)}):_vm._e(),_c('crm-content-edit-dialog',{attrs:{"visible":!!_vm.editContentModel,"content":_vm.editContentModel},on:{"content:update":_vm.saveContent,"content:delete":function($event){_vm.confirmDeleteContent = $event},"close":function($event){_vm.editContentModel = null}}}),_c('crm-confirm-dialog',{attrs:{"visible":_vm.confirmStartImport,"color":"warning","title":"Bekräfta start av import","text":("Jag har verifierat att förhandsgranskningen av Excelfilen visas korrekt i tabellen och är redo att starta importen av " + (_vm.sample && _vm.sample.size) + " poster.")},on:{"confirm":_vm.startImport,"cancel":function($event){_vm.confirmStartImport = false}}}),_c('crm-confirm-dialog',{attrs:{"visible":!!_vm.confirmDeleteContent,"color":"error","title":"Bekräfta borttag","text":("Vill du verkligen ta bort filen " + (_vm.confirmDeleteContent && _vm.confirmDeleteContent.title) + "?")},on:{"confirm":function($event){return _vm.deleteContent(_vm.confirmDeleteContent)},"cancel":function($event){_vm.confirmDeleteContent = null}}})],1)}
var CrmContactImportvue_type_template_id_06f0534c_staticRenderFns = []


// CONCATENATED MODULE: ./src/views/CrmContactImport.vue?vue&type=template&id=06f0534c&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/views/CrmContactImport.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var CrmContactImportvue_type_script_lang_js_tableState = {
  sortBy: null,
  itemsPerPage: 25
};
/* harmony default export */ var CrmContactImportvue_type_script_lang_js_ = ({
  name: 'CrmContactImport',
  data: function data() {
    return {
      headers: [{
        text: 'Nummer',
        value: 'number'
      }, {
        text: 'Företag',
        value: 'companyName'
      }, {
        text: 'Förnamn',
        value: 'firstName'
      }, {
        text: 'Efternamn',
        value: 'lastName'
      }, {
        text: 'Titel',
        value: 'title'
      }, {
        text: 'Telefon',
        value: 'phone'
      }, {
        text: 'E-post',
        value: 'email'
      }, {
        text: 'Hemsida',
        value: 'website'
      }, {
        text: 'Adress',
        value: 'address'
      }, {
        text: 'Postnr',
        value: 'postalCode'
      }, {
        text: 'Ort',
        value: 'city'
      }, {
        text: 'Land',
        value: 'country'
      }, {
        text: 'Beskrivning',
        value: 'description'
      }, {
        text: 'Källa',
        value: 'origin'
      }, {
        text: 'Reserverad',
        value: 'reserved'
      }, {
        text: 'Etiketter',
        value: 'tags'
      }],
      files: [],
      items: [],
      excluded: [],
      selectedFile: null,
      selectedRow: null,
      search: null,
      skipFirst: true,
      importFile: null,
      sample: null,
      editContentModel: null,
      confirmStartImport: false,
      confirmDeleteContent: null
    };
  },
  computed: {
    sortBy: {
      get: function get() {
        return CrmContactImportvue_type_script_lang_js_tableState.sortBy;
      },
      set: function set(n) {
        CrmContactImportvue_type_script_lang_js_tableState.sortBy = n;
      }
    },
    itemsPerPage: {
      get: function get() {
        return CrmContactImportvue_type_script_lang_js_tableState.itemsPerPage;
      },
      set: function set(n) {
        CrmContactImportvue_type_script_lang_js_tableState.itemsPerPage = n;
      }
    },
    basePath: function basePath() {
      return 'contact/import/files';
    },
    isAdmin: function isAdmin() {
      return this.$store.getters['account/isAdmin'];
    },
    columns: function columns() {
      var _this$sample;

      var list = ((_this$sample = this.sample) === null || _this$sample === void 0 ? void 0 : _this$sample.headers) || [];
      return list.map(function (entry) {
        return {
          text: entry,
          value: entry
        };
      });
    },
    rows: function rows() {
      var _this$sample2;

      var headers = this.headers;
      var cols = this.columns;

      var mapper = function mapper(entry) {
        var row = {};

        for (var i = 0; i < headers.length; i++) {
          var _cols$i;

          var hdr = headers[i].value;
          var col = (_cols$i = cols[i]) === null || _cols$i === void 0 ? void 0 : _cols$i.value;
          row[hdr] = entry[col];
        }

        return row;
      };

      var list = ((_this$sample2 = this.sample) === null || _this$sample2 === void 0 ? void 0 : _this$sample2.rows) || [];
      return list.map(function (entry) {
        return mapper(entry.columns);
      });
    }
  },
  methods: {
    fetchContent: function fetchContent() {
      var _this = this;

      var path = this.basePath;

      if (path) {
        return this.$store.dispatch('content/fetchContent', path).then(function (files) {
          return _this.files = files;
        });
      }

      return Promise.resolve();
    },
    itemClass: function itemClass(item) {
      return null;
    },
    getThumbnailUrl: function getThumbnailUrl(id) {
      return "".concat(this.$store.getters.apiUrl, "/").concat(this.$crm.tenant, "/v1/content/assets/").concat(id, "?variant=thumbnail");
    },
    upload: function upload(files) {
      var path = this.basePath;
      return this.$store.dispatch('content/uploadContent', {
        path: path,
        files: files
      }).then(this.fetchContent).catch(console.error);
    },
    selectContent: function selectContent(item) {
      var _this2 = this;

      this.selectedFile = item;
      return this.$store.dispatch('contact/analyzeContactImport', item).then(function (sample) {
        return _this2.sample = sample;
      }).catch(console.error);
    },
    openContent: function openContent(file) {
      this.$store.dispatch('content/openContent', file).catch(console.error);
    },
    editContent: function editContent(file) {
      this.editContentModel = file;
    },
    saveContent: function saveContent(item) {
      this.$store.dispatch('content/saveContent', {
        path: item.id || item.path,
        data: item
      }).then(this.editContentModel = null).then(this.fetchContent).catch(console.error);
    },
    deleteContent: function deleteContent(item) {
      var _this3 = this;

      this.$store.dispatch('content/deleteContent', item.id || item.path).then(function () {
        return _this3.$store.dispatch('message', {
          subject: 'Filen raderad',
          color: 'warning',
          timeout: 2000
        });
      }).then(this.confirmDeleteContent = null).then(this.editContentModel = null).then(this.fetchContent).catch(console.error);
    },
    selectRow: function selectRow(item) {
      this.selectedRow = item;
    },
    startImport: function startImport() {
      var _this4 = this;

      var payload = {
        group: 'crm-contact',
        name: '',
        skip: 0,
        records: -1
      };
      return this.$store.dispatch('contact/startContactImport', {
        id: this.selectedFile.id,
        data: payload
      }).then(function (result) {
        return _this4.$store.dispatch('message', {
          subject: "".concat(result.records, " st rader importerades")
        });
      }).then(function () {
        return _this4.confirmStartImport = false;
      }).catch(function (err) {
        return console.error(err);
      });
    }
  },
  created: function created() {
    this.fetchContent();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.fetchContent().then(next);
  }
});
// CONCATENATED MODULE: ./src/views/CrmContactImport.vue?vue&type=script&lang=js&
 /* harmony default export */ var views_CrmContactImportvue_type_script_lang_js_ = (CrmContactImportvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/views/CrmContactImport.vue





/* normalize component */

var CrmContactImport_component = normalizeComponent(
  views_CrmContactImportvue_type_script_lang_js_,
  CrmContactImportvue_type_template_id_06f0534c_render,
  CrmContactImportvue_type_template_id_06f0534c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CrmContactImport = (CrmContactImport_component.exports);
// CONCATENATED MODULE: ./src/routes.js




/* harmony default export */ var routes = ([{
  path: '/:tenant/contact',
  name: 'crm-contact-list',
  component: CrmContactListView,
  meta: {
    title: 'crm.contact.list.label',
    icon: '$person',
    tenant: true,
    menu: true
  }
}, {
  path: '/:tenant/contact/create',
  name: 'crm-contact-create',
  component: CrmContactCreateView,
  meta: {
    title: 'crm.contact.create.label',
    icon: '$person',
    tenant: true
  }
}, {
  path: '/:tenant/contact/show/:id',
  name: 'crm-contact-show',
  component: CrmContactView,
  meta: {
    title: 'crm.contact.show.label',
    icon: '$person',
    tenant: true
  }
}, {
  path: '/:tenant/contact/import',
  name: 'crm-contact-import',
  component: CrmContactImport,
  meta: {
    title: 'Importera kontakter',
    icon: 'mdi-import',
    tenant: true,
    admin: true
  }
}]);
// CONCATENATED MODULE: ./src/locale/en.js
/* harmony default export */ var en = ({
  dataIterator: {
    pageText: '{0}-{1} of {2}',
    noResultsText: 'No matching records found',
    loadingText: 'Loading items...'
  },
  dataTable: {
    itemsPerPageText: 'Rows per page:',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.'
    },
    sortBy: 'Sort by'
  },
  dataFooter: {
    itemsPerPageText: 'Items per page:',
    itemsPerPageAll: 'All',
    nextPage: 'Next page',
    prevPage: 'Previous page',
    firstPage: 'First page',
    lastPage: 'Last page'
  },
  noDataText: 'No data available',
  crm: {
    default: {
      button: {
        save: 'Save',
        remove: 'Remove',
        add: 'Add',
        close: 'Close',
        cancel: 'Cancel',
        ok: 'Ok',
        search: 'Search'
      }
    },
    tags: {
      label: 'Tags',
      title: 'Tags'
    },
    contact: {
      name: 'Name',
      firstName: 'Firstname',
      middleName: 'Middlename',
      lastName: 'Lastname',
      email: 'Email',
      phone: 'Phone',
      title: 'Title',
      sex: 'Sex',
      number: 'Customer Id',
      description: 'Description',
      origin: 'Origin',
      address: {
        address: 'Address',
        postalCode: 'Postal Code',
        city: 'City'
      },
      relations: {
        title: 'Relations',
        primary: 'Primary relation',
        to: 'Relation to',
        notes: 'Notes',
        search: {
          employer: 'Employer',
          hint: 'Type to search'
        }
      },
      files: {
        label: 'Files'
      },
      avatar: {
        upload: 'Select picture...'
      },
      type: {
        company: 'Company',
        person: 'Person'
      },
      button: {
        add: 'New Contact'
      },
      show: {
        label: 'Show Contact',
        contactInfo: 'Contact information',
        facts: 'Facts',
        summary: 'Summary'
      },
      list: {
        label: 'Contacts',
        title: 'Contacts'
      },
      add: {
        title: 'Add new contact'
      },
      edit: {
        title: 'Edit contact information'
      }
    },
    content: {
      list: {
        filesTitle: 'Files',
        action: ''
      },
      edit: {
        title: 'Edit file'
      },
      upload: {
        select: 'Select files'
      },
      title: 'Title',
      filename: 'Filename',
      length: 'Size',
      timeModified: 'Modified',
      password1: 'Password 1',
      password2: 'Password 2'
    }
  }
});
// CONCATENATED MODULE: ./src/locale/sv.js
/* harmony default export */ var sv = ({
  dataIterator: {
    pageText: '{0}-{1} av {2}',
    noResultsText: 'Inga poster funna',
    loadingText: 'Laddar data...'
  },
  dataTable: {
    itemsPerPageText: 'Rader per sida:',
    ariaLabel: {
      sortDescending: ': Sorterat fallande. Aktivera för att ta bort sortering.',
      sortAscending: ': Sorterat stigande. Aktivera för sortering fallande.',
      sortNone: ': Osorterat. Aktivera för sortering stigande.'
    },
    sortBy: 'Sortera på'
  },
  dataFooter: {
    itemsPerPageText: 'Objekt per sida:',
    itemsPerPageAll: 'Alla',
    nextPage: 'Nästa sida',
    prevPage: 'Föregående sida',
    firstPage: 'Första sidan',
    lastPage: 'Sista sidan'
  },
  noDataText: 'Ingen data',
  app: {
    home: 'Hem',
    admin: 'Administration',
    menu: {
      modules: 'Moduler',
      history: 'Historik'
    }
  },
  Test: 'TEST',
  crm: {
    default: {
      button: {
        save: 'Spara',
        delete: 'Ta bort',
        add: 'Lägg till',
        close: 'Stäng',
        cancel: 'Avbryt',
        ok: 'Ok',
        search: 'Sök',
        more: 'Mer...',
        confirm: 'Bekräfta'
      }
    },
    tags: {
      label: 'Taggar',
      title: 'Taggar'
    },
    contact: {
      name: 'Namn',
      companyName: 'Företagsnamn',
      firstName: 'Förnamn',
      middleName: 'Mellannamn',
      lastName: 'Efternamn',
      email: 'E-post',
      phone: 'Telefon',
      telephone: 'Telefon',
      title: 'Titel',
      sex: 'Kön',
      number: 'Kundnummer',
      description: 'Beskrivning',
      origin: 'Källa',
      address: {
        address: 'Adress',
        postalCode: 'Postnummer',
        city: 'Ort',
        region: 'Region/stat',
        country: 'Land'
      },
      postal: 'Postadress',
      visit: 'Besöksadress',
      delivery: 'Leveransadress',
      invoice: 'Fakturaadress',
      web: 'Hemsida',
      website: 'Hemsida',
      social: 'Social',
      internet: 'Internet',
      twitter: 'Twitter',
      facebook: 'Facebook',
      instagram: 'Instagram',
      linkedin: 'LinkedIn',
      facts: {
        edit: 'Redigera fakta'
      },
      tags: {
        label: 'Etiketter'
      },
      relations: {
        title: 'Relationer',
        primary: 'Primär relation',
        to: 'Relation till',
        notes: 'Notering',
        search: {
          employer: 'Arbetsgivare',
          hint: 'Börja skriva för att söka',
          type: 'Välp typ av relation'
        }
      },
      files: {
        label: 'Filer'
      },
      avatar: {
        upload: 'Välj bild...'
      },
      type: {
        company: 'Företag',
        person: 'Person'
      },
      button: {
        add: 'Ny kontakt'
      },
      show: {
        label: 'Visa kontakt',
        contactInfo: 'Kontaktuppgifter',
        facts: 'Fakta'
      },
      list: {
        label: 'Kontakter',
        title: 'Kontakter'
      },
      add: {
        title: 'Registrera ny kontakt'
      },
      create: {
        label: 'Registrera ny kontakt',
        title: 'Registrera ny kontakt',
        company: {
          title: 'Registrera nytt företag'
        },
        person: {
          title: 'Registrera ny person'
        }
      },
      edit: {
        title: 'Redigera kontaktuppgifter'
      },
      search: {
        title: 'Sök kontakt',
        addContact: 'Ny kontakt',
        searchHint: 'Sök på person- eller företags-namn',
        nameOrAddress: 'Sök namn eller adress'
      },
      company: {
        relations: {
          title: 'Relaterade kontakter'
        }
      },
      person: {
        relations: {
          title: 'Relaterade kontakter'
        }
      },
      summary: {
        title: 'Sammanfattning'
      }
    },
    content: {
      list: {
        filesTitle: 'Filer',
        action: ''
      },
      edit: {
        title: 'Redigera fil'
      },
      upload: {
        select: 'Välj fil(er)'
      },
      filename: 'Filnamn',
      title: 'Titel',
      length: 'Storlek',
      timeModified: 'Ändrad',
      password1: 'Lösenord',
      password2: 'Upprepa lösenord'
    }
  }
});
// CONCATENATED MODULE: ./src/plugin.js












var locale = {
  en: en,
  sv: sv
};
/* harmony default export */ var src_plugin = ({
  install: function install(Vue, _ref) {
    var store = _ref.store,
        router = _ref.router;
    Vue.component('CrmAddressFields', CrmAddressFields);
    Vue.component('CrmContactInformation', CrmContactInformation);
    Vue.component('AddContactDialog', AddContactDialog);

    if (store) {
      store.registerModule('contact', src_store);
    }

    if (router) {
      router.addRoutes(routes);
    }
  }
});

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_plugin);



/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fce3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});


/***/ }),

/***/ "fd34":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VSwitch");

/***/ }),

/***/ "fdbc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("04f8");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "ffda":
/***/ (function(module, exports) {

module.exports = require("vuetify/lib/components/VDivider");

/***/ })

/******/ });
//# sourceMappingURL=vue-gr8crm-contact.common.js.map